/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "www";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var ee = __webpack_require__(2);
	var moment = window.moment;
	var underscore = window.underscore;
	angular.module("app", ["ngResource", "ngSanitize", "ui.router", "angular-storage", "angular-jwt", "angucomplete-alt", "contentful", "ui.bootstrap", "angularUtils.directives.dirPagination", "hc.marked", "slugifier", "720kb.socialshare"]).constant("ee", ee).constant("moment", moment).constant("underscore", underscore).config(["$urlRouterProvider", "$stateProvider", "contentfulProvider", "$locationProvider", "$compileProvider", function ($urlRouterProvider, $stateProvider, contentfulProvider, $locationProvider, $compileProvider) {
	  // Performance improvement/cleaner markup
	  // https://medium.com/swlh/improving-angular-performance-with-1-line-of-code-a1fb814a6476
	  $compileProvider.debugInfoEnabled(false);
	  // Contentful configs
	  contentfulProvider.setOptions({
	    space: "p7m0y70d37w2",
	    accessToken: "cc5527d6c7d2d45d7fe2e1d49d22e3b8cde431a5105f0883c28885a9ec2e7553"
	  });
	  $urlRouterProvider.otherwise("/");
	  $stateProvider.state("site", __webpack_require__(48)).state("site.home", __webpack_require__(50)).state("site.amenities", __webpack_require__(52)).state("site.activities", __webpack_require__(54)).state("site.rooms", __webpack_require__(56)).state("site.meetings-and-events", __webpack_require__(58)).state("site.weddings", __webpack_require__(60)).state("site.versante", __webpack_require__(62)).state("site.versante/menu", __webpack_require__(64)).state("site.galleries", __webpack_require__(66)).state("site.employment", __webpack_require__(68)).state("site.peaks-picks", __webpack_require__(70)).state("site.contact", __webpack_require__(72)).state("site.offers", __webpack_require__(74)).state("site.offer", __webpack_require__(76));
	
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	}]).directive("navFooter", __webpack_require__(78)).directive("navHeader", __webpack_require__(80));
	
	jQuery.noConflict();
	jQuery(document).ready(function ($) {
	  setTimeout(function () {
	    $("#myModal").modal("handleUpdate");
	    // $('label').on('click', function (e) {
	    //   console.log(e);
	    // });
	  });
	
	  setTimeout(function () {
	    $(".close-pop").click(function () {
	      $(".overlay-pop").addClass("overlay-hide");
	      $("body").removeClass("position-fixed");
	    });
	    $(".overlay-pop-bg").click(function () {
	      $(".overlay-pop").addClass("overlay-hide");
	      $("body").removeClass("position-fixed");
	    });
	  }, 4500);
	  //   setTimeout(function () {
	  //     $("body").addClass("position-fixed");
	  //     if ($(".overlay-pop").hasClass("overlay-hide")) {
	  //       $("body").removeClass("position-fixed");
	  //     }
	  //   }, 4000);
	
	  // setTimeout(function(){$('#ToggleAnnouncement').modal('show'); }, 3000);
	  $(".modal .fade").click(function (event) {
	    $(".modal .fade").collapse("hide");
	  });
	  $(".modal .fade .modal-dialog").click(function (event) {
	    $(".modal .fade").collapse("hide");
	  });
	  $(".navbar-nav li a").click(function (event) {
	    $(".navbar-collapse").collapse("hide");
	    $("body").removeClass("position-fixed");
	  });
	
	  $(".close-this").click(function (event) {
	    $(".navbar-collapse").collapse("hide");
	  });
	  $(".mobile-booking").click(function (event) {
	    $("body").addClass("position-fixed");
	  });
	  $(".toggler").click(function (event) {
	    $("body").removeClass("position-fixed");
	  });
	  $(".mobile-specials").click(function (event) {
	    location.href = "/offers";
	    // $('body').addClass("position-fixed");
	  });
	
	  $("#in").datepicker({
	    showButtonPanel: true,
	    showAnim: "clip",
	    showOn: "both",
	    buttonText: "<i class='fa fa-th' style='color: #164c65;'></i>"
	  });
	  $("#out").datepicker({
	    showButtonPanel: true,
	    showAnim: "clip",
	    showOn: "both",
	    buttonText: "<i class='fa fa-th' style='color: #164c65;' ></i>"
	  });
	  var dayObj;
	  var checkIn;
	  var inMonth;
	  $("#check-in").datepicker({
	    showButtonPanel: true,
	    showAnim: "clip",
	    showOn: "both",
	    buttonText: "<i class='fa fa-th' style='color: #164c65;'></i>",
	    onSelect: function onSelect(dateStr, ui) {
	      $("#check-out").datepicker("option", "defaultDate", dateStr);
	      $("#check-out").datepicker("option", "minDate", dateStr);
	      dayObj = ui;
	      inMonth = ui.selectedMonth + 1;
	      checkIn = ui.selectedYear + "-" + inMonth + "-" + ui.selectedDay;
	      // console.log(checkIn);
	    }
	  });
	  var outObj;
	  var checkOut;
	  var outMonth;
	  $("#check-out").datepicker({
	    showButtonPanel: true,
	    showAnim: "clip",
	    showOn: "both",
	    buttonText: "<i class='fa fa-th' style='color: #164c65;' ></i>",
	    onSelect: function onSelect(dateStr, uiOut) {
	      outObj = uiOut;
	      outMonth = uiOut.selectedMonth + 1;
	      checkOut = uiOut.selectedYear + "-" + outMonth + "-" + uiOut.selectedDay;
	      // console.log(checkOut);
	    }
	  });
	  var selectedVal;
	  $("#rooms").change(function () {
	    selectedVal = $("#rooms option:selected").val();
	    // console.log('rooms', selectedVal);
	  });
	
	  $("#go").click(function () {
	    var url = "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=14224&";
	    url += "checkin=" + $("#check-in").val() + "&checkout=" + $("#check-out").val() + "&rooms=" + $("#rooms").val();
	    // alert(url);
	    window.open(url, "_blank");
	    var params = {
	      hd1: checkIn,
	      /* Check In Date. Format yyyy-mm-dd. Ex: 2015-02-14 */
	      hd2: checkOut,
	      /* Check Out Date. Format yyyy-mm-dd. Ex: 2015-02-14 */
	      hc1: "",
	      /* Destination City */
	      hs1: "",
	      /* Destination State or Region */
	      hn1: "",
	      /* Destination Country */
	      hcu: "",
	      /* Purchase Currency */
	      hpr: "",
	      /* Hotel Property */
	      hr: selectedVal,
	      /* Number of Rooms */
	      hpid: "",
	      /* Property ID */
	      t: "" /* Number of Travelers */
	    };
	    console.log(params);
	
	    var cid = [];
	    var paramsArr = [];
	    var cidParams = [];
	    var pl = document.createElement("script");
	    var defaultParams = {
	      vid: "hot",
	      et: "hs"
	    };
	    for (key in defaultParams) {
	      params[key] = defaultParams[key];
	    }
	    for (key in cidParams) {
	      cid.push(params[cidParams[key]]);
	    }
	    params.cid = cid.join("|");
	    for (key in params) {
	      paramsArr.push(key + "=" + encodeURIComponent(params[key]));
	    }
	    pl.type = "text/javascript";
	    pl.async = true;
	    pl.src = "https://beacon.sojern.com/pixel/p/7964?f_v=v6_js&p_v=2&" + paramsArr.join("&");
	    (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(pl);
	  });
	
	  var dayObjM;
	  var checkInM;
	  var inMonthM;
	  $("#check-in-mobile").datepicker({
	    format: "DD/MM/YYYY",
	    ignoreReadonly: true,
	    allowInputToggle: true,
	    showButtonPanel: false,
	    showAnim: "clip",
	    showOn: "both",
	    onSelect: function onSelect(dateStrM, uiM) {
	      $("#check-out-mobile").datepicker("option", "defaultDate", dateStrM);
	      $("#check-out-mobile").datepicker("option", "minDate", dateStrM);
	      dayObjM = uiM;
	      inMonthM = uiM.selectedMonth + 1;
	      checkInM = uiM.selectedYear + "-" + inMonthM + "-" + uiM.selectedDay;
	      // console.log(checkInM);
	    }
	    // buttonText: "<span><i class='fa fa-th' style='color: #164c65;'></i></span>"
	  });
	  var outObjM;
	  var checkOutM;
	  var outMonthM;
	  $("#check-out-mobile").datepicker({
	    format: "DD/MM/YYYY",
	    ignoreReadonly: true,
	    allowInputToggle: true,
	    showButtonPanel: true,
	    showAnim: "clip",
	    showOn: "both",
	    onSelect: function onSelect(dateStrM, uiOutM) {
	      outObjM = uiOutM;
	      outMonthM = uiOutM.selectedMonth + 1;
	      checkOutM = uiOutM.selectedYear + "-" + outMonthM + "-" + uiOutM.selectedDay;
	      // console.log(checkOutM);
	    }
	    // buttonText: "<span><i class='fa fa-th' style='color: #164c65;' ></i></span>"
	  });
	  var selectedValM;
	  $("#rooms-mobile").change(function () {
	    selectedValM = $("#rooms-mobile option:selected").val();
	    // console.log('rooms', selectedValM);
	  });
	
	  $("#go-mobile").click(function () {
	    var url = "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=14224&";
	    url += "checkin=" + $("#check-in-mobile").val() + "&checkout=" + $("#check-out-mobile").val() + "&rooms=" + $("#rooms-mobile").val();
	    // // alert(url);
	    window.open(url, "_blank");
	    var params = {
	      hd1: checkInM,
	      /* Check In Date. Format yyyy-mm-dd. Ex: 2015-02-14 */
	      hd2: checkOutM,
	      /* Check Out Date. Format yyyy-mm-dd. Ex: 2015-02-14 */
	      hc1: "",
	      /* Destination City */
	      hs1: "",
	      /* Destination State or Region */
	      hn1: "",
	      /* Destination Country */
	      hcu: "",
	      /* Purchase Currency */
	      hpr: "",
	      /* Hotel Property */
	      hr: selectedValM,
	      /* Number of Rooms */
	      hpid: "",
	      /* Property ID */
	      t: "" /* Number of Travelers */
	    };
	    console.log(params);
	
	    var cid = [];
	    var paramsArr = [];
	    var cidParams = [];
	    var pl = document.createElement("script");
	    var defaultParams = {
	      vid: "hot",
	      et: "hs"
	    };
	    for (key in defaultParams) {
	      params[key] = defaultParams[key];
	    }
	    for (key in cidParams) {
	      cid.push(params[cidParams[key]]);
	    }
	    params.cid = cid.join("|");
	    for (key in params) {
	      paramsArr.push(key + "=" + encodeURIComponent(params[key]));
	    }
	    pl.type = "text/javascript";
	    pl.async = true;
	    pl.src = "https://beacon.sojern.com/pixel/p/7964?f_v=v6_js&p_v=2&" + paramsArr.join("&");
	    (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(pl);
	  });
	
	  var mapStyle = [{
	    featureType: "administrative",
	    elementType: "labels",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "administrative.country",
	    elementType: "geometry.stroke",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "administrative.province",
	    elementType: "geometry.stroke",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "landscape",
	    elementType: "geometry",
	    stylers: [{
	      visibility: "on"
	    }, {
	      color: "#e3e3e3"
	    }]
	  }, {
	    featureType: "landscape.natural",
	    elementType: "labels",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "poi",
	    elementType: "all",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "road",
	    elementType: "all",
	    stylers: [{
	      color: "#cccccc"
	    }]
	  }, {
	    featureType: "road",
	    elementType: "labels",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "transit",
	    elementType: "labels.icon",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "transit.line",
	    elementType: "geometry",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "transit.line",
	    elementType: "labels.text",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "transit.station.airport",
	    elementType: "geometry",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "transit.station.airport",
	    elementType: "labels",
	    stylers: [{
	      visibility: "off"
	    }]
	  }, {
	    featureType: "water",
	    elementType: "geometry",
	    stylers: [{
	      color: "#FFFFFF"
	    }]
	  }, {
	    featureType: "water",
	    elementType: "labels",
	    stylers: [{
	      visibility: "off"
	    }]
	  }];
	
	  var map = new google.maps.Map($(".map-canvas")[0], {
	    zoom: 15,
	    styles: mapStyle,
	    center: new google.maps.LatLng(40.666966, -111.513942),
	    disableDefaultUI: true
	  });
	  var image = "/img/map-icon.png";
	  var marker = new google.maps.Marker({
	    map: map,
	    icon: image,
	    position: new google.maps.LatLng(40.666966, -111.513942)
	  });
	  var info = new SnazzyInfoWindow({
	    marker: marker,
	    placement: "right",
	    offset: {
	      left: "20px"
	    },
	    content: "<p>Park City Peaks Hotel</p>" + "<p>2346 PARK AVENUE, PARK CITY, UTAH</p>" + '<p><a style="color: #164c65;" href="tel:800.649.5012">800.649.5012</a> / <a style="color: #164c65;" href="tel:435.649.5000">435.649.5000</a></p>' + "<hr>" + '<em><p><a style="color: #164c65;" href="/contact">Contact</a> | <a style="color: #164c65;" href="/room">Get a room</a> | <a style="color: #164c65;" href="https://maps.google.com?saddr=Current+Location&daddr=Park+City+Peaks+Hotel,+2346+Park+Avenue,+Park+City,+Utah" target="_blank">Directions</a></p></em>',
	    backgroundColor: "rgba(248, 249, 250, 0.7)",
	    closeOnMapClick: false,
	    borderRadius: "0px",
	    shadow: false,
	    fontColor: "#164c65",
	    fontSize: "12px"
	  });
	});
	/*! lazysizes - v4.0.1 */
	!function (a, b) {
	  var c = b(a, a.document);
	  a.lazySizes = c, "object" == ( false ? "undefined" : _typeof(module)) && module.exports && (module.exports = c);
	}(window, function (a, b) {
	  "use strict";
	
	  if (b.getElementsByClassName) {
	    var c,
	        d,
	        e = b.documentElement,
	        f = a.Date,
	        g = a.HTMLPictureElement,
	        h = "addEventListener",
	        i = "getAttribute",
	        j = a[h],
	        k = a.setTimeout,
	        l = a.requestAnimationFrame || k,
	        m = a.requestIdleCallback,
	        n = /^picture$/i,
	        o = ["load", "error", "lazyincluded", "_lazyloaded"],
	        p = {},
	        q = Array.prototype.forEach,
	        r = function r(a, b) {
	      return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b];
	    },
	        s = function s(a, b) {
	      r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
	    },
	        t = function t(a, b) {
	      var c;
	      (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
	    },
	        u = function u(a, b, c) {
	      var d = c ? h : "removeEventListener";
	      c && u(a, b), o.forEach(function (c) {
	        a[d](c, b);
	      });
	    },
	        v = function v(a, d, e, f, g) {
	      var h = b.createEvent("CustomEvent");
	      return e || (e = {}), e.instance = c, h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h;
	    },
	        w = function w(b, c) {
	      var e;
	      !g && (e = a.picturefill || d.pf) ? e({
	        reevaluate: !0,
	        elements: [b]
	      }) : c && c.src && (b.src = c.src);
	    },
	        x = function x(a, b) {
	      return (getComputedStyle(a, null) || {})[b];
	    },
	        y = function y(a, b, c) {
	      for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;) {
	        c = b.offsetWidth, b = b.parentNode;
	      }return c;
	    },
	        z = function () {
	      var a,
	          c,
	          d = [],
	          e = [],
	          f = d,
	          g = function g() {
	        var b = f;
	        for (f = d.length ? e : d, a = !0, c = !1; b.length;) {
	          b.shift()();
	        }a = !1;
	      },
	          h = function h(d, e) {
	        a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)));
	      };
	      return h._lsFlush = g, h;
	    }(),
	        A = function A(a, b) {
	      return b ? function () {
	        z(a);
	      } : function () {
	        var b = this,
	            c = arguments;
	        z(function () {
	          a.apply(b, c);
	        });
	      };
	    },
	        B = function B(a) {
	      var b,
	          c = 0,
	          e = 125,
	          g = d.ricTimeout,
	          h = function h() {
	        b = !1, c = f.now(), a();
	      },
	          i = m && d.ricTimeout ? function () {
	        m(h, {
	          timeout: g
	        }), g !== d.ricTimeout && (g = d.ricTimeout);
	      } : A(function () {
	        k(h);
	      }, !0);
	      return function (a) {
	        var d;
	        (a = a === !0) && (g = 33), b || (b = !0, d = e - (f.now() - c), 0 > d && (d = 0), a || 9 > d && m ? i() : k(i, d));
	      };
	    },
	        C = function C(a) {
	      var b,
	          c,
	          d = 99,
	          e = function e() {
	        b = null, a();
	      },
	          g = function g() {
	        var a = f.now() - c;
	        d > a ? k(g, d - a) : (m || e)(e);
	      };
	      return function () {
	        c = f.now(), b || (b = k(g, d));
	      };
	    };
	    !function () {
	      var b,
	          c = {
	        lazyClass: "lazyload",
	        loadedClass: "lazyloaded",
	        loadingClass: "lazyloading",
	        preloadClass: "lazypreload",
	        errorClass: "lazyerror",
	        autosizesClass: "lazyautosizes",
	        srcAttr: "data-src",
	        srcsetAttr: "data-srcset",
	        sizesAttr: "data-sizes",
	        minSize: 40,
	        customMedia: {},
	        init: !0,
	        expFactor: 1.5,
	        hFac: 0.8,
	        loadMode: 2,
	        loadHidden: !0,
	        ricTimeout: 300
	      };
	      d = a.lazySizesConfig || a.lazysizesConfig || {};
	      for (b in c) {
	        b in d || (d[b] = c[b]);
	      }a.lazySizesConfig = d, k(function () {
	        d.init && F();
	      });
	    }();
	    var D = function () {
	      var g,
	          l,
	          m,
	          o,
	          p,
	          y,
	          D,
	          F,
	          G,
	          H,
	          I,
	          J,
	          K,
	          L,
	          M = /^img$/i,
	          N = /^iframe$/i,
	          O = "onscroll" in a && !/glebot/.test(navigator.userAgent),
	          P = 0,
	          Q = 0,
	          R = 0,
	          S = -1,
	          T = function T(a) {
	        R--, a && a.target && u(a.target, T), (!a || 0 > R || !a.target) && (R = 0);
	      },
	          U = function U(a, c) {
	        var d,
	            f = a,
	            g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
	        for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;) {
	          g = (x(f, "opacity") || 1) > 0, g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
	        }return g;
	      },
	          V = function V() {
	        var a,
	            f,
	            h,
	            j,
	            k,
	            m,
	            n,
	            p,
	            q,
	            r = c.elements;
	        if ((o = d.loadMode) && 8 > R && (a = r.length)) {
	          f = 0, S++, null == K && ("expand" in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370), J = d.expand, K = J * d.expFactor), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K, S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
	          for (; a > f; f++) {
	            if (r[f] && !r[f]._lazyRace) if (O) {
	              if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q), q !== m && (y = innerWidth + m * L, D = innerHeight + m, n = -1 * m, q = m), h = r[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) {
	                if (ba(r[f]), k = !0, R > 9) break;
	              } else !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]);
	            } else ba(r[f]);
	          }j && !k && ba(j);
	        }
	      },
	          W = B(V),
	          X = function X(a) {
	        s(a.target, d.loadedClass), t(a.target, d.loadingClass), u(a.target, Z), v(a.target, "lazyloaded");
	      },
	          Y = A(X),
	          Z = function Z(a) {
	        Y({
	          target: a.target
	        });
	      },
	          $ = function $(a, b) {
	        try {
	          a.contentWindow.location.replace(b);
	        } catch (c) {
	          a.src = b;
	        }
	      },
	          _ = function _(a) {
	        var b,
	            c = a[i](d.srcsetAttr);
	        (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c);
	      },
	          aa = A(function (a, b, c, e, f) {
	        var g, h, j, l, o, p;
	        (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = {
	          target: a
	        }, p && (u(a, T, !0), clearTimeout(m), m = k(T, 2500), s(a, d.loadingClass), u(a, Z, !0)), l && q.call(j.getElementsByTagName("source"), _), h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g), f && (h || l) && w(a, {
	          src: g
	        })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () {
	          (!p || a.complete && a.naturalWidth > 1) && (p ? T(o) : R--, X(o));
	        }, !0);
	      }),
	          ba = function ba(a) {
	        var b,
	            c = M.test(a.nodeName),
	            e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
	            f = "auto" == e;
	        (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, R++, aa(a, b, f, e, c));
	      },
	          ca = function ca() {
	        if (!l) {
	          if (f.now() - p < 999) return void k(ca, 999);
	          var a = C(function () {
	            d.loadMode = 3, W();
	          });
	          l = !0, d.loadMode = 3, W(), j("scroll", function () {
	            3 == d.loadMode && (d.loadMode = 2), a();
	          }, !0);
	        }
	      };
	      return {
	        _: function _() {
	          p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), L = d.hFac, j("scroll", W, !0), j("resize", W, !0), a.MutationObserver ? new MutationObserver(W).observe(e, {
	            childList: !0,
	            subtree: !0,
	            attributes: !0
	          }) : (e[h]("DOMNodeInserted", W, !0), e[h]("DOMAttrModified", W, !0), setInterval(W, 999)), j("hashchange", W, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) {
	            b[h](a, W, !0);
	          }), /d$|^c/.test(b.readyState) ? ca() : (j("load", ca), b[h]("DOMContentLoaded", W), k(ca, 2e4)), c.elements.length ? (V(), z._lsFlush()) : W();
	        },
	        checkElems: W,
	        unveil: ba
	      };
	    }(),
	        E = function () {
	      var a,
	          c = A(function (a, b, c, d) {
	        var e, f, g;
	        if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; g > f; f++) {
	          e[f].setAttribute("sizes", d);
	        }c.detail.dataAttr || w(a, c.detail);
	      }),
	          e = function e(a, b, d) {
	        var e,
	            f = a.parentNode;
	        f && (d = y(a, f, d), e = v(a, "lazybeforesizes", {
	          width: d,
	          dataAttr: !!b
	        }), e.defaultPrevented || (d = e.detail.width, d && d !== a._lazysizesWidth && c(a, f, e, d)));
	      },
	          f = function f() {
	        var b,
	            c = a.length;
	        if (c) for (b = 0; c > b; b++) {
	          e(a[b]);
	        }
	      },
	          g = C(f);
	      return {
	        _: function _() {
	          a = b.getElementsByClassName(d.autosizesClass), j("resize", g);
	        },
	        checkElems: g,
	        updateElem: e
	      };
	    }(),
	        F = function F() {
	      F.i || (F.i = !0, E._(), D._());
	    };
	    return c = {
	      cfg: d,
	      autoSizer: E,
	      loader: D,
	      init: F,
	      uP: w,
	      aC: s,
	      rC: t,
	      hC: r,
	      fire: v,
	      gW: y,
	      rAF: z
	    };
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var palmetto = __webpack_require__(3);
	var emailSvc = __webpack_require__(5)();
	
	module.exports = function () {
		var ee = palmetto();
		emailSvc(ee);
		return ee;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var EventEmitter = __webpack_require__(4)
	
	var ee = (ee = global.ee) != null ? ee : (new EventEmitter()).setMaxListeners(0)
	var listening = false
	
	function palmetto () {
	  // only one listener to `send`!
	  if (!listening) {
	    listening = true
	    ee.on('send', function (event) {
	      ee.emit(event.to, event)
	    })
	  }
	  
	  return ee
	}
	
	module.exports = palmetto
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var mandrill = __webpack_require__(6);
	var mandrill_client = new mandrill.Mandrill('XXXXXXX');
	var response = __webpack_require__(44).response;
	var responseError = __webpack_require__(44).responseError;
	
	module.exports = function () {
		return function (ee) {
	
			ee.on('/email/send', function (event) {
				// var toEmail = getToEmail(event.object.reason);
				var toEmail = "";
			});
		};
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {// Generated by CoffeeScript 1.8.0
	(function() {
	  var Exports, Inbound, Internal, Ips, Messages, Metadata, OPTS, Rejects, Senders, Subaccounts, Tags, Templates, Urls, Users, Webhooks, Whitelists, https;
	
	  https = __webpack_require__(12);
	
	  OPTS = {
	    host: 'mandrillapp.com',
	    port: 443,
	    prefix: '/api/1.0/',
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json',
	      'User-Agent': 'Mandrill-Node/1.0.41'
	    }
	  };
	
	  exports.Mandrill = (function() {
	    function Mandrill(apikey, debug) {
	      this.apikey = apikey != null ? apikey : null;
	      this.debug = debug != null ? debug : false;
	      this.templates = new Templates(this);
	      this.exports = new Exports(this);
	      this.users = new Users(this);
	      this.rejects = new Rejects(this);
	      this.inbound = new Inbound(this);
	      this.tags = new Tags(this);
	      this.messages = new Messages(this);
	      this.whitelists = new Whitelists(this);
	      this.ips = new Ips(this);
	      this.internal = new Internal(this);
	      this.subaccounts = new Subaccounts(this);
	      this.urls = new Urls(this);
	      this.webhooks = new Webhooks(this);
	      this.senders = new Senders(this);
	      this.metadata = new Metadata(this);
	      if (this.apikey === null) {
	        this.apikey = process.env['MANDRILL_APIKEY'];
	      }
	    }
	
	    Mandrill.prototype.call = function(uri, params, onresult, onerror) {
	      var req;
	      if (params == null) {
	        params = {};
	      }
	      params.key = this.apikey;
	      params = new Buffer(JSON.stringify(params), 'utf8');
	      if (this.debug) {
	        console.log("Mandrill: Opening request to https://" + OPTS.host + OPTS.prefix + uri + ".json");
	      }
	      OPTS.path = "" + OPTS.prefix + uri + ".json";
	      OPTS.headers['Content-Length'] = params.length;
	      req = https.request(OPTS, (function(_this) {
	        return function(res) {
	          var json;
	          res.setEncoding('utf8');
	          json = '';
	          res.on('data', function(d) {
	            return json += d;
	          });
	          return res.on('end', function() {
	            var e;
	            try {
	              json = JSON.parse(json);
	            } catch (_error) {
	              e = _error;
	              json = {
	                status: 'error',
	                name: 'GeneralError',
	                message: e
	              };
	            }
	            if (json == null) {
	              json = {
	                status: 'error',
	                name: 'GeneralError',
	                message: 'An unexpected error occurred'
	              };
	            }
	            if (res.statusCode !== 200) {
	              if (onerror) {
	                return onerror(json);
	              } else {
	                return _this.onerror(json);
	              }
	            } else {
	              if (onresult) {
	                return onresult(json);
	              }
	            }
	          });
	        };
	      })(this));
	      req.write(params);
	      req.end();
	      req.on('error', (function(_this) {
	        return function(e) {
	          if (onerror) {
	            return onerror(e);
	          } else {
	            return _this.onerror({
	              status: 'error',
	              name: 'GeneralError',
	              message: e
	            });
	          }
	        };
	      })(this));
	      return null;
	    };
	
	    Mandrill.prototype.onerror = function(err) {
	      throw {
	        name: err.name,
	        message: err.message,
	        toString: function() {
	          return "" + err.name + ": " + err.message;
	        }
	      };
	    };
	
	    return Mandrill;
	
	  })();
	
	  Templates = (function() {
	    function Templates(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Add a new template
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the name for the new template - must be unique
	    @option params {String} from_email a default sending address for emails sent using this template
	    @option params {String} from_name a default from name to be used
	    @option params {String} subject a default subject line to be used
	    @option params {String} code the HTML code for the template with mc:edit attributes for the editable elements
	    @option params {String} text a default text part to be used when sending with this template
	    @option params {Boolean} publish set to false to add a draft template without publishing
	    @option params {Array} labels an optional array of up to 10 labels to use for filtering templates
	         - labels[] {String} a single label
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["from_email"] == null) {
	        params["from_email"] = null;
	      }
	      if (params["from_name"] == null) {
	        params["from_name"] = null;
	      }
	      if (params["subject"] == null) {
	        params["subject"] = null;
	      }
	      if (params["code"] == null) {
	        params["code"] = null;
	      }
	      if (params["text"] == null) {
	        params["text"] = null;
	      }
	      if (params["publish"] == null) {
	        params["publish"] = true;
	      }
	      if (params["labels"] == null) {
	        params["labels"] = [];
	      }
	      return this.master.call('templates/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Get the information for an existing template
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the immutable name of an existing template
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('templates/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Update the code for an existing template. If null is provided for any fields, the values will remain unchanged.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the immutable name of an existing template
	    @option params {String} from_email the new default sending address
	    @option params {String} from_name the new default from name
	    @option params {String} subject the new default subject line
	    @option params {String} code the new code for the template
	    @option params {String} text the new default text part to be used
	    @option params {Boolean} publish set to false to update the draft version of the template without publishing
	    @option params {Array} labels an optional array of up to 10 labels to use for filtering templates
	         - labels[] {String} a single label
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.update = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["from_email"] == null) {
	        params["from_email"] = null;
	      }
	      if (params["from_name"] == null) {
	        params["from_name"] = null;
	      }
	      if (params["subject"] == null) {
	        params["subject"] = null;
	      }
	      if (params["code"] == null) {
	        params["code"] = null;
	      }
	      if (params["text"] == null) {
	        params["text"] = null;
	      }
	      if (params["publish"] == null) {
	        params["publish"] = true;
	      }
	      if (params["labels"] == null) {
	        params["labels"] = null;
	      }
	      return this.master.call('templates/update', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Publish the content for the template. Any new messages sent using this template will start using the content that was previously in draft.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the immutable name of an existing template
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.publish = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('templates/publish', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete a template
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the immutable name of an existing template
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('templates/delete', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return a list of all the templates available to this user
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} label an optional label to filter the templates
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["label"] == null) {
	        params["label"] = null;
	      }
	      return this.master.call('templates/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the recent history (hourly stats for the last 30 days) for a template
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the name of an existing template
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.timeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('templates/time-series', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Inject content and optionally merge fields into a template, returning the HTML that results
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} template_name the immutable name of a template that exists in the user's account
	    @option params {Array} template_content an array of template content to render.  Each item in the array should be a struct with two keys - name: the name of the content block to set the content for, and content: the actual content to put into the block
	         - template_content[] {Object} the injection of a single piece of content into a single editable region
	             - name {String} the name of the mc:edit editable region to inject into
	             - content {String} the content to inject
	    @option params {Array} merge_vars optional merge variables to use for injecting merge field content.  If this is not provided, no merge fields will be replaced.
	         - merge_vars[] {Object} a single merge variable
	             - name {String} the merge variable's name. Merge variable names are case-insensitive and may not start with _
	             - content {String} the merge variable's content
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Templates.prototype.render = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["merge_vars"] == null) {
	        params["merge_vars"] = null;
	      }
	      return this.master.call('templates/render', params, onsuccess, onerror);
	    };
	
	    return Templates;
	
	  })();
	
	  Exports = (function() {
	    function Exports(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Returns information about an export job. If the export job's state is 'complete',
	    the returned data will include a URL you can use to fetch the results. Every export
	    job produces a zip archive, but the format of the archive is distinct for each job
	    type. The api calls that initiate exports include more details about the output format
	    for that job type.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id an export job identifier
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Exports.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('exports/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Returns a list of your exports.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Exports.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('exports/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Begins an export of your rejection blacklist. The blacklist will be exported to a zip archive
	    containing a single file named rejects.csv that includes the following fields: email,
	    reason, detail, created_at, expires_at, last_event_at, expires_at.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} notify_email an optional email address to notify when the export job has finished.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Exports.prototype.rejects = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["notify_email"] == null) {
	        params["notify_email"] = null;
	      }
	      return this.master.call('exports/rejects', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Begins an export of your rejection whitelist. The whitelist will be exported to a zip archive
	    containing a single file named whitelist.csv that includes the following fields:
	    email, detail, created_at.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} notify_email an optional email address to notify when the export job has finished.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Exports.prototype.whitelist = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["notify_email"] == null) {
	        params["notify_email"] = null;
	      }
	      return this.master.call('exports/whitelist', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Begins an export of your activity history. The activity will be exported to a zip archive
	    containing a single file named activity.csv in the same format as you would be able to export
	    from your account's activity view. It includes the following fields: Date, Email Address,
	    Sender, Subject, Status, Tags, Opens, Clicks, Bounce Detail. If you have configured any custom
	    metadata fields, they will be included in the exported data.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} notify_email an optional email address to notify when the export job has finished
	    @option params {String} date_from start date as a UTC string in YYYY-MM-DD HH:MM:SS format
	    @option params {String} date_to end date as a UTC string in YYYY-MM-DD HH:MM:SS format
	    @option params {Array} tags an array of tag names to narrow the export to; will match messages that contain ANY of the tags
	         - tags[] {String} a tag name
	    @option params {Array} senders an array of senders to narrow the export to
	         - senders[] {String} a sender address
	    @option params {Array} states an array of states to narrow the export to; messages with ANY of the states will be included
	         - states[] {String} a message state
	    @option params {Array} api_keys an array of api keys to narrow the export to; messsagse sent with ANY of the keys will be included
	         - api_keys[] {String} an API key associated with your account
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Exports.prototype.activity = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["notify_email"] == null) {
	        params["notify_email"] = null;
	      }
	      if (params["date_from"] == null) {
	        params["date_from"] = null;
	      }
	      if (params["date_to"] == null) {
	        params["date_to"] = null;
	      }
	      if (params["tags"] == null) {
	        params["tags"] = null;
	      }
	      if (params["senders"] == null) {
	        params["senders"] = null;
	      }
	      if (params["states"] == null) {
	        params["states"] = null;
	      }
	      if (params["api_keys"] == null) {
	        params["api_keys"] = null;
	      }
	      return this.master.call('exports/activity', params, onsuccess, onerror);
	    };
	
	    return Exports;
	
	  })();
	
	  Users = (function() {
	    function Users(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Return the information about the API-connected user
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Users.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('users/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Validate an API key and respond to a ping
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Users.prototype.ping = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('users/ping', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Validate an API key and respond to a ping (anal JSON parser version)
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Users.prototype.ping2 = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('users/ping2', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the senders that have tried to use this account, both verified and unverified
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Users.prototype.senders = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('users/senders', params, onsuccess, onerror);
	    };
	
	    return Users;
	
	  })();
	
	  Rejects = (function() {
	    function Rejects(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Adds an email to your email rejection blacklist. Addresses that you
	    add manually will never expire and there is no reputation penalty
	    for removing them from your blacklist. Attempting to blacklist an
	    address that has been whitelisted will have no effect.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email an email address to block
	    @option params {String} comment an optional comment describing the rejection
	    @option params {String} subaccount an optional unique identifier for the subaccount to limit the blacklist entry
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Rejects.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["comment"] == null) {
	        params["comment"] = null;
	      }
	      if (params["subaccount"] == null) {
	        params["subaccount"] = null;
	      }
	      return this.master.call('rejects/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Retrieves your email rejection blacklist. You can provide an email
	    address to limit the results. Returns up to 1000 results. By default,
	    entries that have expired are excluded from the results; set
	    include_expired to true to include them.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email an optional email address to search by
	    @option params {Boolean} include_expired whether to include rejections that have already expired.
	    @option params {String} subaccount an optional unique identifier for the subaccount to limit the blacklist
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Rejects.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["email"] == null) {
	        params["email"] = null;
	      }
	      if (params["include_expired"] == null) {
	        params["include_expired"] = false;
	      }
	      if (params["subaccount"] == null) {
	        params["subaccount"] = null;
	      }
	      return this.master.call('rejects/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Deletes an email rejection. There is no limit to how many rejections
	    you can remove from your blacklist, but keep in mind that each deletion
	    has an affect on your reputation.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email an email address
	    @option params {String} subaccount an optional unique identifier for the subaccount to limit the blacklist deletion
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Rejects.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["subaccount"] == null) {
	        params["subaccount"] = null;
	      }
	      return this.master.call('rejects/delete', params, onsuccess, onerror);
	    };
	
	    return Rejects;
	
	  })();
	
	  Inbound = (function() {
	    function Inbound(master) {
	      this.master = master;
	    }
	
	
	    /*
	    List the domains that have been configured for inbound delivery
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.domains = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/domains', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add an inbound domain to your account
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain a domain name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.addDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/add-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Check the MX settings for an inbound domain. The domain must have already been added with the add-domain call
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain an existing inbound domain
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.checkDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/check-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete an inbound domain from the account. All mail will stop routing for this domain immediately.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain an existing inbound domain
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.deleteDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/delete-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    List the mailbox routes defined for an inbound domain
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain the domain to check
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.routes = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/routes', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add a new mailbox route to an inbound domain
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain an existing inbound domain
	    @option params {String} pattern the search pattern that the mailbox name should match
	    @option params {String} url the webhook URL where the inbound messages will be published
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.addRoute = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/add-route', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Update the pattern or webhook of an existing inbound mailbox route. If null is provided for any fields, the values will remain unchanged.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of an existing mailbox route
	    @option params {String} pattern the search pattern that the mailbox name should match
	    @option params {String} url the webhook URL where the inbound messages will be published
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.updateRoute = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["pattern"] == null) {
	        params["pattern"] = null;
	      }
	      if (params["url"] == null) {
	        params["url"] = null;
	      }
	      return this.master.call('inbound/update-route', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete an existing inbound mailbox route
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of an existing route
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.deleteRoute = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('inbound/delete-route', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Take a raw MIME document destined for a domain with inbound domains set up, and send it to the inbound hook exactly as if it had been sent over SMTP
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} raw_message the full MIME document of an email message
	    @option params {Array|null} to optionally define the recipients to receive the message - otherwise we'll use the To, Cc, and Bcc headers provided in the document
	         - to[] {String} the email address of the recipient
	    @option params {String} mail_from the address specified in the MAIL FROM stage of the SMTP conversation. Required for the SPF check.
	    @option params {String} helo the identification provided by the client mta in the MTA state of the SMTP conversation. Required for the SPF check.
	    @option params {String} client_address the remote MTA's ip address. Optional; required for the SPF check.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Inbound.prototype.sendRaw = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["to"] == null) {
	        params["to"] = null;
	      }
	      if (params["mail_from"] == null) {
	        params["mail_from"] = null;
	      }
	      if (params["helo"] == null) {
	        params["helo"] = null;
	      }
	      if (params["client_address"] == null) {
	        params["client_address"] = null;
	      }
	      return this.master.call('inbound/send-raw', params, onsuccess, onerror);
	    };
	
	    return Inbound;
	
	  })();
	
	  Tags = (function() {
	    function Tags(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Return all of the user-defined tag information
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Tags.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('tags/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Deletes a tag permanently. Deleting a tag removes the tag from any messages
	    that have been sent, and also deletes the tag's stats. There is no way to
	    undo this operation, so use it carefully.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} tag a tag name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Tags.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('tags/delete', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return more detailed information about a single tag, including aggregates of recent stats
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} tag an existing tag name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Tags.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('tags/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the recent history (hourly stats for the last 30 days) for a tag
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} tag an existing tag name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Tags.prototype.timeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('tags/time-series', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the recent history (hourly stats for the last 30 days) for all tags
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Tags.prototype.allTimeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('tags/all-time-series', params, onsuccess, onerror);
	    };
	
	    return Tags;
	
	  })();
	
	  Messages = (function() {
	    function Messages(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Send a new transactional message through Mandrill
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {Struct} message the information on the message to send
	         - html {String} the full HTML content to be sent
	         - text {String} optional full text content to be sent
	         - subject {String} the message subject
	         - from_email {String} the sender email address.
	         - from_name {String} optional from name to be used
	         - to {Array} an array of recipient information.
	             - to[] {Object} a single recipient's information.
	                 - email {String} the email address of the recipient
	                 - name {String} the optional display name to use for the recipient
	                 - type {String} the header type to use for the recipient, defaults to "to" if not provided
	         - headers {Object} optional extra headers to add to the message (most headers are allowed)
	         - important {Boolean} whether or not this message is important, and should be delivered ahead of non-important messages
	         - track_opens {Boolean} whether or not to turn on open tracking for the message
	         - track_clicks {Boolean} whether or not to turn on click tracking for the message
	         - auto_text {Boolean} whether or not to automatically generate a text part for messages that are not given text
	         - auto_html {Boolean} whether or not to automatically generate an HTML part for messages that are not given HTML
	         - inline_css {Boolean} whether or not to automatically inline all CSS styles provided in the message HTML - only for HTML documents less than 256KB in size
	         - url_strip_qs {Boolean} whether or not to strip the query string from URLs when aggregating tracked URL data
	         - preserve_recipients {Boolean} whether or not to expose all recipients in to "To" header for each email
	         - view_content_link {Boolean} set to false to remove content logging for sensitive emails
	         - bcc_address {String} an optional address to receive an exact copy of each recipient's email
	         - tracking_domain {String} a custom domain to use for tracking opens and clicks instead of mandrillapp.com
	         - signing_domain {String} a custom domain to use for SPF/DKIM signing instead of mandrill (for "via" or "on behalf of" in email clients)
	         - return_path_domain {String} a custom domain to use for the messages's return-path
	         - merge {Boolean} whether to evaluate merge tags in the message. Will automatically be set to true if either merge_vars or global_merge_vars are provided.
	         - merge_language {String} the merge tag language to use when evaluating merge tags, either mailchimp or handlebars
	         - global_merge_vars {Array} global merge variables to use for all recipients. You can override these per recipient.
	             - global_merge_vars[] {Object} a single global merge variable
	                 - name {String} the global merge variable's name. Merge variable names are case-insensitive and may not start with _
	                 - content {Mixed} the global merge variable's content
	         - merge_vars {Array} per-recipient merge variables, which override global merge variables with the same name.
	             - merge_vars[] {Object} per-recipient merge variables
	                 - rcpt {String} the email address of the recipient that the merge variables should apply to
	                 - vars {Array} the recipient's merge variables
	                     - vars[] {Object} a single merge variable
	                         - name {String} the merge variable's name. Merge variable names are case-insensitive and may not start with _
	                         - content {Mixed} the merge variable's content
	         - tags {Array} an array of string to tag the message with.  Stats are accumulated using tags, though we only store the first 100 we see, so this should not be unique or change frequently.  Tags should be 50 characters or less.  Any tags starting with an underscore are reserved for internal use and will cause errors.
	             - tags[] {String} a single tag - must not start with an underscore
	         - subaccount {String} the unique id of a subaccount for this message - must already exist or will fail with an error
	         - google_analytics_domains {Array} an array of strings indicating for which any matching URLs will automatically have Google Analytics parameters appended to their query string automatically.
	         - google_analytics_campaign {Array|string} optional string indicating the value to set for the utm_campaign tracking parameter. If this isn't provided the email's from address will be used instead.
	         - metadata {Array} metadata an associative array of user metadata. Mandrill will store this metadata and make it available for retrieval. In addition, you can select up to 10 metadata fields to index and make searchable using the Mandrill search api.
	         - recipient_metadata {Array} Per-recipient metadata that will override the global values specified in the metadata parameter.
	             - recipient_metadata[] {Object} metadata for a single recipient
	                 - rcpt {String} the email address of the recipient that the metadata is associated with
	                 - values {Array} an associated array containing the recipient's unique metadata. If a key exists in both the per-recipient metadata and the global metadata, the per-recipient metadata will be used.
	         - attachments {Array} an array of supported attachments to add to the message
	             - attachments[] {Object} a single supported attachment
	                 - type {String} the MIME type of the attachment
	                 - name {String} the file name of the attachment
	                 - content {String} the content of the attachment as a base64-encoded string
	         - images {Array} an array of embedded images to add to the message
	             - images[] {Object} a single embedded image
	                 - type {String} the MIME type of the image - must start with "image/"
	                 - name {String} the Content ID of the image - use <img src="cid:THIS_VALUE"> to reference the image in your HTML content
	                 - content {String} the content of the image as a base64-encoded string
	    @option params {Boolean} async enable a background sending mode that is optimized for bulk sending. In async mode, messages/send will immediately return a status of "queued" for every recipient. To handle rejections when sending in async mode, set up a webhook for the 'reject' event. Defaults to false for messages with no more than 10 recipients; messages with more than 10 recipients are always sent asynchronously, regardless of the value of async.
	    @option params {String} ip_pool the name of the dedicated ip pool that should be used to send the message. If you do not have any dedicated IPs, this parameter has no effect. If you specify a pool that does not exist, your default pool will be used instead.
	    @option params {String} send_at when this message should be sent as a UTC timestamp in YYYY-MM-DD HH:MM:SS format. If you specify a time in the past, the message will be sent immediately. An additional fee applies for scheduled email, and this feature is only available to accounts with a positive balance.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.send = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["async"] == null) {
	        params["async"] = false;
	      }
	      if (params["ip_pool"] == null) {
	        params["ip_pool"] = null;
	      }
	      if (params["send_at"] == null) {
	        params["send_at"] = null;
	      }
	      return this.master.call('messages/send', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Send a new transactional message through Mandrill using a template
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} template_name the immutable name or slug of a template that exists in the user's account. For backwards-compatibility, the template name may also be used but the immutable slug is preferred.
	    @option params {Array} template_content an array of template content to send.  Each item in the array should be a struct with two keys - name: the name of the content block to set the content for, and content: the actual content to put into the block
	         - template_content[] {Object} the injection of a single piece of content into a single editable region
	             - name {String} the name of the mc:edit editable region to inject into
	             - content {String} the content to inject
	    @option params {Struct} message the other information on the message to send - same as /messages/send, but without the html content
	         - html {String} optional full HTML content to be sent if not in template
	         - text {String} optional full text content to be sent
	         - subject {String} the message subject
	         - from_email {String} the sender email address.
	         - from_name {String} optional from name to be used
	         - to {Array} an array of recipient information.
	             - to[] {Object} a single recipient's information.
	                 - email {String} the email address of the recipient
	                 - name {String} the optional display name to use for the recipient
	                 - type {String} the header type to use for the recipient, defaults to "to" if not provided
	         - headers {Object} optional extra headers to add to the message (most headers are allowed)
	         - important {Boolean} whether or not this message is important, and should be delivered ahead of non-important messages
	         - track_opens {Boolean} whether or not to turn on open tracking for the message
	         - track_clicks {Boolean} whether or not to turn on click tracking for the message
	         - auto_text {Boolean} whether or not to automatically generate a text part for messages that are not given text
	         - auto_html {Boolean} whether or not to automatically generate an HTML part for messages that are not given HTML
	         - inline_css {Boolean} whether or not to automatically inline all CSS styles provided in the message HTML - only for HTML documents less than 256KB in size
	         - url_strip_qs {Boolean} whether or not to strip the query string from URLs when aggregating tracked URL data
	         - preserve_recipients {Boolean} whether or not to expose all recipients in to "To" header for each email
	         - view_content_link {Boolean} set to false to remove content logging for sensitive emails
	         - bcc_address {String} an optional address to receive an exact copy of each recipient's email
	         - tracking_domain {String} a custom domain to use for tracking opens and clicks instead of mandrillapp.com
	         - signing_domain {String} a custom domain to use for SPF/DKIM signing instead of mandrill (for "via" or "on behalf of" in email clients)
	         - return_path_domain {String} a custom domain to use for the messages's return-path
	         - merge {Boolean} whether to evaluate merge tags in the message. Will automatically be set to true if either merge_vars or global_merge_vars are provided.
	         - merge_language {String} the merge tag language to use when evaluating merge tags, either mailchimp or handlebars
	         - global_merge_vars {Array} global merge variables to use for all recipients. You can override these per recipient.
	             - global_merge_vars[] {Object} a single global merge variable
	                 - name {String} the global merge variable's name. Merge variable names are case-insensitive and may not start with _
	                 - content {Mixed} the global merge variable's content
	         - merge_vars {Array} per-recipient merge variables, which override global merge variables with the same name.
	             - merge_vars[] {Object} per-recipient merge variables
	                 - rcpt {String} the email address of the recipient that the merge variables should apply to
	                 - vars {Array} the recipient's merge variables
	                     - vars[] {Object} a single merge variable
	                         - name {String} the merge variable's name. Merge variable names are case-insensitive and may not start with _
	                         - content {Mixed} the merge variable's content
	         - tags {Array} an array of string to tag the message with.  Stats are accumulated using tags, though we only store the first 100 we see, so this should not be unique or change frequently.  Tags should be 50 characters or less.  Any tags starting with an underscore are reserved for internal use and will cause errors.
	             - tags[] {String} a single tag - must not start with an underscore
	         - subaccount {String} the unique id of a subaccount for this message - must already exist or will fail with an error
	         - google_analytics_domains {Array} an array of strings indicating for which any matching URLs will automatically have Google Analytics parameters appended to their query string automatically.
	         - google_analytics_campaign {Array|string} optional string indicating the value to set for the utm_campaign tracking parameter. If this isn't provided the email's from address will be used instead.
	         - metadata {Array} metadata an associative array of user metadata. Mandrill will store this metadata and make it available for retrieval. In addition, you can select up to 10 metadata fields to index and make searchable using the Mandrill search api.
	         - recipient_metadata {Array} Per-recipient metadata that will override the global values specified in the metadata parameter.
	             - recipient_metadata[] {Object} metadata for a single recipient
	                 - rcpt {String} the email address of the recipient that the metadata is associated with
	                 - values {Array} an associated array containing the recipient's unique metadata. If a key exists in both the per-recipient metadata and the global metadata, the per-recipient metadata will be used.
	         - attachments {Array} an array of supported attachments to add to the message
	             - attachments[] {Object} a single supported attachment
	                 - type {String} the MIME type of the attachment
	                 - name {String} the file name of the attachment
	                 - content {String} the content of the attachment as a base64-encoded string
	         - images {Array} an array of embedded images to add to the message
	             - images[] {Object} a single embedded image
	                 - type {String} the MIME type of the image - must start with "image/"
	                 - name {String} the Content ID of the image - use <img src="cid:THIS_VALUE"> to reference the image in your HTML content
	                 - content {String} the content of the image as a base64-encoded string
	    @option params {Boolean} async enable a background sending mode that is optimized for bulk sending. In async mode, messages/send will immediately return a status of "queued" for every recipient. To handle rejections when sending in async mode, set up a webhook for the 'reject' event. Defaults to false for messages with no more than 10 recipients; messages with more than 10 recipients are always sent asynchronously, regardless of the value of async.
	    @option params {String} ip_pool the name of the dedicated ip pool that should be used to send the message. If you do not have any dedicated IPs, this parameter has no effect. If you specify a pool that does not exist, your default pool will be used instead.
	    @option params {String} send_at when this message should be sent as a UTC timestamp in YYYY-MM-DD HH:MM:SS format. If you specify a time in the past, the message will be sent immediately. An additional fee applies for scheduled email, and this feature is only available to accounts with a positive balance.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.sendTemplate = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["async"] == null) {
	        params["async"] = false;
	      }
	      if (params["ip_pool"] == null) {
	        params["ip_pool"] = null;
	      }
	      if (params["send_at"] == null) {
	        params["send_at"] = null;
	      }
	      return this.master.call('messages/send-template', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Search recently sent messages and optionally narrow by date range, tags, senders, and API keys. If no date range is specified, results within the last 7 days are returned. This method may be called up to 20 times per minute. If you need the data more often, you can use <a href="/api/docs/messages.html#method=info">/messages/info.json</a> to get the information for a single message, or <a href="http://help.mandrill.com/entries/21738186-Introduction-to-Webhooks">webhooks</a> to push activity to your own application for querying.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} query <a href="http://help.mandrill.com/entries/22211902">search terms</a> to find matching messages
	    @option params {String} date_from start date
	    @option params {String} date_to end date
	    @option params {Array} tags an array of tag names to narrow the search to, will return messages that contain ANY of the tags
	    @option params {Array} senders an array of sender addresses to narrow the search to, will return messages sent by ANY of the senders
	    @option params {Array} api_keys an array of API keys to narrow the search to, will return messages sent by ANY of the keys
	    @option params {Integer} limit the maximum number of results to return, defaults to 100, 1000 is the maximum
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.search = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["query"] == null) {
	        params["query"] = '*';
	      }
	      if (params["date_from"] == null) {
	        params["date_from"] = null;
	      }
	      if (params["date_to"] == null) {
	        params["date_to"] = null;
	      }
	      if (params["tags"] == null) {
	        params["tags"] = null;
	      }
	      if (params["senders"] == null) {
	        params["senders"] = null;
	      }
	      if (params["api_keys"] == null) {
	        params["api_keys"] = null;
	      }
	      if (params["limit"] == null) {
	        params["limit"] = 100;
	      }
	      return this.master.call('messages/search', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Search the content of recently sent messages and return the aggregated hourly stats for matching messages
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} query the search terms to find matching messages for
	    @option params {String} date_from start date
	    @option params {String} date_to end date
	    @option params {Array} tags an array of tag names to narrow the search to, will return messages that contain ANY of the tags
	    @option params {Array} senders an array of sender addresses to narrow the search to, will return messages sent by ANY of the senders
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.searchTimeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["query"] == null) {
	        params["query"] = '*';
	      }
	      if (params["date_from"] == null) {
	        params["date_from"] = null;
	      }
	      if (params["date_to"] == null) {
	        params["date_to"] = null;
	      }
	      if (params["tags"] == null) {
	        params["tags"] = null;
	      }
	      if (params["senders"] == null) {
	        params["senders"] = null;
	      }
	      return this.master.call('messages/search-time-series', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Get the information for a single recently sent message
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique id of the message to get - passed as the "_id" field in webhooks, send calls, or search calls
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('messages/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Get the full content of a recently sent message
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique id of the message to get - passed as the "_id" field in webhooks, send calls, or search calls
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.content = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('messages/content', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Parse the full MIME document for an email message, returning the content of the message broken into its constituent pieces
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} raw_message the full MIME document of an email message
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.parse = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('messages/parse', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Take a raw MIME document for a message, and send it exactly as if it were sent through Mandrill's SMTP servers
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} raw_message the full MIME document of an email message
	    @option params {String|null} from_email optionally define the sender address - otherwise we'll use the address found in the provided headers
	    @option params {String|null} from_name optionally define the sender alias
	    @option params {Array|null} to optionally define the recipients to receive the message - otherwise we'll use the To, Cc, and Bcc headers provided in the document
	         - to[] {String} the email address of the recipient
	    @option params {Boolean} async enable a background sending mode that is optimized for bulk sending. In async mode, messages/sendRaw will immediately return a status of "queued" for every recipient. To handle rejections when sending in async mode, set up a webhook for the 'reject' event. Defaults to false for messages with no more than 10 recipients; messages with more than 10 recipients are always sent asynchronously, regardless of the value of async.
	    @option params {String} ip_pool the name of the dedicated ip pool that should be used to send the message. If you do not have any dedicated IPs, this parameter has no effect. If you specify a pool that does not exist, your default pool will be used instead.
	    @option params {String} send_at when this message should be sent as a UTC timestamp in YYYY-MM-DD HH:MM:SS format. If you specify a time in the past, the message will be sent immediately.
	    @option params {String} return_path_domain a custom domain to use for the messages's return-path
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.sendRaw = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["from_email"] == null) {
	        params["from_email"] = null;
	      }
	      if (params["from_name"] == null) {
	        params["from_name"] = null;
	      }
	      if (params["to"] == null) {
	        params["to"] = null;
	      }
	      if (params["async"] == null) {
	        params["async"] = false;
	      }
	      if (params["ip_pool"] == null) {
	        params["ip_pool"] = null;
	      }
	      if (params["send_at"] == null) {
	        params["send_at"] = null;
	      }
	      if (params["return_path_domain"] == null) {
	        params["return_path_domain"] = null;
	      }
	      return this.master.call('messages/send-raw', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Queries your scheduled emails by sender or recipient, or both.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} to an optional recipient address to restrict results to
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.listScheduled = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["to"] == null) {
	        params["to"] = null;
	      }
	      return this.master.call('messages/list-scheduled', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Cancels a scheduled email.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id a scheduled email id, as returned by any of the messages/send calls or messages/list-scheduled
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.cancelScheduled = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('messages/cancel-scheduled', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Reschedules a scheduled email.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id a scheduled email id, as returned by any of the messages/send calls or messages/list-scheduled
	    @option params {String} send_at the new UTC timestamp when the message should sent. Mandrill can't time travel, so if you specify a time in past the message will be sent immediately
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Messages.prototype.reschedule = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('messages/reschedule', params, onsuccess, onerror);
	    };
	
	    return Messages;
	
	  })();
	
	  Whitelists = (function() {
	    function Whitelists(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Adds an email to your email rejection whitelist. If the address is
	    currently on your blacklist, that blacklist entry will be removed
	    automatically.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email an email address to add to the whitelist
	    @option params {String} comment an optional description of why the email was whitelisted
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Whitelists.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["comment"] == null) {
	        params["comment"] = null;
	      }
	      return this.master.call('whitelists/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Retrieves your email rejection whitelist. You can provide an email
	    address or search prefix to limit the results. Returns up to 1000 results.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email an optional email address or prefix to search by
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Whitelists.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["email"] == null) {
	        params["email"] = null;
	      }
	      return this.master.call('whitelists/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Removes an email address from the whitelist.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} email the email address to remove from the whitelist
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Whitelists.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('whitelists/delete', params, onsuccess, onerror);
	    };
	
	    return Whitelists;
	
	  })();
	
	  Ips = (function() {
	    function Ips(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Lists your dedicated IPs.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Retrieves information about a single dedicated ip.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated IP address
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Requests an additional dedicated IP for your account. Accounts may
	    have one outstanding request at any time, and provisioning requests
	    are processed within 24 hours.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {Boolean} warmup whether to enable warmup mode for the ip
	    @option params {String} pool the id of the pool to add the dedicated ip to, or null to use your account's default pool
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.provision = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["warmup"] == null) {
	        params["warmup"] = false;
	      }
	      if (params["pool"] == null) {
	        params["pool"] = null;
	      }
	      return this.master.call('ips/provision', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Begins the warmup process for a dedicated IP. During the warmup process,
	    Mandrill will gradually increase the percentage of your mail that is sent over
	    the warming-up IP, over a period of roughly 30 days. The rest of your mail
	    will be sent over shared IPs or other dedicated IPs in the same pool.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated ip address
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.startWarmup = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/start-warmup', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Cancels the warmup process for a dedicated IP.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated ip address
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.cancelWarmup = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/cancel-warmup', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Moves a dedicated IP to a different pool.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated ip address
	    @option params {String} pool the name of the new pool to add the dedicated ip to
	    @option params {Boolean} create_pool whether to create the pool if it does not exist; if false and the pool does not exist, an Unknown_Pool will be thrown.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.setPool = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["create_pool"] == null) {
	        params["create_pool"] = false;
	      }
	      return this.master.call('ips/set-pool', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Deletes a dedicated IP. This is permanent and cannot be undone.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip the dedicated ip to remove from your account
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/delete', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Lists your dedicated IP pools.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.listPools = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/list-pools', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Describes a single dedicated IP pool.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} pool a pool name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.poolInfo = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/pool-info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Creates a pool and returns it. If a pool already exists with this
	    name, no action will be performed.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} pool the name of a pool to create
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.createPool = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/create-pool', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Deletes a pool. A pool must be empty before you can delete it, and you cannot delete your default pool.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} pool the name of the pool to delete
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.deletePool = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/delete-pool', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Tests whether a domain name is valid for use as the custom reverse
	    DNS for a dedicated IP.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated ip address
	    @option params {String} domain the domain name to test
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.checkCustomDns = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/check-custom-dns', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Configures the custom DNS name for a dedicated IP.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} ip a dedicated ip address
	    @option params {String} domain a domain name to set as the dedicated IP's custom dns name.
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Ips.prototype.setCustomDns = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('ips/set-custom-dns', params, onsuccess, onerror);
	    };
	
	    return Ips;
	
	  })();
	
	  Internal = (function() {
	    function Internal(master) {
	      this.master = master;
	    }
	
	    return Internal;
	
	  })();
	
	  Subaccounts = (function() {
	    function Subaccounts(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Get the list of subaccounts defined for the account, optionally filtered by a prefix
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} q an optional prefix to filter the subaccounts' ids and names
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["q"] == null) {
	        params["q"] = null;
	      }
	      return this.master.call('subaccounts/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add a new subaccount
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id a unique identifier for the subaccount to be used in sending calls
	    @option params {String} name an optional display name to further identify the subaccount
	    @option params {String} notes optional extra text to associate with the subaccount
	    @option params {Integer} custom_quota an optional manual hourly quota for the subaccount. If not specified, Mandrill will manage this based on reputation
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["name"] == null) {
	        params["name"] = null;
	      }
	      if (params["notes"] == null) {
	        params["notes"] = null;
	      }
	      if (params["custom_quota"] == null) {
	        params["custom_quota"] = null;
	      }
	      return this.master.call('subaccounts/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Given the ID of an existing subaccount, return the data about it
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of the subaccount to query
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('subaccounts/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Update an existing subaccount
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of the subaccount to update
	    @option params {String} name an optional display name to further identify the subaccount
	    @option params {String} notes optional extra text to associate with the subaccount
	    @option params {Integer} custom_quota an optional manual hourly quota for the subaccount. If not specified, Mandrill will manage this based on reputation
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.update = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["name"] == null) {
	        params["name"] = null;
	      }
	      if (params["notes"] == null) {
	        params["notes"] = null;
	      }
	      if (params["custom_quota"] == null) {
	        params["custom_quota"] = null;
	      }
	      return this.master.call('subaccounts/update', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete an existing subaccount. Any email related to the subaccount will be saved, but stats will be removed and any future sending calls to this subaccount will fail.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of the subaccount to delete
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('subaccounts/delete', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Pause a subaccount's sending. Any future emails delivered to this subaccount will be queued for a maximum of 3 days until the subaccount is resumed.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of the subaccount to pause
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.pause = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('subaccounts/pause', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Resume a paused subaccount's sending
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} id the unique identifier of the subaccount to resume
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Subaccounts.prototype.resume = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('subaccounts/resume', params, onsuccess, onerror);
	    };
	
	    return Subaccounts;
	
	  })();
	
	  Urls = (function() {
	    function Urls(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Get the 100 most clicked URLs
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the 100 most clicked URLs that match the search query given
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} q a search query
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.search = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/search', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the recent history (hourly stats for the last 30 days) for a url
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} url an existing URL
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.timeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/time-series', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Get the list of tracking domains set up for this account
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.trackingDomains = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/tracking-domains', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add a tracking domain to your account
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain a domain name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.addTrackingDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/add-tracking-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Checks the CNAME settings for a tracking domain. The domain must have been added already with the add-tracking-domain call
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain an existing tracking domain name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Urls.prototype.checkTrackingDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('urls/check-tracking-domain', params, onsuccess, onerror);
	    };
	
	    return Urls;
	
	  })();
	
	  Webhooks = (function() {
	    function Webhooks(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Get the list of all webhooks defined on the account
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Webhooks.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('webhooks/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add a new webhook
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} url the URL to POST batches of events
	    @option params {String} description an optional description of the webhook
	    @option params {Array} events an optional list of events that will be posted to the webhook
	         - events[] {String} the individual event to listen for
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Webhooks.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["description"] == null) {
	        params["description"] = null;
	      }
	      if (params["events"] == null) {
	        params["events"] = [];
	      }
	      return this.master.call('webhooks/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Given the ID of an existing webhook, return the data about it
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {Integer} id the unique identifier of a webhook belonging to this account
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Webhooks.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('webhooks/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Update an existing webhook
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {Integer} id the unique identifier of a webhook belonging to this account
	    @option params {String} url the URL to POST batches of events
	    @option params {String} description an optional description of the webhook
	    @option params {Array} events an optional list of events that will be posted to the webhook
	         - events[] {String} the individual event to listen for
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Webhooks.prototype.update = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["description"] == null) {
	        params["description"] = null;
	      }
	      if (params["events"] == null) {
	        params["events"] = [];
	      }
	      return this.master.call('webhooks/update', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete an existing webhook
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {Integer} id the unique identifier of a webhook belonging to this account
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Webhooks.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('webhooks/delete', params, onsuccess, onerror);
	    };
	
	    return Webhooks;
	
	  })();
	
	  Senders = (function() {
	    function Senders(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Return the senders that have tried to use this account.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Returns the sender domains that have been added to this account.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.domains = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/domains', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Adds a sender domain to your account. Sender domains are added automatically as you
	    send, but you can use this call to add them ahead of time.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain a domain name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.addDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/add-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Checks the SPF and DKIM settings for a domain. If you haven't already added this domain to your
	    account, it will be added automatically.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain a domain name
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.checkDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/check-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Sends a verification email in order to verify ownership of a domain.
	    Domain verification is an optional step to confirm ownership of a domain. Once a
	    domain has been verified in a Mandrill account, other accounts may not have their
	    messages signed by that domain unless they also verify the domain. This prevents
	    other Mandrill accounts from sending mail signed by your domain.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} domain a domain name at which you can receive email
	    @option params {String} mailbox a mailbox at the domain where the verification email should be sent
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.verifyDomain = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/verify-domain', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return more detailed information about a single sender, including aggregates of recent stats
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} address the email address of the sender
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.info = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/info', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Return the recent history (hourly stats for the last 30 days) for a sender
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} address the email address of the sender
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Senders.prototype.timeSeries = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('senders/time-series', params, onsuccess, onerror);
	    };
	
	    return Senders;
	
	  })();
	
	  Metadata = (function() {
	    function Metadata(master) {
	      this.master = master;
	    }
	
	
	    /*
	    Get the list of custom metadata fields indexed for the account.
	    @param {Object} params the hash of the parameters to pass to the request
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Metadata.prototype.list = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('metadata/list', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Add a new custom metadata field to be indexed for the account.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name a unique identifier for the metadata field
	    @option params {String} view_template optional Mustache template to control how the metadata is rendered in your activity log
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Metadata.prototype.add = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      if (params["view_template"] == null) {
	        params["view_template"] = null;
	      }
	      return this.master.call('metadata/add', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Update an existing custom metadata field.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the unique identifier of the metadata field to update
	    @option params {String} view_template optional Mustache template to control how the metadata is rendered in your activity log
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Metadata.prototype.update = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('metadata/update', params, onsuccess, onerror);
	    };
	
	
	    /*
	    Delete an existing custom metadata field. Deletion isn't instataneous, and /metadata/list will continue to return the field until the asynchronous deletion process is complete.
	    @param {Object} params the hash of the parameters to pass to the request
	    @option params {String} name the unique identifier of the metadata field to update
	    @param {Function} onsuccess an optional callback to execute when the API call is successfully made
	    @param {Function} onerror an optional callback to execute when the API call errors out - defaults to throwing the error as an exception
	     */
	
	    Metadata.prototype["delete"] = function(params, onsuccess, onerror) {
	      if (params == null) {
	        params = {};
	      }
	      if (typeof params === 'function') {
	        onerror = onsuccess;
	        onsuccess = params;
	        params = {};
	      }
	      return this.master.call('metadata/delete', params, onsuccess, onerror);
	    };
	
	    return Metadata;
	
	  })();
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8).Buffer))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(9)
	var ieee754 = __webpack_require__(10)
	var isArray = __webpack_require__(11)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var http = __webpack_require__(13);
	
	var https = module.exports;
	
	for (var key in http) {
	    if (http.hasOwnProperty(key)) https[key] = http[key];
	};
	
	https.request = function (params, cb) {
	    if (!params) params = {};
	    params.scheme = 'https';
	    params.protocol = 'https:';
	    return http.request.call(this, params, cb);
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(14)
	var extend = __webpack_require__(36)
	var statusCodes = __webpack_require__(37)
	var url = __webpack_require__(38)
	
	var http = exports
	
	http.request = function (opts, cb) {
		if (typeof opts === 'string')
			opts = url.parse(opts)
		else
			opts = extend(opts)
	
		// Normally, the page is loaded from http or https, so not specifying a protocol
		// will result in a (valid) protocol-relative url. However, this won't work if
		// the protocol is something else, like 'file:'
		var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''
	
		var protocol = opts.protocol || defaultProtocol
		var host = opts.hostname || opts.host
		var port = opts.port
		var path = opts.path || '/'
	
		// Necessary for IPv6 addresses
		if (host && host.indexOf(':') !== -1)
			host = '[' + host + ']'
	
		// This may be a relative url. The browser should always be able to interpret it correctly.
		opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
		opts.method = (opts.method || 'GET').toUpperCase()
		opts.headers = opts.headers || {}
	
		// Also valid opts.auth, opts.mode
	
		var req = new ClientRequest(opts)
		if (cb)
			req.on('response', cb)
		return req
	}
	
	http.get = function get (opts, cb) {
		var req = http.request(opts, cb)
		req.end()
		return req
	}
	
	http.Agent = function () {}
	http.Agent.defaultMaxSockets = 4
	
	http.STATUS_CODES = statusCodes
	
	http.METHODS = [
		'CHECKOUT',
		'CONNECT',
		'COPY',
		'DELETE',
		'GET',
		'HEAD',
		'LOCK',
		'M-SEARCH',
		'MERGE',
		'MKACTIVITY',
		'MKCOL',
		'MOVE',
		'NOTIFY',
		'OPTIONS',
		'PATCH',
		'POST',
		'PROPFIND',
		'PROPPATCH',
		'PURGE',
		'PUT',
		'REPORT',
		'SEARCH',
		'SUBSCRIBE',
		'TRACE',
		'UNLOCK',
		'UNSUBSCRIBE'
	]
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(15)
	var inherits = __webpack_require__(16)
	var response = __webpack_require__(17)
	var stream = __webpack_require__(18)
	var toArrayBuffer = __webpack_require__(35)
	
	var IncomingMessage = response.IncomingMessage
	var rStates = response.readyStates
	
	function decideMode (preferBinary, useFetch) {
		if (capability.fetch && useFetch) {
			return 'fetch'
		} else if (capability.mozchunkedarraybuffer) {
			return 'moz-chunked-arraybuffer'
		} else if (capability.msstream) {
			return 'ms-stream'
		} else if (capability.arraybuffer && preferBinary) {
			return 'arraybuffer'
		} else if (capability.vbArray && preferBinary) {
			return 'text:vbarray'
		} else {
			return 'text'
		}
	}
	
	var ClientRequest = module.exports = function (opts) {
		var self = this
		stream.Writable.call(self)
	
		self._opts = opts
		self._body = []
		self._headers = {}
		if (opts.auth)
			self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
		Object.keys(opts.headers).forEach(function (name) {
			self.setHeader(name, opts.headers[name])
		})
	
		var preferBinary
		var useFetch = true
		if (opts.mode === 'disable-fetch' || 'timeout' in opts) {
			// If the use of XHR should be preferred and includes preserving the 'content-type' header.
			// Force XHR to be used since the Fetch API does not yet support timeouts.
			useFetch = false
			preferBinary = true
		} else if (opts.mode === 'prefer-streaming') {
			// If streaming is a high priority but binary compatibility and
			// the accuracy of the 'content-type' header aren't
			preferBinary = false
		} else if (opts.mode === 'allow-wrong-content-type') {
			// If streaming is more important than preserving the 'content-type' header
			preferBinary = !capability.overrideMimeType
		} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
			// Use binary if text streaming may corrupt data or the content-type header, or for speed
			preferBinary = true
		} else {
			throw new Error('Invalid value for opts.mode')
		}
		self._mode = decideMode(preferBinary, useFetch)
	
		self.on('finish', function () {
			self._onFinish()
		})
	}
	
	inherits(ClientRequest, stream.Writable)
	
	ClientRequest.prototype.setHeader = function (name, value) {
		var self = this
		var lowerName = name.toLowerCase()
		// This check is not necessary, but it prevents warnings from browsers about setting unsafe
		// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
		// http-browserify did it, so I will too.
		if (unsafeHeaders.indexOf(lowerName) !== -1)
			return
	
		self._headers[lowerName] = {
			name: name,
			value: value
		}
	}
	
	ClientRequest.prototype.getHeader = function (name) {
		var header = this._headers[name.toLowerCase()]
		if (header)
			return header.value
		return null
	}
	
	ClientRequest.prototype.removeHeader = function (name) {
		var self = this
		delete self._headers[name.toLowerCase()]
	}
	
	ClientRequest.prototype._onFinish = function () {
		var self = this
	
		if (self._destroyed)
			return
		var opts = self._opts
	
		var headersObj = self._headers
		var body = null
		if (opts.method !== 'GET' && opts.method !== 'HEAD') {
			if (capability.blobConstructor) {
				body = new global.Blob(self._body.map(function (buffer) {
					return toArrayBuffer(buffer)
				}), {
					type: (headersObj['content-type'] || {}).value || ''
				})
			} else {
				// get utf8 string
				body = Buffer.concat(self._body).toString()
			}
		}
	
		// create flattened list of headers
		var headersList = []
		Object.keys(headersObj).forEach(function (keyName) {
			var name = headersObj[keyName].name
			var value = headersObj[keyName].value
			if (Array.isArray(value)) {
				value.forEach(function (v) {
					headersList.push([name, v])
				})
			} else {
				headersList.push([name, value])
			}
		})
	
		if (self._mode === 'fetch') {
			global.fetch(self._opts.url, {
				method: self._opts.method,
				headers: headersList,
				body: body || undefined,
				mode: 'cors',
				credentials: opts.withCredentials ? 'include' : 'same-origin'
			}).then(function (response) {
				self._fetchResponse = response
				self._connect()
			}, function (reason) {
				self.emit('error', reason)
			})
		} else {
			var xhr = self._xhr = new global.XMLHttpRequest()
			try {
				xhr.open(self._opts.method, self._opts.url, true)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
	
			// Can't set responseType on really old browsers
			if ('responseType' in xhr)
				xhr.responseType = self._mode.split(':')[0]
	
			if ('withCredentials' in xhr)
				xhr.withCredentials = !!opts.withCredentials
	
			if (self._mode === 'text' && 'overrideMimeType' in xhr)
				xhr.overrideMimeType('text/plain; charset=x-user-defined')
	
			if ('timeout' in opts) {
				xhr.timeout = opts.timeout
				xhr.ontimeout = function () {
					self.emit('timeout')
				}
			}
	
			headersList.forEach(function (header) {
				xhr.setRequestHeader(header[0], header[1])
			})
	
			self._response = null
			xhr.onreadystatechange = function () {
				switch (xhr.readyState) {
					case rStates.LOADING:
					case rStates.DONE:
						self._onXHRProgress()
						break
				}
			}
			// Necessary for streaming in Firefox, since xhr.response is ONLY defined
			// in onprogress, not in onreadystatechange with xhr.readyState = 3
			if (self._mode === 'moz-chunked-arraybuffer') {
				xhr.onprogress = function () {
					self._onXHRProgress()
				}
			}
	
			xhr.onerror = function () {
				if (self._destroyed)
					return
				self.emit('error', new Error('XHR error'))
			}
	
			try {
				xhr.send(body)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
		}
	}
	
	/**
	 * Checks if xhr.status is readable and non-zero, indicating no error.
	 * Even though the spec says it should be available in readyState 3,
	 * accessing it throws an exception in IE8
	 */
	function statusValid (xhr) {
		try {
			var status = xhr.status
			return (status !== null && status !== 0)
		} catch (e) {
			return false
		}
	}
	
	ClientRequest.prototype._onXHRProgress = function () {
		var self = this
	
		if (!statusValid(self._xhr) || self._destroyed)
			return
	
		if (!self._response)
			self._connect()
	
		self._response._onXHRProgress()
	}
	
	ClientRequest.prototype._connect = function () {
		var self = this
	
		if (self._destroyed)
			return
	
		self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode)
		self._response.on('error', function(err) {
			self.emit('error', err)
		})
	
		self.emit('response', self._response)
	}
	
	ClientRequest.prototype._write = function (chunk, encoding, cb) {
		var self = this
	
		self._body.push(chunk)
		cb()
	}
	
	ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
		var self = this
		self._destroyed = true
		if (self._response)
			self._response._destroyed = true
		if (self._xhr)
			self._xhr.abort()
		// Currently, there isn't a way to truly abort a fetch.
		// If you like bikeshedding, see https://github.com/whatwg/fetch/issues/27
	}
	
	ClientRequest.prototype.end = function (data, encoding, cb) {
		var self = this
		if (typeof data === 'function') {
			cb = data
			data = undefined
		}
	
		stream.Writable.prototype.end.call(self, data, encoding, cb)
	}
	
	ClientRequest.prototype.flushHeaders = function () {}
	ClientRequest.prototype.setTimeout = function () {}
	ClientRequest.prototype.setNoDelay = function () {}
	ClientRequest.prototype.setSocketKeepAlive = function () {}
	
	// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
	var unsafeHeaders = [
		'accept-charset',
		'accept-encoding',
		'access-control-request-headers',
		'access-control-request-method',
		'connection',
		'content-length',
		'cookie',
		'cookie2',
		'date',
		'dnt',
		'expect',
		'host',
		'keep-alive',
		'origin',
		'referer',
		'te',
		'trailer',
		'transfer-encoding',
		'upgrade',
		'user-agent',
		'via'
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)
	
	exports.blobConstructor = false
	try {
		new Blob([new ArrayBuffer(1)])
		exports.blobConstructor = true
	} catch (e) {}
	
	// The xhr request to example.com may violate some restrictive CSP configurations,
	// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
	// and assume support for certain features below.
	var xhr
	function getXHR () {
		// Cache the xhr value
		if (xhr !== undefined) return xhr
	
		if (global.XMLHttpRequest) {
			xhr = new global.XMLHttpRequest()
			// If XDomainRequest is available (ie only, where xhr might not work
			// cross domain), use the page location. Otherwise use example.com
			// Note: this doesn't actually make an http request.
			try {
				xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
			} catch(e) {
				xhr = null
			}
		} else {
			// Service workers don't have XHR
			xhr = null
		}
		return xhr
	}
	
	function checkTypeSupport (type) {
		var xhr = getXHR()
		if (!xhr) return false
		try {
			xhr.responseType = type
			return xhr.responseType === type
		} catch (e) {}
		return false
	}
	
	// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
	// Safari 7.1 appears to have fixed this bug.
	var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
	var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)
	
	// If fetch is supported, then arraybuffer will be supported too. Skip calling
	// checkTypeSupport(), since that calls getXHR().
	exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))
	
	// These next two tests unavoidably show warnings in Chrome. Since fetch will always
	// be used if it's available, just return false for these to avoid the warnings.
	exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
	exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
		checkTypeSupport('moz-chunked-arraybuffer')
	
	// If fetch is supported, then overrideMimeType will be supported too. Skip calling
	// getXHR().
	exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)
	
	exports.vbArray = isFunction(global.VBArray)
	
	function isFunction (value) {
		return typeof value === 'function'
	}
	
	xhr = null // Help gc
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(15)
	var inherits = __webpack_require__(16)
	var stream = __webpack_require__(18)
	
	var rStates = exports.readyStates = {
		UNSENT: 0,
		OPENED: 1,
		HEADERS_RECEIVED: 2,
		LOADING: 3,
		DONE: 4
	}
	
	var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode) {
		var self = this
		stream.Readable.call(self)
	
		self._mode = mode
		self.headers = {}
		self.rawHeaders = []
		self.trailers = {}
		self.rawTrailers = []
	
		// Fake the 'close' event, but only once 'end' fires
		self.on('end', function () {
			// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
			process.nextTick(function () {
				self.emit('close')
			})
		})
	
		if (mode === 'fetch') {
			self._fetchResponse = response
	
			self.url = response.url
			self.statusCode = response.status
			self.statusMessage = response.statusText
			
			response.headers.forEach(function(header, key){
				self.headers[key.toLowerCase()] = header
				self.rawHeaders.push(key, header)
			})
	
	
			// TODO: this doesn't respect backpressure. Once WritableStream is available, this can be fixed
			var reader = response.body.getReader()
			function read () {
				reader.read().then(function (result) {
					if (self._destroyed)
						return
					if (result.done) {
						self.push(null)
						return
					}
					self.push(new Buffer(result.value))
					read()
				}).catch(function(err) {
					self.emit('error', err)
				})
			}
			read()
	
		} else {
			self._xhr = xhr
			self._pos = 0
	
			self.url = xhr.responseURL
			self.statusCode = xhr.status
			self.statusMessage = xhr.statusText
			var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
			headers.forEach(function (header) {
				var matches = header.match(/^([^:]+):\s*(.*)/)
				if (matches) {
					var key = matches[1].toLowerCase()
					if (key === 'set-cookie') {
						if (self.headers[key] === undefined) {
							self.headers[key] = []
						}
						self.headers[key].push(matches[2])
					} else if (self.headers[key] !== undefined) {
						self.headers[key] += ', ' + matches[2]
					} else {
						self.headers[key] = matches[2]
					}
					self.rawHeaders.push(matches[1], matches[2])
				}
			})
	
			self._charset = 'x-user-defined'
			if (!capability.overrideMimeType) {
				var mimeType = self.rawHeaders['mime-type']
				if (mimeType) {
					var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
					if (charsetMatch) {
						self._charset = charsetMatch[1].toLowerCase()
					}
				}
				if (!self._charset)
					self._charset = 'utf-8' // best guess
			}
		}
	}
	
	inherits(IncomingMessage, stream.Readable)
	
	IncomingMessage.prototype._read = function () {}
	
	IncomingMessage.prototype._onXHRProgress = function () {
		var self = this
	
		var xhr = self._xhr
	
		var response = null
		switch (self._mode) {
			case 'text:vbarray': // For IE9
				if (xhr.readyState !== rStates.DONE)
					break
				try {
					// This fails in IE8
					response = new global.VBArray(xhr.responseBody).toArray()
				} catch (e) {}
				if (response !== null) {
					self.push(new Buffer(response))
					break
				}
				// Falls through in IE8	
			case 'text':
				try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
					response = xhr.responseText
				} catch (e) {
					self._mode = 'text:vbarray'
					break
				}
				if (response.length > self._pos) {
					var newData = response.substr(self._pos)
					if (self._charset === 'x-user-defined') {
						var buffer = new Buffer(newData.length)
						for (var i = 0; i < newData.length; i++)
							buffer[i] = newData.charCodeAt(i) & 0xff
	
						self.push(buffer)
					} else {
						self.push(newData, self._charset)
					}
					self._pos = response.length
				}
				break
			case 'arraybuffer':
				if (xhr.readyState !== rStates.DONE || !xhr.response)
					break
				response = xhr.response
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'moz-chunked-arraybuffer': // take whole
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING || !response)
					break
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'ms-stream':
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING)
					break
				var reader = new global.MSStreamReader()
				reader.onprogress = function () {
					if (reader.result.byteLength > self._pos) {
						self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
						self._pos = reader.result.byteLength
					}
				}
				reader.onload = function () {
					self.push(null)
				}
				// reader.onerror = ??? // TODO: this
				reader.readAsArrayBuffer(response)
				break
		}
	
		// The ms-stream case handles end separately in reader.onload()
		if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
			self.push(null)
		}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8).Buffer, (function() { return this; }())))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(28);
	exports.Duplex = __webpack_require__(27);
	exports.Transform = __webpack_require__(33);
	exports.PassThrough = __webpack_require__(34);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(20);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(11);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(4).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(21);
	/*</replacement>*/
	
	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(22).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(16);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(24);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(25);
	var destroyImpl = __webpack_require__(26);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(27);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(32).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(27);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(32).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4).EventEmitter;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(8)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(22).Buffer;
	/*</replacement>*/
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(20);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(20);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(16);
	/*</replacement>*/
	
	var Readable = __webpack_require__(19);
	var Writable = __webpack_require__(28);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(20);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(16);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(31)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(21);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(22).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(26);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(27);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(27);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(29).setImmediate, (function() { return this; }())))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(30);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(22).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(27);
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(16);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(33);
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(16);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(8).Buffer
	
	module.exports = function (buf) {
		// If the buffer is backed by a Uint8Array, a faster version will work
		if (buf instanceof Uint8Array) {
			// If the buffer isn't a subarray, return the underlying ArrayBuffer
			if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
				return buf.buffer
			} else if (typeof buf.buffer.slice === 'function') {
				// Otherwise we need to get a proper copy
				return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
			}
		}
	
		if (Buffer.isBuffer(buf)) {
			// This is the slow version that will work with any Buffer
			// implementation (even in old browsers)
			var arrayCopy = new Uint8Array(buf.length)
			var len = buf.length
			for (var i = 0; i < len; i++) {
				arrayCopy[i] = buf[i]
			}
			return arrayCopy.buffer
		} else {
			throw new Error('Argument must be a Buffer')
		}
	}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = {
	  "100": "Continue",
	  "101": "Switching Protocols",
	  "102": "Processing",
	  "200": "OK",
	  "201": "Created",
	  "202": "Accepted",
	  "203": "Non-Authoritative Information",
	  "204": "No Content",
	  "205": "Reset Content",
	  "206": "Partial Content",
	  "207": "Multi-Status",
	  "208": "Already Reported",
	  "226": "IM Used",
	  "300": "Multiple Choices",
	  "301": "Moved Permanently",
	  "302": "Found",
	  "303": "See Other",
	  "304": "Not Modified",
	  "305": "Use Proxy",
	  "307": "Temporary Redirect",
	  "308": "Permanent Redirect",
	  "400": "Bad Request",
	  "401": "Unauthorized",
	  "402": "Payment Required",
	  "403": "Forbidden",
	  "404": "Not Found",
	  "405": "Method Not Allowed",
	  "406": "Not Acceptable",
	  "407": "Proxy Authentication Required",
	  "408": "Request Timeout",
	  "409": "Conflict",
	  "410": "Gone",
	  "411": "Length Required",
	  "412": "Precondition Failed",
	  "413": "Payload Too Large",
	  "414": "URI Too Long",
	  "415": "Unsupported Media Type",
	  "416": "Range Not Satisfiable",
	  "417": "Expectation Failed",
	  "418": "I'm a teapot",
	  "421": "Misdirected Request",
	  "422": "Unprocessable Entity",
	  "423": "Locked",
	  "424": "Failed Dependency",
	  "425": "Unordered Collection",
	  "426": "Upgrade Required",
	  "428": "Precondition Required",
	  "429": "Too Many Requests",
	  "431": "Request Header Fields Too Large",
	  "451": "Unavailable For Legal Reasons",
	  "500": "Internal Server Error",
	  "501": "Not Implemented",
	  "502": "Bad Gateway",
	  "503": "Service Unavailable",
	  "504": "Gateway Timeout",
	  "505": "HTTP Version Not Supported",
	  "506": "Variant Also Negotiates",
	  "507": "Insufficient Storage",
	  "508": "Loop Detected",
	  "509": "Bandwidth Limit Exceeded",
	  "510": "Not Extended",
	  "511": "Network Authentication Required"
	}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(39);
	var util = __webpack_require__(40);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(41);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module), (function() { return this; }())))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(42);
	exports.encode = exports.stringify = __webpack_require__(43);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(45)
	var uuid = __webpack_require__(46)
	
	exports.response = function response(event, dataObject) {
	  return {
	    to: event.from,
	    from: event.to,
	    subject: event.subject + '-response',
	    verb: event.verb + '-response',
	    object: dataObject,
	    dateSubmitted: event.dateSubmitted,
	    duration: moment().diff(event.dateSubmitted)
	  }
	}
	
	exports.newEvent = function (subject, verb, object, actor) {
	  return {
	    from: uuid.v4(),
	    to: '/' + [subject, verb].join('/'),
	    subject: subject,
	    verb: verb,
	    object: object,
	    actor: actor,
	    dateSubmitted: moment().utc().format()
	  }
	}
	
	exports.responseError = function (event, dataObject) {
	 return {
	    to: event.from,
	    from: event.to,
	    subject: event.subject + '-error',
	    verb: event.verb + '-error',
	    object: dataObject,
	    dateSubmitted: event.dateSubmitted,
	    duration: moment().diff(event.dateSubmitted)
	  }
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.19.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.19.4';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var _rng = __webpack_require__(47);
	
	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i = 0; i < 256; i++) {
	  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i]] = i;
	}
	
	// **`parse()` - Parse a UUID into it's component bytes**
	function parse(s, buf, offset) {
	  var i = (buf && offset) || 0, ii = 0;
	
	  buf = buf || [];
	  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	    if (ii < 16) { // Don't overflow!
	      buf[i + ii++] = _hexToByte[oct];
	    }
	  });
	
	  // Zero out remaining bytes if string was short
	  while (ii < 16) {
	    buf[i + ii++] = 0;
	  }
	
	  return buf;
	}
	
	// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	function unparse(buf, offset) {
	  var i = offset || 0, bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = _rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; n++) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : unparse(b);
	}
	
	// **`v4()` - Generate random UUID**
	
	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ii++) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || unparse(rnds);
	}
	
	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	uuid.parse = parse;
	uuid.unparse = unparse;
	
	module.exports = uuid;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return _rnds;
	  };
	}
	
	module.exports = rng;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  url: '',
	  template: __webpack_require__(49),
	  controller: SiteController,
	  abstract: true
	};
	
	function SiteController($scope, $rootScope, $state, contentful, $window) {
	
	  $rootScope.goBack = function () {
	    $window.history.back();
	  };
	  var b = document.documentElement;
	  b.setAttribute('data-useragent', navigator.userAgent);
	  b.setAttribute('data-platform', navigator.platform);
	
	  var stateName = $state.current.name;
	
	  $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
	
	  $rootScope.$on('$stateChangeSuccess', function (e, newState, oldState) {
	    var stateName = newState.name;
	    $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
	  });
	
	  // b.className += ((!!('ontouchstart' in window) || !!('onmsgesturechange' in window))?' touch':'');
	
	  // var stateName = $state.current.name.split('.');
	  // $rootScope.currentPage = stateName.length > 1 ?
	  //   stateName[1] :
	  //   'splash';
	
	  // var stateName = $state.current.name;
	  // $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
	
	  // $rootScope.$on('$stateChangeSuccess', function (e, newState, oldState) {
	  //   var stateName = newState.name;
	  //   $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
	  // });
	
	  // $rootScope.$on('$stateChangeSuccess', function(e, newState, oldState) {
	  //   var stateName = newState.name.split('.');
	  //   $rootScope.currentPage = stateName.length > 1 ?
	  //     stateName[1] :
	  //     'splash';
	  // });
	}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"site-wrapper\" id=\"site-wrapper\">\n  <nav-header></nav-header>\n    <div ui-view class=\"page-{{currentPage}}\"></div>\n    <!-- <script\n    data-item_desc_font_color=\"#000000\"\n    data-item_price_font_color=\"#000000\"\n    data-item_title_font_color=\"#000000\"\n    data-menu_desc_background_color=\"#ffffff\"\n    data-menu_desc_font_color=\"#000000\"\n    data-primary_background_color=\"#ffffff\"\n    data-section_desc_font_color=\"#000000\"\n    data-section_title_font_color=\"#dc0000\"\n    data-stylesheet=\"https://www.parkcitypeaks.com/assets/css/styles.css https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta/css/bootstrap.min.css\"\n    data-hide_cover_photo=\"true\"\n    data-hide_disclaimer=\"true\"\n    data-location=\"versante-hearts-bar\"\n    data-api_key=\"ke09z8icq4xu8uiiccighy1bw\"\n    id=\"singleplatform-menu\"\n    src=\"https://menus.singleplatform.com/widget\"></script> -->\n  <nav-footer></nav-footer>\n</div>\n"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/',
		template: __webpack_require__(51),
		controller: HomeController,
		controllerAs: 'homeCtrl'
	};
	
	function HomeController($scope, $state, store, $window, contentful, $http) {
		var vm = this;
		$window.scrollTo(0, 0);
		contentful.entries('content_type=homePage').then(function (res) {
			// console.log('home page contentful data',res);
			$scope.home = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoPageTitle) {
				document.title = seoData.fields.seoPageTitle;
			}
			if (seoData.fields.seoPageDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoPageDescription;
					}
				}
			}
		});
	
		$window.sr = ScrollReveal({ reset: false });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('.home-test', { rotate: { x: 0, y: 0, z: 100 } });
	
		$('.tri-up a').click(function () {
			$('html, body').animate({
				scrollTop: window.pageYOffset + $(window).height()
			}, 300);
			return false;
		});
		function myFunction(x) {
			x.classList.toggle("change");
		}
	}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"homePage\">\n  <div ng-if='home.fields.popUp.fields.popUpActive == true' class=\"modal fade\" role=\"dialog\" id=\"ToggleAnnouncement\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"bg-primary\">\n      <ul class=\"text-center\">\n        <li><button type=\"button\" class=\"toggler nav-specials\" data-dismiss=\"modal\" aria-label=\"Close\">&times;</button></li>\n        <li class=\"text-white large\">\n          <h2>{{home.fields.popUp.fields.title}}</h2>\n          <h4>{{home.fields.popUp.fields.body}}</h4>\n          <a class=\"btn btn-primary btn-sm\" href=\"{{home.fields.popUp.fields.ctaButtonLink}}\" role=\"button\">{{home.fields.popUp.fields.ctaButtonLabel}}</a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n  <div id=\"myCarousel\" class=\"carousel slide banner\" data-ride=\"carousel\">\n    <div class=\"carousel-inner\">\n      <div class=\"carousel-item\" ng-class=\"{active:!$index}\" ng-repeat=\"slide in home.fields.homeSlider\">\n        <img class=\"first-slide mobile-hide\" src=\"{{slide.fields.homeDesktopImage.fields.file.url}}\" alt=\"{{slide.fields.homeDesktopImage.fields.title}}\">\n        <img class=\"first-slide desktop-hide\" src=\"{{slide.fields.homeMobileImage.fields.file.url}}?h=768\" alt=\"{{slide.fields.homeMobileImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"carousel-caption d-md-block\">\n            <h1>{{slide.fields.headline}} <a class=\"btn btn-link\" href=\"{{slide.fields.ctaButtonLink}}\" role=\"button\">{{slide.fields.ctaButtonLabel}}</a></h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <a id=\"control2\" class=\"carousel-control-prev\" data-target=\"#myCarousel\" role=\"button\" data-slide=\"prev\">\n         <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\n         <span class=\"sr-only\">Previous</span>\n       </a>\n    <a id=\"control\" class=\"carousel-control-next\" data-target=\"#myCarousel\" role=\"button\" data-slide=\"next\">\n         <span aria-hidden=\"true\"><i class=\"fa fa-2x fa-angle-right\" aria-hidden=\"true\"></i></span>\n         <span class=\"sr-only\">Next</span>\n       </a>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n           <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n         </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n  <div class=\"main\">\n    <div id=\"UD\" class=\"row bg-white no-gutters p-4 text-center home-load\">\n      <div class=\"col-lg-12 text-center pad-top-10\" style=\"max-width:650px;\">\n        <h2>{{home.fields.headline}}</h2>\n        <div data-marked='home.fields.body'></div>\n        <a class=\"btn btn-secondary\" href=\"{{home.fields.ctaButtonLink}}\" role=\"button\">{{home.fields.ctaButtonLabel}}</a>\n        <a ng-if=\"home.fields.link\" class=\"btn btn-secondary\" href=\"{{home.fields.link}}\" role=\"button\">{{home.fields.linkLabel}}</a>\n\n      </div>\n    </div>\n    <div class=\"row no-gutters home-load\">\n      <div class=\"col-md-7 order-md-1 bg-rooms-home\" style=\"background-image: url({{home.fields.section1Image.fields.file.url}}?h=400)\">\n      </div>\n      <div class=\"col-md-5 order-md-2 bg-blue p-4 text-white text-center p-twenty\">\n        <h2 style=\"font-weight:400;\">{{home.fields.section1Title}}</h2>\n        <div data-marked='home.fields.section1Body'></div>\n        <a class=\"btn btn-thethird\" href=\"{{home.fields.section1CtaLink}}\" role=\"button\">{{home.fields.section1CtaLabel}}</a>\n\n      </div>\n    </div>\n    <div class=\"row no-gutters home-load\">\n      <div class=\"col-md-5 order-md-1 mobile-order-2 bg-type-home text-center\">\n        <h4 class=\"text-right\">{{home.fields.picksSection.fields.name}} | {{home.fields.picksSection.fields.title}}</h4>\n        <img class=\"mx-auto d-block picks\" src=\"img/Peaks-Badge-icon.svg\" alt=\"Peaks Picks\">\n        <h3>{{home.fields.picksSection.fields.heading}}</h3>\n        <div data-marked='home.fields.picksSection.fields.body'></div>\n        <a class=\"btn btn-secondary\" href=\"/peaks-picks\" role=\"button\">Peaks Picks</a>\n        <img class=\"author-avatar rounded-circle border-white\" src=\"{{home.fields.picksSection.fields.image.fields.file.url}}?h=100\" alt=\"{{home.fields.picksSection.fields.image.fields.title}}\">\n      </div>\n      <div class=\"col-md-7 order-md-2 mobile-order-1 bg-picks-home\" style=\"background-image: url({{home.fields.picksSection.fields.pickImage.fields.file.url}}?h=400)\">\n      </div>\n    </div>\n  </div>\n"

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	  url: "/amenities",
	  template: __webpack_require__(53),
	  controller: AmenitiesController,
	  controllerAs: "amenitiesCtrl"
	};
	
	function AmenitiesController($scope, $state, store, $window, contentful, $http, Socialshare) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  contentful.entries("content_type=longPage&sys.id=3QZMQnJ5ocKaKCQQEiwogs").then(function (res) {
	    // console.log('amenities page contentful data',res);
	    $scope.amenities = res.data.items[0];
	    var seoData = res.data.items[0];
	    if (seoData.fields.seoPageTitle) {
	      document.title = seoData.fields.seoPageTitle;
	    }
	    if (seoData.fields.seoPageDescription) {
	      var meta = document.getElementsByTagName("meta");
	      for (var i = 0; i < meta.length; i++) {
	        if (meta[i].name.toLowerCase() === "description") {
	          meta[i].content = seoData.fields.seoPageDescription;
	        }
	      }
	    }
	  });
	  setTimeout(function () {
	    var elem = document.querySelector(".carousel");
	    var flkty = new Flickity(elem, {
	      imagesLoaded: true,
	      draggable: false,
	      percentPostion: false,
	      cellAlign: "center",
	      wrapAround: true,
	      lazyLoad: true,
	      pageDots: false,
	      autoPlay: true
	    });
	  }, 1000);
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ["$sce"];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  $window.sr = ScrollReveal({ reset: false });
	  sr.reveal(".home-load", { duration: 1000 });
	  sr.reveal("#cafe", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	  sr.reveal("#pool", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	  sr.reveal("#fitness", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	
	  setTimeout(function () {
	    // Open overlay when button is clicked
	    $(".show-blue").on("click", function () {
	      var contentID = $(this).data("target");
	      $("#" + contentID).toggleClass("reveal");
	      $(this).fadeOut(800, "linear");
	    });
	
	    $(".show-white").on("click", function () {
	      var contentID = $(this).data("target");
	      $("#" + contentID).toggleClass("reveal");
	      $(this).fadeOut(800, "linear");
	    });
	
	    // Close overlay when the outside of menu is clicked
	    $(".hide-blue").on("click", function () {
	      $(".overlay.bg-blue").addClass("conceal").delay(300).queue(function () {
	        $(".overlay.bg-blue").removeClass("conceal");
	        $(".overlay.bg-blue").removeClass("reveal");
	        $(this).dequeue();
	        $(".show-blue").fadeIn(800, "linear");
	      });
	    });
	    $(".hide-white").on("click", function () {
	      $(".overlay.bg-white").addClass("conceal").delay(300).queue(function () {
	        $(".overlay.bg-white").removeClass("conceal");
	        $(".overlay.bg-white").removeClass("reveal");
	        $(this).dequeue();
	        $(".show-white").fadeIn(800, "linear");
	      });
	    });
	  }, 1000);
	  vm.socialShare = function (share) {
	    if (share === "facebook") {
	      Socialshare.share({
	        provider: "facebook",
	        attrs: {
	          socialshareUrl: "http://peaks-hotel.herokuapp.com/amenities",
	          socialshareQuote: "Peaks Hotel | Amenities",
	          socialshareMedia: "https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "twitter") {
	      Socialshare.share({
	        provider: "twitter",
	        attrs: {
	          socialshareUrl: "http://peaks-hotel.herokuapp.com/amenities",
	          socialshareText: "Peaks Hotel | Amenities",
	          socialshareMedia: "https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "pinterest") {
	      Socialshare.share({
	        provider: "pinterest",
	        attrs: {
	          socialshareUrl: "http://peaks-hotel.herokuapp.com/amenities",
	          socialshareText: "Peaks Hotel | Amenities",
	          socialshareMedia: "https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "email") {
	      Socialshare.share({
	        provider: "email",
	        attrs: {
	          "socialshare-subject": "Peaks Hotel | Amenities",
	          "socialshare-body": "Take a look at the Peaks Hotel!"
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  //smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div id=\"amenities\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{amenities.fields.bannerImage.fields.file.url}}\" alt=\"{{amenities.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{amenities.fields.mobileBannerImage.fields.file.url}}?h=768\" alt=\"{{amenities.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{amenities.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n           <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n         </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n\n  <div class=\"main\">\n    <div class=\"row no-gutters home-load\">\n      <div class=\"col-md-7 order-md-1 bg-christy-amenities\" style=\"background: url({{amenities.fields.partnerSection.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n        <img class=\"author-avatar\" id=\"logo\" src=\"{{amenities.fields.partnerSection.fields.logo.fields.file.url}}\" alt=\"{{amenities.fields.partnerSection.fields.logo.fields.title}}\">\n      </div>\n      <div class=\"col-md-5 order-md-2 bg-christy-type-amenities text-center p-twenty\">\n        <h2>{{amenities.fields.partnerSection.fields.headline}}</h2>\n        <div data-marked='amenities.fields.partnerSection.fields.body'></div>\n        <p><a class=\"btn btn-secondary\" href=\"{{amenities.fields.partnerSection.fields.ctaButtonLink}}\" target=\"_blank\" role=\"button\">{{amenities.fields.partnerSection.fields.ctaButtonLabel}}</a></p>\n\n      </div>\n    </div>\n\n    <ng-container ng-repeat=\"section in amenities.fields.sections track by $index\">\n      <!-- Overlay Section -->\n      <div \n        class=\"overlay d-flex align-items-center text-center hide-blue hide-white\"\n        ng-class=\"$index % 2 === 0 ? 'pool bg-white text-center' : 'fitness bg-blue text-white text-center'\"\n        id=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">\n        <div>\n          <p ng-if=\"section.fields.icon\">\n            <img ng-src=\"{{ section.fields.icon.fields.file.url }}\" class=\"img-fluid am-icon\" alt=\"icon\" />\n          </p>\n          \n          <h2>{{ section.fields.interiorHeading }}</h2>\n          <div data-marked=\"section.fields.interiorBody\"></div>\n    \n          <!-- CTA Links -->\n          <p ng-if=\"section.fields.ctaAssetLink\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.ctaAssetLink.fields.file.url }}\"\n               target=\"_blank\">\n               {{ section.fields.ctaButtonLabel }}\n            </a>\n          </p>\n    \n          <p ng-if=\"section.fields.ctaButtonLink\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.ctaButtonLink }}\"\n               target=\"_blank\" aria-label=\"view virtual tour\">\n               {{ section.fields.ctaButtonLabel }}\n            </a>\n          </p>\n    \n          <p ng-if=\"section.fields.externalLinkUrl\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.externalLinkUrl }}\"\n               target=\"_blank\" aria-label=\"view virtual tour\">\n               {{ section.fields.externalLink }}\n            </a>\n          </p>\n    \n          <button class=\"toggler\"\n                  ng-class=\"$index % 2 === 0 ? 'hide-white' : 'hide-blue'\"\n                  type=\"button\"\n                  data-target=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">&times;</button>\n        </div>\n      </div>\n    \n      <!-- Background Section -->\n      <div class=\"row no-gutters home-load\">\n        <div id=\"hover-button\"\n             class=\"col-lg-12 text-center\"\n             ng-class=\"$index % 2 === 0 ? 'amenities-pool' : 'amenities-fitness'\"\n             style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button \n            id=\"{{ $index % 2 === 0 ? ('pool-'+$index) : ('fitness-'+$index) }}\" \n            class=\"btn btn-primary\" \n            ng-class=\"$index % 2 === 0 ? 'show-white hide-blue' : 'show-blue hide-white'\"\n            type=\"button\"\n            data-target=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">\n            {{ section.fields.title }}\n          </button>\n        </div>\n      </div>\n    </ng-container>\n  \n \n\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n              </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12 d-none\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"amenitiesCtrl.socialShare('facebook')\"><i class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"amenitiesCtrl.socialShare('twitter')\"> <i class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"amenitiesCtrl.socialShare('pinterest')\"> <i class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"amenitiesCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                    <!-- <div class=\"body\"></div> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"carousel\">\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[0].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[0].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[0].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[1].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[1].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[1].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[2].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[2].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[2].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[3].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[3].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[3].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[4].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[4].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[4].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[5].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[5].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[5].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{amenities.fields.slider.fields.images[6].sys.id}}\" data-title=\"{{amenities.fields.slider.fields.images[6].fields.description}}\">\n        <img src=\"{{amenities.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{amenities.fields.slider.fields.images[6].fields.title}}\" />\n      </div>\n    </div>\n    </div>\n    <script>\n      jQuery.noConflict();\n      jQuery(document).ready(function($) {\n        var $card = $('.img'),\n          $modal = $('#modal');\n\n        $card.click(this, function() {\n          var $this = $(this),\n            $thisImage = $this.find('img'),\n            $thisTitle = $this.data('title'),\n            $thisBody = $this.data('body'),\n            $thisDate = $this.data('date');\n\n          $modal.find('.header h2').html($thisTitle);\n          $modal.find('.meta').html($thisDate);\n          $modal.find('.body').html($thisBody);\n          $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n          $modal.modal();\n        })\n      });\n    </script>\n\n  </div>\n</div>\n"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/activities',
		template: __webpack_require__(55),
		controller: ActivitiesController,
		controllerAs: 'activitiesCtrl'
	};
	
	function ActivitiesController($scope, $state, store, $window, contentful, $http, Socialshare) {
		var vm = this;
		$window.scrollTo(0, 0);
		contentful.entries('content_type=longPage&sys.id=6lihlx6Jx3qQKDZdOnnqQ4').then(function (res) {
			// console.log('activities page contentful data', res);
			$scope.activities = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoPageTitle) {
				document.title = seoData.fields.seoPageTitle;
			}
			if (seoData.fields.seoPageDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoPageDescription;
					}
				}
			}
		});
		setTimeout(function () {
			var elem = document.querySelector('.carousel');
			var flkty = new Flickity(elem, {
				imagesLoaded: true,
				draggable: false,
				percentPostion: false,
				cellAlign: 'center',
				wrapAround: true,
				lazyLoad: true,
				pageDots: false,
				autoPlay: true
			});
		}, 1000);
		vm.trustUrl = "trustUrl";
	
		trustUrl.$inject = ['$sce'];
	
		function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}
	
		$window.sr = ScrollReveal({
			reset: false
		});
		sr.reveal('.home-load', {
			duration: 1000
		});
		sr.reveal('#cafe', {
			distance: 0,
			duration: 1000,
			scale: 1.5
		}, 500);
		sr.reveal('#pool', {
			distance: 0,
			duration: 1000,
			scale: 1.5
		}, 500);
		sr.reveal('#fitness', {
			distance: 0,
			duration: 1000,
			scale: 1.5
		}, 500);
	
		setTimeout(function () {
	
			// Open overlay when button is clicked
			$('.show-blue').on('click', function () {
				var contentID = $(this).data('target');
				$('#' + contentID).toggleClass('reveal');
				$(this).fadeOut(800, 'linear');
			});
	
			$('.show-white').on('click', function () {
				var contentID = $(this).data('target');
				$('#' + contentID).toggleClass('reveal');
				$(this).fadeOut(800, 'linear');
			});
	
			// Close overlay when the outside of menu is clicked
			$('.hide-blue').on('click', function () {
				$('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
					$('.overlay.bg-blue').removeClass('conceal');
					$('.overlay.bg-blue').removeClass('reveal');
					$(this).dequeue();
					$(".show-blue").fadeIn(800, 'linear');
				});
			});
			$('.hide-white').on('click', function () {
				$('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
					$('.overlay.bg-white').removeClass('conceal');
					$('.overlay.bg-white').removeClass('reveal');
					$(this).dequeue();
					$(".show-white").fadeIn(800, 'linear');
				});
			});
		}, 1000);
		vm.socialShare = function (share) {
			if (share === 'facebook') {
				Socialshare.share({
					'provider': 'facebook',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/activities',
						'socialshareQuote': 'Peaks Hotel | Activities',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'twitter') {
				Socialshare.share({
					'provider': 'twitter',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/activities',
						'socialshareText': 'Peaks Hotel | Activities',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'pinterest') {
				Socialshare.share({
					'provider': 'pinterest',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/activities',
						'socialshareText': 'Peaks Hotel | Activities',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'email') {
				Socialshare.share({
					'provider': 'email',
					'attrs': {
						'socialshare-subject': 'Peaks Hotel | Activities',
						'socialshare-body': 'Take a look at the Peaks Hotel!'
					}
				});
			}
		};
	}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  //smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div id=\"amenities\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{activities.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{activities.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{activities.fields.mobileBannerImage.fields.file.url}}?h=768\"\n          alt=\"{{activities.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{activities.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div class=\"main\" style=\"border-top: 10px solid #fff;\">\n    <ng-container ng-repeat=\"section in activities.fields.sections track by $index\">\n      <!-- Overlay Section -->\n      <div \n        class=\"overlay d-flex align-items-center text-center hide-blue hide-white\"\n        ng-class=\"$index % 2 === 0 ? 'pool bg-white text-center' : 'fitness bg-blue text-white text-center'\"\n        id=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">\n        <div>\n          <p ng-if=\"section.fields.icon\">\n            <img ng-src=\"{{ section.fields.icon.fields.file.url }}\" class=\"img-fluid am-icon\" alt=\"icon\" />\n          </p>\n          \n          <h2>{{ section.fields.interiorHeading }}</h2>\n          <div data-marked=\"section.fields.interiorBody\"></div>\n    \n          <!-- CTA Links -->\n          <p ng-if=\"section.fields.ctaAssetLink\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.ctaAssetLink.fields.file.url }}\"\n               target=\"_blank\">\n               {{ section.fields.ctaButtonLabel }}\n            </a>\n          </p>\n    \n          <p ng-if=\"section.fields.ctaButtonLink\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.ctaButtonLink }}\"\n               target=\"_blank\" aria-label=\"view virtual tour\">\n               {{ section.fields.ctaButtonLabel }}\n            </a>\n          </p>\n    \n          <p ng-if=\"section.fields.externalLinkUrl\" class=\"p-0\">\n            <a class=\"buy-now\"\n               ng-class=\"$index % 2 === 0 ? 'btn-secondary' : 'btn-thethird'\"\n               ng-href=\"{{ section.fields.externalLinkUrl }}\"\n               target=\"_blank\" aria-label=\"view virtual tour\">\n               {{ section.fields.externalLink }}\n            </a>\n          </p>\n    \n          <button class=\"toggler\"\n                  ng-class=\"$index % 2 === 0 ? 'hide-white' : 'hide-blue'\"\n                  type=\"button\"\n                  data-target=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">&times;</button>\n        </div>\n      </div>\n    \n      <!-- Background Section -->\n      <div class=\"row no-gutters home-load\">\n        <div id=\"hover-button\"\n             class=\"col-lg-12 text-center\"\n             ng-class=\"$index % 2 === 0 ? 'amenities-pool' : 'amenities-fitness'\"\n             style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button \n            id=\"{{ $index % 2 === 0 ? ('pool-'+$index) : ('fitness-'+$index) }}\" \n            class=\"btn btn-primary\" \n            ng-class=\"$index % 2 === 0 ? 'show-white hide-blue' : 'show-blue hide-white'\"\n            type=\"button\"\n            data-target=\"{{ $index % 2 === 0 ? ('pool-overlay-'+$index) : ('fitness-overlay-'+$index) }}\">\n            {{ section.fields.title }}\n          </button>\n        </div>\n      </div>\n    </ng-container>\n  \n\n\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"\n        aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                    <span aria-hidden=\"true\">\n                      <p><i class=\"fa fa-close\"></i></p>\n                    </span>\n                  </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"activitiesCtrl.socialShare('facebook')\"><i\n                            class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"activitiesCtrl.socialShare('twitter')\"> <i\n                            class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"activitiesCtrl.socialShare('pinterest')\"> <i\n                            class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"activitiesCtrl.socialShare('email')\"> <i\n                            class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                    <!-- <div class=\"body\"></div> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"carousel\">\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[0].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[0].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[0].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[1].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[1].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[1].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[2].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[2].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[2].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[3].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[3].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[3].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[4].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[4].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[4].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[5].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[5].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[5].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{activities.fields.slider.fields.images[6].sys.id}}\"\n        data-title=\"{{activities.fields.slider.fields.images[6].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{activities.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{activities.fields.slider.fields.images[6].fields.title}}\" />\n      </div>\n    </div>\n  </div>\n  <script>\n    jQuery.noConflict();\n    jQuery(document).ready(function ($) {\n      var $card = $('.img'),\n        $modal = $('#modal');\n\n      $card.click(this, function () {\n        var $this = $(this),\n          $thisImage = $this.find('img'),\n          $thisTitle = $this.data('title'),\n          $thisBody = $this.data('body'),\n          $thisDate = $this.data('date');\n\n        $modal.find('.header h2').html($thisTitle);\n        $modal.find('.meta').html($thisDate);\n        $modal.find('.body').html($thisBody);\n        $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n        $modal.modal();\n      })\n    });\n  </script>\n\n</div>\n</div>"

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  url: '/rooms',
	  template: __webpack_require__(57),
	  controller: RoomsController,
	  controllerAs: 'roomsCtrl'
	};
	
	function RoomsController($scope, $state, store, $window, contentful, $http, Socialshare, $document) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  contentful.entries('content_type=longPage&sys.id=2xzUWEuR7yKGeoa86MEMYM').then(function (res) {
	    // console.log('meetings page contentful data',res);
	    $scope.rooms = res.data.items[0];
	    var seoData = res.data.items[0];
	    if (seoData.fields.seoPageTitle) {
	      document.title = seoData.fields.seoPageTitle;
	    }
	    if (seoData.fields.seoPageDescription) {
	      var meta = document.getElementsByTagName("meta");
	      for (var i = 0; i < meta.length; i++) {
	        if (meta[i].name.toLowerCase() === "description") {
	          meta[i].content = seoData.fields.seoPageDescription;
	        }
	      }
	    }
	  });
	  setTimeout(function () {
	    var elem = document.querySelector('.carousel');
	    var flkty = new Flickity(elem, {
	      imagesLoaded: true,
	      draggable: false,
	      percentPostion: false,
	      cellAlign: 'center',
	      wrapAround: true,
	      lazyLoad: true,
	      pageDots: false,
	      autoPlay: true
	    });
	  }, 1000);
	
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ['$sce'];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  $window.sr = ScrollReveal({
	    reset: false
	  });
	  sr.reveal('.home-load', {
	    duration: 1000
	  });
	  sr.reveal('#cafe', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#pool', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#king-suite', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	
	  setTimeout(function () {
	
	    $('.show-blue').on('click', function () {
	      var contentID = $(this).data('target');
	      $('#' + contentID).toggleClass('reveal');
	      $(this).fadeOut(800, 'linear');
	    });
	
	    $('.show-white').on('click', function () {
	      var contentID = $(this).data('target');
	      $('#' + contentID).toggleClass('reveal');
	      $(this).fadeOut(800, 'linear');
	    });
	
	    // Close overlay when the outside of menu is clicked
	    $('.hide-blue').on('click', function () {
	      $('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
	        $('.overlay.bg-blue').removeClass('conceal');
	        $('.overlay.bg-blue').removeClass('reveal');
	        $(this).dequeue();
	        $(".show-blue").fadeIn(800, 'linear');
	      });
	    });
	    $('.hide-white').on('click', function () {
	      $('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
	        $('.overlay.bg-white').removeClass('conceal');
	        $('.overlay.bg-white').removeClass('reveal');
	        $(this).dequeue();
	        $(".show-white").fadeIn(800, 'linear');
	      });
	    });
	  }, 1000);
	  vm.socialShare = function (share) {
	    if (share === 'facebook') {
	      Socialshare.share({
	        'provider': 'facebook',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareQuote': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'twitter') {
	      Socialshare.share({
	        'provider': 'twitter',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareText': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'pinterest') {
	      Socialshare.share({
	        'provider': 'pinterest',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareText': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'email') {
	      Socialshare.share({
	        'provider': 'email',
	        'attrs': {
	          'socialshare-subject': 'Peaks Hotel | Rooms',
	          'socialshare-body': 'Take a look at the Peaks Hotel!'
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  // smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div id=\"rooms\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{rooms.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{rooms.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{rooms.fields.mobileBannerImage.fields.file.url}}?h=768\"\n          alt=\"{{rooms.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{rooms.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div class=\"main\" style=\"border-top: 10px solid #fff;\">\n    <div class=\"pool overlay bg-white d-flex align-items-center text-center hide-blue hide-white\" id=\"king-overlay\">\n      <div>\n        <h2>{{rooms.fields.sections[0].fields.interiorHeading}}</h2>\n        <div data-marked='rooms.fields.sections[0].fields.interiorBody'></div>\n        <div>\n          <a ng-if=\"rooms.fields.sections[0].fields.ctaButtonLink\" class=\"buy-now btn-secondary\"\n            href=\"{{rooms.fields.sections[0].fields.ctaButtonLink}}\">{{rooms.fields.sections[0].fields.ctaButtonLabel}}</a>\n          <a ng-if=\"rooms.fields.sections[0].fields.externalLinkUrl\" class=\"buy-now btn-secondary\"\n            href=\"{{rooms.fields.sections[0].fields.externalLinkUrl}}\" target=\"_blank\"\n            aria-label=\"view virtual tour on Visiting Media's Website\">{{rooms.fields.sections[0].fields.externalLink}}</a>\n        </div>\n        <button class=\"toggler hide-white\" type=\"button\" data-target=\"king-overlay\">&times;</button>\n\n      </div>\n    </div>\n    <div class=\"row no-gutters\">\n      <div id=\"hover-button\" class=\"col-lg-12 text-center rooms-king\"\n        style=\"background: url({{rooms.fields.sections[0].fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n        <button id=\"pool\" class=\"btn btn-primary show-white hide-blue\" type=\"button\"\n          data-target=\"king-overlay\">{{rooms.fields.sections[0].fields.title}}</button>\n      </div>\n    </div>\n\n\n    <div class=\"mercato overlay bg-blue d-flex align-items-center text-white text-center hide-blue hide-white\"\n      id=\"queen-overlay\">\n      <div>\n        <h2>{{rooms.fields.sections[1].fields.interiorHeading}}</h2>\n        <div data-marked='rooms.fields.sections[1].fields.interiorBody'></div>\n        <div>\n          <a ng-if=\"rooms.fields.sections[1].fields.ctaButtonLink\" class=\"buy-now btn-thethird\"\n            href=\"{{rooms.fields.sections[1].fields.ctaButtonLink}}\">{{rooms.fields.sections[1].fields.ctaButtonLabel}}</a>\n          <a ng-if=\"rooms.fields.sections[1].fields.externalLinkUrl\" class=\"buy-now  btn-thethird\"\n            href=\"{{rooms.fields.sections[1].fields.externalLinkUrl}}\" target=\"_blank\"\n            aria-label=\"view virtual tour on Visiting Media's Website\">{{rooms.fields.sections[1].fields.externalLink}}</a>\n        </div>\n        <button class=\"toggler hide-white\" type=\"button\" data-target=\"queen-overlay\">&times;</button>\n\n      </div>\n    </div>\n    <div class=\"row no-gutters\">\n      <div id=\"hover-button\" class=\"col-lg-12 text-center rooms-queen\"\n        style=\"background: url({{rooms.fields.sections[1].fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n        <button id=\"cafe\" class=\"btn btn-primary show-blue hide-white\" type=\"button\"\n          data-target=\"queen-overlay\">{{rooms.fields.sections[1].fields.title}}</button>\n      </div>\n    </div>\n\n\n\n    <div class=\"pool overlay bg-white d-flex align-items-center text-center hide-blue hide-white\"\n      id=\"king-suite-overlay\">\n      <div>\n        <h2>{{rooms.fields.sections[2].fields.interiorHeading}}</h2>\n        <div data-marked='rooms.fields.sections[2].fields.interiorBody'></div>\n        <div>\n          <a ng-if=\"rooms.fields.sections[2].fields.ctaButtonLink\" class=\"buy-now btn-secondary\"\n            href=\"{{rooms.fields.sections[2].fields.ctaButtonLink}}\">{{rooms.fields.sections[2].fields.ctaButtonLabel}}</a>\n          <a ng-if=\"rooms.fields.sections[2].fields.externalLinkUrl\" class=\"buy-now btn-secondary\"\n            href=\"{{rooms.fields.sections[2].fields.externalLinkUrl}}\" target=\"_blank\"\n            aria-label=\"view virtual tour on Visiting Media's Website\">{{rooms.fields.sections[2].fields.externalLink}}</a>\n        </div>\n        <button class=\"toggler hide-white\" type=\"button\" data-target=\"king-suite-overlay\">&times;</button>\n\n      </div>\n    </div>\n    <div class=\"row no-gutters\">\n      <div id=\"hover-button\" class=\"col-lg-12 text-center rooms-king-suite\"\n        style=\"background: url({{rooms.fields.sections[2].fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n        <button id=\"king-suite\" class=\"btn btn-primary show-white hide-blue\" type=\"button\"\n          data-target=\"king-suite-overlay\">{{rooms.fields.sections[2].fields.title}}</button>\n      </div>\n    </div>\n\n\n    <div ng-if=\"rooms.fields.sections[3]\"\n      class=\"mercato overlay bg-blue d-flex align-items-center text-white text-center hide-blue hide-white\"\n      id=\"queen-overlay\">\n      <div>\n        <h2>{{rooms.fields.sections[3].fields.interiorHeading}}</h2>\n        <div data-marked='rooms.fields.sections[3].fields.interiorBody'></div>\n        <div>\n          <a ng-if=\"rooms.fields.sections[3].fields.ctaButtonLink\" class=\"buy-now btn-thethird\"\n            href=\"{{rooms.fields.sections[3].fields.ctaButtonLink}}\">{{rooms.fields.sections[3].fields.ctaButtonLabel}}</a>\n          <a ng-if=\"rooms.fields.sections[3].fields.externalLinkUrl\" class=\"buy-now  btn-thethird\"\n            href=\"{{rooms.fields.sections[3].fields.externalLinkUrl}}\" target=\"_blank\"\n            aria-label=\"view virtual tour on Visiting Media's Website\">{{rooms.fields.sections[3].fields.externalLink}}</a>\n        </div>\n\n        <button class=\"toggler hide-white\" type=\"button\" data-target=\"king-suite-overlay\">&times;</button>\n\n\n      </div>\n    </div>\n    <div ng-if=\"rooms.fields.sections[3]\" class=\"row no-gutters\">\n      <div id=\"hover-button\" class=\"col-lg-12 text-center rooms-queen\"\n        style=\"background: url({{rooms.fields.sections[3].fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n        <button id=\"cafe\" class=\"btn btn-primary show-blue hide-white\" type=\"button\"\n          data-target=\"queen-overlay\">{{rooms.fields.sections[3].fields.title}}</button>\n      </div>\n    </div>\n\n\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"\n        aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                    <span aria-hidden=\"true\">\n                      <p><i class=\"fa fa-close\"></i></p>\n                    </span>\n                  </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"roomsCtrl.socialShare('facebook')\"><i\n                            class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"roomsCtrl.socialShare('twitter')\"> <i\n                            class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"roomsCtrl.socialShare('pinterest')\"> <i\n                            class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"roomsCtrl.socialShare('email')\"> <i\n                            class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"carousel\">\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[0].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[0].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[0].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[0].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[1].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[1].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[1].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[1].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[2].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[2].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[2].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[2].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[3].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[3].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[3].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[3].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[4].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[4].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[4].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[4].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[5].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[5].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[5].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[5].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{rooms.fields.slider.fields.images[6].sys.id}}\"\n        data-title=\"{{rooms.fields.slider.fields.images[6].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{rooms.fields.slider.fields.images[6].fields.file.url}}?h=375\"\n          alt=\"{{rooms.fields.slider.fields.images[6].fields.title}}\" />\n      </div>\n    </div>\n    <script>\n      jQuery.noConflict();\n      jQuery(document).ready(function ($) {\n        //     var elem = document.querySelector('.carousel');\n        // var flkty = new Flickity( elem, {\n        //   imagesLoaded: true,\n        //   draggable: false,\n        //   percentPostion: false,\n        //   cellAlign: 'center',\n        //   wrapAround: true,\n        //   lazyLoad: true,\n        //   pageDots: false,\n        //   autoPlay: true\n        // });\n        // $('.carousel-rooms').flickity({\n        //   'imagesLoaded': true,\n        //   'draggable': false,\n        //   'percentPostion': false,\n        //   'cellAlign': 'center',\n        //   'wrapAround': true,\n        //   'lazyLoad': true,\n        //   'pageDots': false,\n        //   'autoPlay': true\n        // });\n\n        var $card = $('.img'),\n          $modal = $('#modal');\n\n        $card.click(this, function () {\n          var $this = $(this),\n            $thisImage = $this.find('img'),\n            $thisTitle = $this.data('title'),\n            $thisBody = $this.data('body'),\n            $thisDate = $this.data('date');\n\n          $modal.find('.header h2').html($thisTitle);\n          $modal.find('.meta').html($thisDate);\n          $modal.find('.body').html($thisBody);\n          $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n          $modal.modal();\n        })\n      });\n    </script>\n\n  </div>\n</div>"

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	  url: "/meetings-and-events",
	  template: __webpack_require__(59),
	  controller: MeetingAndEventsController,
	  controllerAs: "meetingAndEventsCtrl"
	};
	
	function MeetingAndEventsController($scope, $state, store, $window, contentful, $http, Socialshare) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  contentful.entries("content_type=longPage&sys.id=7bCL1KEt5CwEmKM24qUiyu").then(function (res) {
	    console.log("meetings page contentful data", res);
	    $scope.meetings = res.data.items[0];
	    var seoData = res.data.items[0];
	    if (seoData.fields.seoPageTitle) {
	      document.title = seoData.fields.seoPageTitle;
	    }
	    if (seoData.fields.seoPageDescription) {
	      var meta = document.getElementsByTagName("meta");
	      for (var i = 0; i < meta.length; i++) {
	        if (meta[i].name.toLowerCase() === "description") {
	          meta[i].content = seoData.fields.seoPageDescription;
	        }
	      }
	    }
	  });
	  vm.showForm = true;
	  vm.showConfirmationLayer = false;
	  vm.showErrorLayer = false;
	
	  vm.submitForm = function (formValid) {
	    if (formValid) {
	      var postUrl = "/api/email";
	      var reason = "test";
	      if (vm.contactForm.company) {
	        vm.company = vm.contactForm.company;
	      } else {
	        vm.company = "N/A";
	      }
	      var obj = {
	        fromName: vm.contactForm.firstName + " " + vm.contactForm.lastName,
	        fromEmail: vm.contactForm.email,
	        fromCompany: vm.company,
	        toName: "Sales",
	        toEmail: "sales@parkcitypeaks.com",
	        toCc: "nikki@parkcitypeaks.com",
	        toBcc: "hoseasandstrom@gmail.com",
	        subject: document.title,
	        interest: vm.contactForm.interest,
	        phone: vm.contactForm.phone,
	        emailBody: vm.contactForm.comments
	      };
	
	      // FAKE FORM POST FOR DEVELOPMENT
	      // console.log('valid, emailing ' + obj.toEmail)
	      // vm.showConfirmationLayer = true;
	      // $timeout(function(){
	      //   vm.contactForm = '';
	      //   vm.showConfirmationLayer = false;
	      // }, 5000);
	
	      $http.post(postUrl, obj).then(function success(res) {
	        console.log("success: ", res);
	        vm.showForm = false;
	        vm.showConfirmationLayer = true;
	        // $timeout(function() {
	        // 	vm.contactForm = '';
	        // 	vm.showConfirmationLayer = false;
	        // }, 10000);
	      }, function error(err) {
	        console.log("error: ", err);
	        window.glob = err;
	        vm.showErrorLayer = true;
	        $timeout(function () {
	          vm.contactForm = "";
	          vm.showErrorLayer = false;
	        }, 5000);
	      });
	    } else {
	      console.log("form invalid");
	    }
	  };
	  setTimeout(function () {
	    var elem = document.querySelector(".carousel");
	    var flkty = new Flickity(elem, {
	      imagesLoaded: true,
	      draggable: false,
	      percentPostion: false,
	      cellAlign: "center",
	      wrapAround: true,
	      lazyLoad: true,
	      pageDots: false,
	      autoPlay: true
	    });
	  }, 1000);
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ["$sce"];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  $window.sr = ScrollReveal({ reset: false });
	  sr.reveal(".home-load", { duration: 1000 });
	  sr.reveal("#cafe", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	  sr.reveal("#pool", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	  sr.reveal("#fitness", { distance: 0, duration: 1000, scale: 1.5 }, 500);
	
	  // Open overlay when button is clicked
	  $(".show-blue").on("click", function () {
	    var contentID = $(this).data("target");
	    $("#" + contentID).toggleClass("reveal");
	    $(this).fadeOut(800, "linear");
	  });
	
	  $(".show-white").on("click", function () {
	    var contentID = $(this).data("target");
	    $("#" + contentID).toggleClass("reveal");
	    $(this).fadeOut(800, "linear");
	  });
	
	  // Close overlay when the outside of menu is clicked
	  $(".hide-blue").on("click", function () {
	    $(".overlay.bg-blue").addClass("conceal").delay(300).queue(function () {
	      $(".overlay.bg-blue").removeClass("conceal");
	      $(".overlay.bg-blue").removeClass("reveal");
	      $(this).dequeue();
	      $(".show-blue").fadeIn(800, "linear");
	    });
	  });
	  $(".hide-white").on("click", function () {
	    $(".overlay.bg-white").addClass("conceal").delay(300).queue(function () {
	      $(".overlay.bg-white").removeClass("conceal");
	      $(".overlay.bg-white").removeClass("reveal");
	      $(this).dequeue();
	      $(".show-white").fadeIn(800, "linear");
	    });
	  });
	  vm.socialShare = function (share) {
	    if (share === "facebook") {
	      Socialshare.share({
	        provider: "facebook",
	        attrs: {
	          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
	          socialshareQuote: "Peaks Hotel | Meetings & Events",
	          socialshareMedia: "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "twitter") {
	      Socialshare.share({
	        provider: "twitter",
	        attrs: {
	          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
	          socialshareText: "Peaks Hotel | Meetings & Events",
	          socialshareMedia: "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "pinterest") {
	      Socialshare.share({
	        provider: "pinterest",
	        attrs: {
	          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
	          socialshareText: "Peaks Hotel | Meetings & Events",
	          socialshareMedia: "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
	          socialsharePopupHeight: "400",
	          socialsharePopupWidth: "400"
	        }
	      });
	    } else if (share === "email") {
	      Socialshare.share({
	        provider: "email",
	        attrs: {
	          "socialshare-subject": "Peaks Hotel | Meetings & Events",
	          "socialshare-body": "Take a look at the Peaks Hotel!"
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  //smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div id=\"meetings-and-events\">\n\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{meetings.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{meetings.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{meetings.fields.mobileBannerImage.fields.file.url}}?h=768\"\n          style=\"min-height: 100%;\" alt=\"{{meetings.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{meetings.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div id=\"meetings-page\" class=\"main\">\n    <div class=\"wrap\">\n      <div class=\"container\">\n        <section class=\"no-gutters main-body container-fluid\">\n     \n          <div class=\"floorplans\">\n            <section ng-repeat=\"item in meetings.fields.sections track by $index\" class=\"home-load\" \n            ng-class=\"{\n              'full-width': ($index + 1) % 4 === 1,\n              'half-width': ($index + 1) % 4 === 2 || ($index + 1) % 4 === 3,\n              'events': $first\n            }\"          \n            ng-style=\"item.fields.backgroundImage ? {'background': 'url(' + item.fields.backgroundImage.fields.file.url + ') center no-repeat', 'background-size': 'cover'} : {}\"\n            >\n            <ng-container ng-if=\"item.fields.backgroundOverlay === true\">\n              <div class=\"floorplan-overlay\"></div>\n              <div class=\"d-flex flex-column align-items-center justify-content-center\">\n                <h1 >{{item.fields.title}}</h1>\n                <h2>{{item.fields.interiorHeading}}</h2>\n                <div data-marked='item.fields.interiorBody'></div>\n                <a ng-if=\"item.fields.ctaButtonLink\" class=\"btn btn-thefourth\" href=\"{{item.fields.ctaButtonLink}}\"\n                  target=\"_blank\" rel=\"noopener noreferrer\"><span ng-if=\"item.fields.ctaButtonLabel\"> </span>{{item.fields.ctaButtonLabel}}</a>\n                <a ng-if=\"item.fields.ctaAssetLink\" class=\"btn btn-thefourth\" href=\"{{item.fields.ctaAssetLink.fields.file.url}}\"\n                  target=\"_blank\" rel=\"noopener noreferrer\"><span ng-if=\"item.fields.ctaButtonLabel\"> </span>{{item.fields.ctaButtonLabel}}</a>\n                <a ng-if=\"item.fields.externalLinkUrl\" class=\"btn btn-thefourth\" href=\"{{item.fields.externalLinkUrl}}\"\n                  target=\"_blank\" rel=\"noopener noreferrer\">{{item.fields.externalLink}}</a>\n              </div>\n            </ng-container>\n            <ng-container ng-if=\"item.fields.backgroundOverlay === false\">\n              \n              <div class=\"d-flex flex-column align-items-center justify-content-center\">\n                <h1 ng-if=\"item.fields.title\" style=\"color: #164c65\">{{item.fields.title}}</h1>\n                <h2 ng-if=\"item.fields.interiorHeading\" style=\"color: #164c65\">{{item.fields.interiorHeading}}</h2>\n                <div data-marked='item.fields.interiorBody' style=\"color: #164c65\"></div>\n                <div id=\"hover-button\" class=\"col-lg-12 text-center absolute-center\">\n                  <a ng-if=\"item.fields.ctaAssetLink\" id=\"cafe\" class=\"btn btn-secondary\"\n                  href=\"{{item.fields.ctaAssetLink.fields.file.url}}\"\n                  target=\"_blank\" rel=\"noopener noreferrer\">{{item.fields.ctaButtonLabel}}</a>\n                <a ng-if=\"item.fields.externalLinkUrl\" id=\"cafe\" class=\"btn btn-secondary\"\n                  href=\"{{item.fields.externalLinkUrl}}\" target=\"_blank\"\n                  rel=\"noopener noreferrer\">{{item.fields.externalLink}}</a>\n\n                </div>\n               \n              </div>\n              <div class=\"d-flex flex-column align-items-center justify-content-center\"> \n              <div style=\"margin-bottom: -6em\">\n                <a ng-if=\"item.fields.iconLink\" aria-label=\"got to the Versante Page\" href=\"{{item.fields.iconLink}}\"><img\n                  src=\"{{item.fields.icon.fields.file.url}}\" alt=\"{{item.fields.icon.fields.title}}\"></a>\n                  </div>\n                  </div>\n            </ng-container>\n          </section>\n          </div>\n       \n        </section>\n        <aside class=\"meeting-and-events-contact container-fluid home-load\">\n          <div class=\"center-me col-lg-12 text-center pad-top-10\" style=\"max-width:350px;\">\n            <h1 class=\"text-center\">Plan your next event</h1>\n            <p>Get in touch today to work with our in-house event coordinator. Make your next gathering outstanding.</p>\n          </div>\n          <div class=\"center-me col-lg-12 text-center pad-top-10\" style=\"max-width:350px;\">\n            <div class=\"emailConfirmationLayer\" data-ng-show=\"meetingAndEventsCtrl.showForm\">\n              <div class=\"emailConfirmationLayer\" data-ng-show=\"meetingAndEventsCtrl.showForm\">\n                <form id=contactform class=\"well form-horizontal\" name=\"userForm\"\n                  data-ng-submit=\"meetingAndEventsCtrl.submitForm(userForm.$valid)\">\n\n                  <!-- Form group for name -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"first name\" name=\"inputfirstname\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.firstName\" placeholder=\"FIRST NAME\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"last name\" name=\"inputlastname\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.lastName\" placeholder=\"LAST NAME\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"company\" name=\"inputcompany\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.company\" placeholder=\"COMPANY\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\">\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for email + phone -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"email\" name=\"inputemail\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.email\" placeholder=\"EMAIL\"\n                          class=\"form-control contact-text\" type=\"email\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"phone\" name=\"inputphone\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.phone\" placeholder=\"PHONE\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <select aria-label=\"select\" class=\"contact-text minimal\" id=\"l1\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.interest\" required>\n                          <option value=\"\" disabled selected>I'M INTERESTED IN</option>\n                          <option aria-label=\"meeting\">Meeting</option>\n                          <option aria-label=\"reception\">Reception</option>\n                          <option aria-label=\"private event\">Private Event</option>\n                          <option aria-label=\"other\">Other</option>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for comment -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <textarea aria-label=\"comment\" name=\"inputcomment\"\n                          data-ng-model=\"meetingAndEventsCtrl.contactForm.comments\" placeholder=\"MESSAGE\"\n                          class=\"form-control contact-text\" maxlength=\"1000\" required></textarea>\n                      </div>\n                    </div>\n                  </div>\n\n\n                  <!-- Form group for button  -->\n                  <div class=\"spacer\"></div>\n                  <div class=\"form-group\">\n                    <div class=\"col-md-4 inputGroupContainer\">\n                      <div class=\"input-group justify-center\">\n                        <button aria-label=\"submit\" type=\"submit\" class=\"btn btn-primary\"\n                          style=\"font-size:12px;\">SUBMIT</button>\n                      </div>\n                    </div>\n                  </div>\n                </form>\n              </div>\n            </div>\n            <div class=\"contactContent\">\n              <div class=\"row\" style=\"min-height:0;\">\n                <div class=\"emailConfirmationLayer\" data-ng-show=\"meetingAndEventsCtrl.showConfirmationLayer\">\n                  <h2 class=\"tk-clarendon-wide\">SUCCESS!</h2>\n                  <p class=\"futuraHeavy text-uppercase\">Thanks for your interest in Peaks Hotel. We'll get back to you\n                    just as soon as we can.</p>\n                  <p>Return to our\n                    <a href=\"/\">homepage.</a>\n                  </p>\n                </div>\n                <div class=\"emailConfirmationLayer\" data-ng-show=\"meetingAndEventsCtrl.showErrorLayer\">\n                  <h2 class=\"tk-clarendon-wide\">WE'RE SORRY!</h2>\n                  <p class=\"futuraHeavy text-uppercase\">An error occurred while trying to deliver your message through\n                    the website. You can reach us at <a\n                      href=\"mailto:guestservices@parkcitypeaks.com\">guestservices@parkcitypeaks.com</a>.</p>\n                  <p>Return to our\n                    <a href=\"/\">homepage.</a>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </aside>\n      </div>\n    </div>\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"\n        aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                    <span aria-hidden=\"true\">\n                      <p><i class=\"fa fa-close\"></i></p>\n                    </span>\n                  </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"meetingAndEventsCtrl.socialShare('facebook')\"><i\n                            class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"meetingAndEventsCtrl.socialShare('twitter')\"> <i\n                            class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"meetingAndEventsCtrl.socialShare('pinterest')\"> <i\n                            class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"meetingAndEventsCtrl.socialShare('email')\"> <i\n                            class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                    <!-- <div class=\"body\"></div> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div id=\"footerCarousel\">\n      <div class=\"carousel\">\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[0].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[0].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[0].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[1].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[1].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[1].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[2].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[2].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[2].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[3].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[3].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[3].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[4].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[4].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[4].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[5].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[5].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[5].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[6].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[6].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[6].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[7].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[7].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[7].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[7].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[8].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[8].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[8].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[8].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{meetings.fields.slider.fields.images[9].sys.id}}\"\n          data-title=\"{{meetings.fields.slider.fields.images[9].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{meetings.fields.slider.fields.images[9].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n            alt=\"{{meetings.fields.slider.fields.images[9].fields.title}}\" />\n        </div>\n      </div>\n    </div>\n \n  </div>\n</div>\n<script>\n  jQuery.noConflict();\n  jQuery(document).ready(function ($) {\n\n    var $card = $('.img'),\n      $modal = $('#modal');\n\n    $card.click(this, function () {\n      var $this = $(this),\n        $thisImage = $this.find('img'),\n        $thisTitle = $this.data('title'),\n        $thisBody = $this.data('body'),\n        $thisDate = $this.data('date');\n\n      $modal.find('.header h2').html($thisTitle);\n      $modal.find('.meta').html($thisDate);\n      $modal.find('.body').html($thisBody);\n      $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n      $modal.modal();\n    })\n  });\n</script>\n\n</div>\n</div>\n"

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  url: '/weddings',
	  template: __webpack_require__(61),
	  controller: WeddingsController,
	  controllerAs: 'weddingsCtrl'
	};
	
	function WeddingsController($scope, $state, store, $window, contentful, $http, Socialshare, $timeout) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  contentful.entries('content_type=longPage&sys.id=4GmahswIVaa64Ooau0qS2k').then(function (res) {
	    console.log('weddings page contentful data', res);
	    $scope.weddings = res.data.items[0];
	    $scope.cateringImage = $scope.weddings.fields.sections[4].fields.image.fields.file.url;
	    console.log('Catering Image', $scope.cateringImage);
	    var seoData = res.data.items[0];
	    if (seoData.fields.seoPageTitle) {
	      document.title = seoData.fields.seoPageTitle;
	    }
	    if (seoData.fields.seoPageDescription) {
	      var meta = document.getElementsByTagName("meta");
	      for (var i = 0; i < meta.length; i++) {
	        if (meta[i].name.toLowerCase() === "description") {
	          meta[i].content = seoData.fields.seoPageDescription;
	        }
	      }
	    }
	  });
	  vm.showForm = true;
	  vm.showConfirmationLayer = false;
	  vm.showErrorLayer = false;
	
	  vm.submitForm = function (formValid) {
	    if (!vm.contactForm.luncheon) {
	      vm.contactForm.luncheon = '';
	    } else {
	      vm.contactForm.luncheon = 'Bridal Luncheon';
	    }
	
	    if (!vm.contactForm.dinner) {
	      vm.contactForm.dinner = '';
	    } else {
	      vm.contactForm.dinner = 'Rehearsal Dinner';
	    }
	
	    if (!vm.contactForm.welcomeReception) {
	      vm.contactForm.welcomeReception = '';
	    } else {
	      vm.contactForm.welcomeReception = 'Welcome Reception';
	    }
	
	    if (!vm.contactForm.ceremony) {
	      vm.contactForm.ceremony = '';
	    } else {
	      vm.contactForm.ceremony = 'Ceremony';
	    }
	
	    if (!vm.contactForm.reception) {
	      vm.contactForm.reception = '';
	    } else {
	      vm.contactForm.reception = 'Reception';
	    }
	
	    if (!vm.contactForm.brunch) {
	      vm.contactForm.brunch = '';
	    } else {
	      vm.contactForm.brunch = 'Brunch';
	    }
	
	    if (!vm.contactForm.blocks) {
	      vm.contactForm.blocks = '';
	    } else {
	      vm.contactForm.blocks = 'Room Blocks';
	    }
	
	    if (!vm.contactForm.pEmail) {
	      vm.contactForm.pEmail = '';
	    } else {
	      vm.contactForm.pEmail = 'EMAIL';
	    }
	
	    if (!vm.contactForm.pPhone) {
	      vm.contactForm.pPhone = '';
	    } else {
	      vm.contactForm.pPhone = 'PHONE';
	    }
	
	    if (formValid) {
	      var postUrl = "/api/weddings";
	      var reason = "test";
	      var obj = {
	        fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
	        fromEmail: vm.contactForm.email,
	        toName: 'Wedding Coordinator',
	        toEmail: 'parkcitypeaks.weddings@ldhg.com',
	        subject: document.title,
	        phone: vm.contactForm.phone,
	        number: vm.contactForm.number,
	        arrive: vm.contactForm.arrive,
	        leave: vm.contactForm.leave,
	        bride: vm.contactForm.bride,
	        groom: vm.contactForm.groom,
	        relationship: vm.contactForm.relationship,
	        luncheon: vm.contactForm.luncheon,
	        dinner: vm.contactForm.dinner,
	        welcomeReception: vm.contactForm.welcomeReception,
	        ceremony: vm.contactForm.ceremony,
	        reception: vm.contactForm.reception,
	        brunch: vm.contactForm.brunch,
	        blocks: vm.contactForm.blocks,
	        pEmail: vm.contactForm.pEmail,
	        pPhone: vm.contactForm.pPhone,
	        emailBody: vm.contactForm.comments
	      };
	
	      // FAKE FORM POST FOR DEVELOPMENT
	      // console.log('valid, emailing ' + obj.toEmail)
	      // vm.showConfirmationLayer = true;
	      // $timeout(function(){
	      //   vm.contactForm = '';
	      //   vm.showConfirmationLayer = false;
	      // }, 5000);
	
	      $http.post(postUrl, obj).then(function success(res) {
	        console.log('success: ', res);
	        vm.showForm = false;
	        vm.showConfirmationLayer = true;
	        // $timeout(function() {
	        // 	vm.contactForm = '';
	        // 	vm.showConfirmationLayer = false;
	        // }, 10000);
	      }, function error(err) {
	        console.log('error: ', err);
	        window.glob = err;
	        vm.showErrorLayer = true;
	        $timeout(function () {
	          vm.contactForm = '';
	          vm.showErrorLayer = false;
	        }, 5000);
	      });
	    } else {
	      console.log("form invalid");
	    }
	  };
	  setTimeout(function () {
	    var elem = document.querySelector('.carousel');
	    var flkty = new Flickity(elem, {
	      imagesLoaded: true,
	      draggable: false,
	      percentPostion: false,
	      cellAlign: 'center',
	      wrapAround: true,
	      lazyLoad: true,
	      pageDots: false,
	      autoPlay: true
	    });
	  }, 1000);
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ['$sce'];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  $window.sr = ScrollReveal({
	    reset: false
	  });
	  sr.reveal('.home-load', {
	    duration: 1000
	  });
	  sr.reveal('#cafe', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#pool', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#fitness', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	
	  // Open overlay when button is clicked
	  $('.show-blue').on('click', function () {
	    var contentID = $(this).data('target');
	    $('#' + contentID).toggleClass('reveal');
	    $(this).fadeOut(800, 'linear');
	  });
	
	  $('.show-white').on('click', function () {
	    var contentID = $(this).data('target');
	    $('#' + contentID).toggleClass('reveal');
	    $(this).fadeOut(800, 'linear');
	  });
	
	  // Close overlay when the outside of menu is clicked
	  $('.hide-blue').on('click', function () {
	    $('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
	      $('.overlay.bg-blue').removeClass('conceal');
	      $('.overlay.bg-blue').removeClass('reveal');
	      $(this).dequeue();
	      $(".show-blue").fadeIn(800, 'linear');
	    });
	  });
	  $('.hide-white').on('click', function () {
	    $('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
	      $('.overlay.bg-white').removeClass('conceal');
	      $('.overlay.bg-white').removeClass('reveal');
	      $(this).dequeue();
	      $(".show-white").fadeIn(800, 'linear');
	    });
	  });
	  vm.socialShare = function (share) {
	    if (share === 'facebook') {
	      Socialshare.share({
	        'provider': 'facebook',
	        'attrs': {
	          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
	          'socialshareQuote': 'Peaks Hotel | Weddings',
	          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'twitter') {
	      Socialshare.share({
	        'provider': 'twitter',
	        'attrs': {
	          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
	          'socialshareText': 'Peaks Hotel | Weddings',
	          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'pinterest') {
	      Socialshare.share({
	        'provider': 'pinterest',
	        'attrs': {
	          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
	          'socialshareText': 'Peaks Hotel | Weddings',
	          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'email') {
	      Socialshare.share({
	        'provider': 'email',
	        'attrs': {
	          'socialshare-subject': 'Peaks Hotel | Weddings',
	          'socialshare-body': 'Park City Peaks Hotel Weddings'
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  //smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div id=\"meetings-and-events\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{weddings.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{weddings.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{weddings.fields.bannerImage.fields.file.url}}?h=768\" style=\"min-height: 100%;\"\n          alt=\"{{weddings.fields.bannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{weddings.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div id=\"wedding-page\" class=\"main\">\n    <div class=\"wrap\">\n      <div class=\"container\">\n        <section class=\"no-gutters main-body container-fluid events\">\n          <section class=\"events home-load\">\n            <div class=\"center-me col-lg-12 text-center pad-top-10\" style=\"max-width:650px;\">\n              <h1>{{weddings.fields.sections[0].fields.title}}</h1>\n              <div data-marked='weddings.fields.sections[0].fields.interiorBody'></div>\n            </div>\n          </section>\n          <style>\n            #need-bullets ul {\n              list-style-type: square !important;\n              text-align: left !important;\n              padding: .1em 0 0 2em;\n            }\n          </style>\n          <div id=\"need-bullets\" class=\"floorplans d-flex flex-column flex-md-row\">\n            <section class=\"aspen\"\n              ng-style=\"{'background': 'linear-gradient(0deg, rgba(22, 76, 101, 0.7), rgba(22, 76, 101, 0.7)), url(' + weddings.fields.sections[2].fields.image.fields.file.url + ') center center / cover no-repeat'}\">\n              <h1>{{weddings.fields.sections[2].fields.title}}</h1>\n              <h2>{{weddings.fields.sections[2].fields.interiorHeading}}</h2>\n              <div class=\"fp-interior\" data-marked=\"weddings.fields.sections[2].fields.interiorBody\"></div>\n              <a ng-if=\"weddings.fields.sections[2].fields.ctaAssetLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[2].fields.ctaAssetLink.fields.file.url}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[2].fields.ctaButtonLabel}}</a>\n              <a ng-if=\"weddings.fields.sections[2].fields.ctaButtonLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[2].fields.ctaButtonLink}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[2].fields.ctaButtonLabel}}</a>\n            </section>\n            <section class=\"spruce\"\n              ng-style=\"{'background': 'linear-gradient(0deg, rgba(22, 76, 101, 0.7), rgba(22, 76, 101, 0.7)), url(' + weddings.fields.sections[3].fields.image.fields.file.url + ') center center / cover no-repeat'}\">\n              <h1>{{weddings.fields.sections[3].fields.title}}</h1>\n              <h2>{{weddings.fields.sections[3].fields.interiorHeading}}</h2>\n              <div class=\"fp-interior\" data-marked=\"weddings.fields.sections[3].fields.interiorBody\"></div>\n              <a ng-if=\"weddings.fields.sections[3].fields.ctaAssetLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[3].fields.ctaAssetLink.fields.file.url}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[3].fields.ctaButtonLabel}}</a>\n              <a ng-if=\"weddings.fields.sections[3].fields.ctaButtonLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[3].fields.ctaButtonLink}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[3].fields.ctaButtonLabel}}</a>\n            </section>\n            <section class=\"spruce\"\n              ng-style=\"{'background': 'linear-gradient(0deg, rgba(22, 76, 101, 0.7), rgba(22, 76, 101, 0.7)), url(' + weddings.fields.sections[4].fields.image.fields.file.url + ') center center / cover no-repeat'}\">\n              <h1>{{weddings.fields.sections[4].fields.title}}</h1>\n              <h2>{{weddings.fields.sections[4].fields.interiorHeading}}</h2>\n              <div class=\"fp-interior\" data-marked=\"weddings.fields.sections[4].fields.interiorBody\"></div>\n              <a ng-if=\"weddings.fields.sections[4].fields.ctaAssetLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[4].fields.ctaAssetLink.fields.file.url}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[4].fields.ctaButtonLabel}}</a>\n\n              <a ng-if=\"weddings.fields.sections[4].fields.ctaButtonLink\" class=\"btn btn-thefourth\"\n                href=\"{{weddings.fields.sections[4].fields.ctaButtonLink}}\" target=\"_blank\"\n                rel=\"noopener noreferrer\">{{weddings.fields.sections[4].fields.ctaButtonLabel}}</a>\n\n            </section>\n          </div>\n          <section class=\"events no-gutters\">\n            <style>\n              #section-two ul {\n                list-style-type: square !important;\n                text-align: left !important;\n                padding: 0 0 0 4em;\n              }\n            </style>\n            <div class=\"center-me col-md-12 d-flex flex-column align-items-center text-center pad-top-10\">\n              <h1>{{weddings.fields.sections[1].fields.title}}</h1>\n              <div id=\"section-two\" class=\"d-flex flex-column align-items-center weddings-perfect\"\n                data-marked='weddings.fields.sections[1].fields.interiorBody'></div>\n            </div>\n          </section>\n          <!-- <section class=\"catering no-gutters\" ng-style=\"{'background': 'linear-gradient(0deg, rgba(22, 76, 101, 0.7), rgba(22, 76, 101, 0.7)), url(' + cateringImage + ') center center / cover no-repeat'}\">\n            <div class=\"no-gutters\">\n              <div id=\"hover-button\" class=\"col-lg-12 text-center\">\n                <a id=\"cafe\" class=\"btn btn-primary\" style=\"color:#FFF\" href=\"{{weddings.fields.sections[4].fields.ctaAssetLink.fields.file.url}}\" target=\"_blank\" rel=\"noopener noreferrer\">{{weddings.fields.sections[4].fields.ctaButtonLabel}}</a>\n              </div>\n            </div>\n          </section> -->\n        </section>\n        <aside class=\"meeting-and-events-contact container-fluid weddings-aside home-load\">\n          <div class=\"center-me col-lg-12 text-center pad-top-40\">\n            <h1 class=\"text-center\">{{weddings.fields.sections[5].fields.title}}</h1>\n            <p>{{weddings.fields.sections[5].fields.interiorHeading}}</p>\n          </div>\n          <div class=\"center-me col-lg-12 text-center pad-top-10\" style=\"max-width:350px;\">\n            <div class=\"emailConfirmationLayer\" data-ng-show=\"weddingsCtrl.showForm\">\n              <div class=\"emailConfirmationLayer\" data-ng-show=\"weddingsCtrl.showForm\">\n                <form id=contactform class=\"well form-horizontal\" name=\"userForm\"\n                  data-ng-submit=\"weddingsCtrl.submitForm(userForm.$valid)\">\n\n                  <!-- Form group for name -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"first name\" name=\"inputfirstname\"\n                          data-ng-model=\"weddingsCtrl.contactForm.firstName\" placeholder=\"YOUR FIRST NAME\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"last name\" name=\"inputlastname\"\n                          data-ng-model=\"weddingsCtrl.contactForm.lastName\" placeholder=\"YOUR LAST NAME\"\n                          class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for email + phone -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"email\" name=\"inputemail\" data-ng-model=\"weddingsCtrl.contactForm.email\"\n                          placeholder=\"YOUR EMAIL\" class=\"form-control contact-text\" type=\"email\" maxlength=\"80\"\n                          required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"phone\" name=\"inputphone\" data-ng-model=\"weddingsCtrl.contactForm.phone\"\n                          placeholder=\"YOUR PHONE\" class=\"form-control contact-text\" type=\"text\" maxlength=\"80\"\n                          required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for dates -->\n                  <!--\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <h2 class=\"text-left fs-12\">When is the wedding?<br></h2>\n                      <div class=\"date-picker\">\n                        <input class=\"form-control contact-text\" aria-label=\"in\" id=\"in\" size=\"15\" placeholder=\"Arrive\" title=\"in\" data-ng-model=\"weddingsCtrl.contactForm.arrive\">\n                      </div>\n                    </div>\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"date-picker\">\n                        <input class=\"form-control contact-text\" aria-label=\"out\" id=\"out\" size=\"15\" placeholder=\"Depart\" title=\"in\" data-ng-model=\"weddingsCtrl.contactForm.leave\">\n                      </div>\n                    </div>\n                  </div>\n                </br> -->\n\n                  <!-- Form group for Bride's Name -->\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <h2 class=\"text-left fs-12\">Details<br></h2>\n                      <div class=\"input-group\">\n                        <input aria-label=\"brides name\" name=\"inputbride\" data-ng-model=\"weddingsCtrl.contactForm.bride\"\n                          placeholder=\"BRIDE'S NAME\" class=\"form-control contact-text\" type=\"text\" maxlength=\"80\"\n                          required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for Groom's Name -->\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"grooms name\" name=\"inputbride\" data-ng-model=\"weddingsCtrl.contactForm.groom\"\n                          placeholder=\"GROOM'S NAME\" class=\"form-control contact-text\" type=\"text\" maxlength=\"80\"\n                          required>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for Relationship to the wedding party -->\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <select aria-label=\"select\" class=\"contact-text minimal\" id=\"l1\"\n                          data-ng-model=\"weddingsCtrl.contactForm.relationship\" required>\n                          <option value=\"\" disabled selected>YOUR RELATIONSHIP TO THE WEDDING PARTY</option>\n                          <option aria-label=\"bride/groom\">Bride/Groom</option>\n                          <option aria-label=\"parent\">Parent</option>\n                          <option aria-label=\"friend relation\">Friend/Relation</option>\n                          <option aria-label=\"wedding planner\">Wedding Planner</option>\n                          <option aria-label=\"other\">Other</option>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for dates -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <h2 class=\"text-left fs-12\">When is the wedding?<br></h2>\n                      <div class=\"date-picker\">\n                        <input class=\"form-control contact-text\" aria-label=\"in\" id=\"in\" size=\"15\" placeholder=\"Date\"\n                          title=\"in\" data-ng-model=\"weddingsCtrl.contactForm.arrive\">\n                      </div>\n                    </div>\n                    <!-- <div class=\"inputGroupContainer\">\n                      <div class=\"date-picker\">\n                        <input class=\"form-control contact-text\" aria-label=\"out\" id=\"out\" size=\"15\" placeholder=\"Depart\" title=\"in\" data-ng-model=\"weddingsCtrl.contactForm.leave\">\n                      </div>\n                    </div> -->\n                  </div>\n                  </br>\n\n\n                  <!-- Form group for number of people -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"email\" name=\"inputnumber\" data-ng-model=\"weddingsCtrl.contactForm.number\"\n                          placeholder=\"Estimated Number of Guests\" class=\"form-control contact-text\" type=\"text\"\n                          maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div>\n\n\n                  <!-- Form group for Events of Consideration -->\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <h2 class=\"text-left fs-12\">What events are you considering?<br>\n                        (check all that apply)</h2>\n                      <div class=\"input-group\">\n                        <div class=\"d-flex flex-column align-items-start\">\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"bridal luncheon\"\n                              data-ng-model=\"weddingsCtrl.contactForm.luncheon\">Bridal Luncheon</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"rehearsal dinner\"\n                              data-ng-model=\"weddingsCtrl.contactForm.dinner\">Rehearsal Dinner</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"welcome reception\"\n                              data-ng-model=\"weddingsCtrl.contactForm.welcomeReception\">Welcome Reception</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"ceremony\"\n                              data-ng-model=\"weddingsCtrl.contactForm.ceremony\">Ceremony</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"reception\"\n                              data-ng-model=\"weddingsCtrl.contactForm.reception\">Reception</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"post wedding brunch\"\n                              data-ng-model=\"weddingsCtrl.contactForm.brunch\">Post Wedding Brunch</label>\n                          <label class=\"checkbox\"><input class=\"mr-1\" type=\"checkbox\" value=\"room blocks\"\n                              data-ng-model=\"weddingsCtrl.contactForm.blocks\">Room Blocks</label>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for number of people -->\n\n                  <!-- <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <input aria-label=\"email\" name=\"inputnumber\" data-ng-model=\"weddingsCtrl.contactForm.number\" placeholder=\"Est. Number of People\" class=\"form-control contact-text\" type=\"text\" maxlength=\"80\" required>\n                      </div>\n                    </div>\n                  </div> -->\n\n                  <!-- Form group for Preferred Communication -->\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <h2 class=\"text-left fs-12\">How would you like us to Contact you?</h2>\n                      <div class=\"input-group\">\n                        <label class=\"mr-4\"><input class=\"mr-1\" type=\"checkbox\" value=\"email\"\n                            data-ng-model=\"weddingsCtrl.contactForm.pEmail\">Email</label>\n                        <label><input class=\"mr-1\" type=\"checkbox\" value=\"phone\"\n                            data-ng-model=\"weddingsCtrl.contactForm.pPhone\">Phone</label>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- Form group for comment -->\n\n                  <div class=\"form-group\">\n                    <div class=\"inputGroupContainer\">\n                      <div class=\"input-group\">\n                        <textarea class=\"h-200\" aria-label=\"comment\" name=\"inputcomment\"\n                          data-ng-model=\"weddingsCtrl.contactForm.comments\" placeholder=\"ADDITONAL COMMENTS\"\n                          class=\"form-control contact-text\" maxlength=\"1000\" required></textarea>\n                      </div>\n                    </div>\n                  </div>\n\n\n                  <!-- Form group for button  -->\n                  <div class=\"spacer\"></div>\n                  <div class=\"form-group\">\n                    <div class=\"col-md-4 inputGroupContainer\">\n                      <div class=\"input-group justify-center\">\n                        <button aria-label=\"submit\" type=\"submit\" class=\"btn btn-primary\"\n                          style=\"font-size:12px;\">SUBMIT</button>\n                      </div>\n                    </div>\n                  </div>\n                </form>\n              </div>\n            </div>\n            <div class=\"contactContent\">\n              <div class=\"row\" style=\"min-height:0;\">\n                <div class=\"emailConfirmationLayer\" data-ng-show=\"weddingsCtrl.showConfirmationLayer\">\n                  <h2 class=\"tk-clarendon-wide\">SUCCESS!</h2>\n                  <p class=\"futuraHeavy text-uppercase\">Thanks for your interest in Peaks Hotel. We'll get back to you\n                    just as soon as we can.</p>\n                  <p>Return to our\n                    <a href=\"/\">homepage.</a>\n                  </p>\n                </div>\n                <div class=\"emailConfirmationLayer\" data-ng-show=\"weddingsCtrl.showErrorLayer\">\n                  <h2 class=\"tk-clarendon-wide\">WE'RE SORRY!</h2>\n                  <p class=\"futuraHeavy text-uppercase\">An error occurred while trying to deliver your message through\n                    the website. You can reach us at <a\n                      href=\"mailto:guestservices@parkcitypeaks.com\">guestservices@parkcitypeaks.com</a>.</p>\n                  <p>Return to our\n                    <a href=\"/\">homepage.</a>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </aside>\n      </div>\n    </div>\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\"\n        aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                    <span aria-hidden=\"true\">\n                      <p><i class=\"fa fa-close\"></i></p>\n                    </span>\n                  </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"weddingsCtrl.socialShare('facebook')\"><i\n                            class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"weddingsCtrl.socialShare('twitter')\"> <i\n                            class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"weddingsCtrl.socialShare('pinterest')\"> <i\n                            class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"weddingsCtrl.socialShare('email')\"> <i\n                            class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                    <!-- <div class=\"body\"></div> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"carousel\">\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[0].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[0].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[0].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[1].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[1].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[1].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[2].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[2].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[2].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[3].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[3].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[3].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[4].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[4].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[4].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[5].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[5].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[5].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[6].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[6].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[6].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[7].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[7].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[7].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[7].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[8].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[8].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[8].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[8].fields.title}}\" />\n      </div>\n      <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{weddings.fields.slider.fields.images[9].sys.id}}\"\n        data-title=\"{{weddings.fields.slider.fields.images[9].fields.description}}\" data-body=\"Share with your world\">\n        <img src=\"{{weddings.fields.slider.fields.images[9].fields.file.url}}?h=375&fm=jpg&fl=progressive\"\n          alt=\"{{weddings.fields.slider.fields.images[9].fields.title}}\" />\n      </div>\n    </div>\n  </div>\n</div>\n<script>\n  jQuery.noConflict();\n  jQuery(document).ready(function ($) {\n\n    var $card = $('.img'),\n      $modal = $('#modal');\n\n    $card.click(this, function () {\n      var $this = $(this),\n        $thisImage = $this.find('img'),\n        $thisTitle = $this.data('title'),\n        $thisBody = $this.data('body'),\n        $thisDate = $this.data('date');\n\n      $modal.find('.header h2').html($thisTitle);\n      $modal.find('.meta').html($thisDate);\n      $modal.find('.body').html($thisBody);\n      $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n      $modal.modal();\n    })\n  });\n</script>\n\n</div>\n</div>"

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/versante',
		template: __webpack_require__(63),
		controller: DiningController,
		controllerAs: 'diningCtrl'
	};
	
	function DiningController($scope, $state, store, $window, contentful, $http, Socialshare) {
		var vm = this;
		$window.scrollTo(0, 0);
		contentful.entries('content_type=diningPage&sys.id=5x9VxyDL5SqWgo0eoEgA8K').then(function (res) {
			// console.log('dining page contentful data',res);
			$scope.dining = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoTitle) {
				document.title = seoData.fields.seoTitle;
			}
			if (seoData.fields.seoDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoDescription;
					}
				}
			}
		});
		setTimeout(function () {
			var elem = document.querySelector('.carousel');
			var flkty = new Flickity(elem, {
				imagesLoaded: true,
				draggable: false,
				percentPostion: false,
				cellAlign: 'center',
				wrapAround: true,
				lazyLoad: true,
				pageDots: false,
				autoPlay: true
			});
		}, 1000);
	
		// document.getElementById("stars").innerHTML = getStars(5);
	
		function getStars(rating) {
	
			// Round to nearest half
			rating = Math.round(rating * 2) / 2;
			var output = [];
	
			// Append all the filled whole stars
			for (var i = rating; i >= 1; i--) {
				output.push('<span>☆</span>&nbsp;');
			} // If there is a half a star, append it
			// if (i == .5) output.push('<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>&nbsp;');
	
			// Fill the empty stars
			for (var _i = 5 - rating; _i >= 1; _i--) {
				output.push('☆&nbsp;');
			}return output.join('');
		}
	
		vm.trustUrl = "trustUrl";
	
		trustUrl.$inject = ['$sce'];
	
		function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}
	
		$window.sr = ScrollReveal({ reset: false });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#fitness', { distance: 0, duration: 1000, scale: 1.5 }, 500);
	
		// Open overlay when button is clicked
		$('.show-blue').on('click', function () {
			var contentID = $(this).data('target');
			$('#' + contentID).toggleClass('reveal');
			$(this).fadeOut(800, 'linear');
		});
	
		$('.show-white').on('click', function () {
			var contentID = $(this).data('target');
			$('#' + contentID).toggleClass('reveal');
			$(this).fadeOut(800, 'linear');
		});
	
		// Close overlay when the outside of menu is clicked
		$('.hide-blue').on('click', function () {
			$('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
				$('.overlay.bg-blue').removeClass('conceal');
				$('.overlay.bg-blue').removeClass('reveal');
				$(this).dequeue();
				$(".show-blue").fadeIn(800, 'linear');
			});
		});
		$('.hide-white').on('click', function () {
			$('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
				$('.overlay.bg-white').removeClass('conceal');
				$('.overlay.bg-white').removeClass('reveal');
				$(this).dequeue();
				$(".show-white").fadeIn(800, 'linear');
			});
		});
		vm.socialShare = function (share) {
			if (share === 'facebook') {
				Socialshare.share({
					'provider': 'facebook',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
						'socialshareQuote': 'Peaks Hotel | Versante',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'twitter') {
				Socialshare.share({
					'provider': 'twitter',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
						'socialshareText': 'Peaks Hotel | Versante',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'pinterest') {
				Socialshare.share({
					'provider': 'pinterest',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
						'socialshareText': 'Peaks Hotel | Versante',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'email') {
				Socialshare.share({
					'provider': 'email',
					'attrs': {
						'socialshare-subject': 'Peaks Hotel | Versante',
						'socialshare-body': 'Take a look at Versante at the Peaks Hotel!'
					}
				});
			}
		};
	}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "\n\n<div id=\"versante\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <!-- <div class=\"logo-versante\"><img src=\"/img/dining-assets/Versante_logo-wht-03.svg\" alt=\"Versante Logo, white\" /></div> -->\n      <div class=\"banner-item\">\n        <div class=\"logo-versante\"><img src=\"/img/dining-assets/Versante_logo-wht-03.svg\" alt=\"Versante Logo, white\" /></div>\n        <img class=\"mobile-hide\" src=\"{{dining.fields.bannerImage.fields.file.url}}\" alt=\"{{dining.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{dining.fields.mobileBannerImage.fields.file.url}}?h=768\" alt=\"{{dining.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1 style=\"color:#FFF\">{{dining.fields.bannerHeadline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n           <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n         </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n\n  <div id=\"jump1\" class=\"main\">\n    <div class=\"wrap d-flex justify-content-center\">\n      <!-- <div class=\"col-4\"></div> -->\n      <aside class=\"versante-section-2\">\n        <div class=\"text-center pad-2 versante-section-2 mobile-hide\">\n          <p><br>\n            <div data-marked='dining.fields.yelpIframe'></div>\n              <!-- <iframe aria-label=\"yelp widget\" width=\"300\" height=\"530\" src=\"//www.yelp.com/reservations/versante-hearth-bar-park-city/widget?orientation=vertical&amp;color-scheme=light\" scrolling=\"yes\" class=\"iframe-class\" frameborder=\"0\" title=\"yelp-widget\"></iframe></p> -->\n        </div>\n\n\n        <div class=\"text-center pad-2 desktop-hide versante-section-2\">\n          <div data-marked='dining.fields.yelpIframe'></div>\n          <div class=\"desktop-hide w-40 p-4 d-flex justify-content-center text-center\">\n            <a ng-if=\"dining.fields.externalMenuLink\" href=\"{{dining.fields.externalMenuLink}}\"  aria-label=\"view our menu online\">\n\n          <img class=\"img-versante align-self-end\" src=\"images/dining-assets-r2/viewmenu-2.jpg\" alt=\"Dining\"></a>\n          </div>\n        </div>\n\n\n        <div class=\"this-week home-load versante-section-2 text-center\">\n          <div class=\"this-week-interior no-deco\">\n            <h1 class=\"text-center\" style=\"margin-bottom:.4em;\">Hours:</h1>\n            <div class=\"text-center\" style=\"margin-bottom: 2em;\" data-marked='dining.fields.hours'></div>\n            <h2 class=\"text-center\" style=\"margin-bottom: 1em;\">{{dining.fields.phoneNumber}}</h2>\n          </div>\n        </div>\n\n\n        <div ng-if=\"dining.fields.specials.fields.showSpecials === true\"  class=\"this-week mobile-hide home-load versante-section-2 text-center\">\n          <div class=\"this-week-interior\">\n            <h1 class=\"text-center\" style=\"margin-top: 1em\">{{dining.fields.specials.fields.title}}</h1>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special1DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special1Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special1Body'></div>\n          </br>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special2DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special2Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special2Body'></div>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special3Daytime}}</h2>\n            <h3>{{dining.fields.specials.fields.special3Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special3Body'></div>\n          </div>\n\n        </div>\n\n\n        <div ng-if=\"dining.fields.specials.fields.showSpecials === true\"  class=\"this-week desktop-hide home-load versante-section-2\">\n           <a data-toggle=\"collapse\" data-target=\"#collapseExample\" aria-expanded=\"false\" aria-controls=\"collapseExample\">\n             <div class=\"this-week-interior\">\n               <div class=\"icon-versante\">\n            <h1 class=\"text-center\">{{dining.fields.specials.fields.title}}</h1><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></div>\n            <div class=\"collapse\" id=\"collapseExample\">\n            </br>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special1DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special1Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special1Body'></div>\n            </br>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special2DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special2Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special2Body'></div>\n            </br>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special3Daytime}}</h2>\n            <h3>{{dining.fields.specials.fields.special3Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special3Body'></div>\n          </div>\n        </a>\n      </div>\n    </div>\n\n    <div class=\"this-week home-load versante-section-2 blue-outline text-center m-top-2\">\n      <div class=\"this-week-interior no-deco\">\n        <div id=\"sidebar-message\" class=\"text-center\" data-marked='dining.fields.sidebarMessage' style=\"padding: .5em .2em;\"></div>\n      </div>\n    </div>\n\n    <div class=\"this-week home-load versante-section-2 text-center m-top-4 large-party\">\n      <div class=\"this-week-interior no-deco\">\n        <div id=\"chef\" class=\"text-center\" data-marked='dining.fields.chefInfo'></div>\n      </div>\n    </div>\n\n      </aside>\n      <section>\n          <div class=\"d-flex justify-content-around align-items-center versante-section-1 home-load background-one\">\n              <div class=\"versante-snippet w-60\">\n                <h1 style=\"color: #dc0000; letter-spacing: .15em; margin-bottom: .5em;\">{{dining.fields.section1Title}}</h1>\n                <div id=\"section1Body\" style=\"color: #000;\" data-marked='dining.fields.section1Body'>\n\n                </div>\n                <div ng-if=\"dining.fields.orderingLinks\" class=\"d-flex flex-wrap justify-content-start\">\n                  <div data-ng-repeat=\"orderLink in dining.fields.orderingLinks\" class=\"mt-neg-3 pr-3\">\n                    <a href=\"{{orderLink.fields.link}}\" target=\"_blank\" class=\"btn btn-secondary\" aria-label=\"reserve a table online\">{{orderLink.fields.label}}</a>\n                  </div>\n                </div>\n\n\n              </div>\n                <div class=\"mobile-hide w-40 p-4 d-flex flex-column justify-content-center text-center\">\n                  <a ng-if=\"dining.fields.externalMenuLink\" href=\"{{dining.fields.externalMenuLink}}\" aria-label=\"view our menu online\">\n\n              <!-- <a aria-label=\"yelp\" href=\"{{dining.fields.menu.fields.file.url}}\" target=\"_blank\"> -->\n                <img class=\"img-versante align-self-end\" src=\"images/dining-assets-r2/viewmenu-2.jpg\" alt=\"Dining\"></a>\n                </div>\n\n          </div>\n\n          <div id=\"insta\" class=\" d-flex justify-content-around align-items-center versante-section-1 home-load\">\n          <div class=\"w-60\">\n            <img class=\"img-fluid h-400\" src=\"{{dining.fields.virtualTourImage.fields.file.url}}\" alt=\"Dining\">\n          </div>\n            <div id=\"virtual\" class=\"versante-snippet d-flex justify-content-center w-50 text-center\">\n              <div class=\"d-flex flex-column justify-content-center\">\n                <div data-marked='dining.fields.virtualTourCopy' >\n\n                  </div>\n                  <div class=\"mt-3\">\n                    <p ng-if=\"link.fields.link\" ng-repeat=\"link in dining.fields.links\" class=\"p-0 mt-3\">\n                      <a class=\"buy-now  btn-thethird\" href=\"{{link.fields.link}}\" target=\"_blank\" aria-label=\"view virtual tour on Visiting Media's Website\">{{link.fields.label}}</a>\n                    </p>\n                    </div>\n              </div>\n            </div>\n        </div>\n\n\n          <div id=\"yelp\" class=\"d-flex justify-content-around align-items-center versante-section-1 home-load\">\n            <div class=\"yelp-section order-sm-2 w-40 text-center\">\n              <div class=\"rating\">\n                <span>☆</span><span>☆</span><span>☆</span><span>☆</span><span>☆</span>\n              </div>\n                <div class=\"yelp-quote\" data-marked='dining.fields.yelpReview'></div>\n                <a href=\"https://www.yelp.com/biz/versante-hearth-bar-park-city\" target=\"_blank\"><h2 class=\"yelp-quote\">Read more reviews</h2></a>\n              <div class=\"d-flex justify-content-center\">\n                <a aria-label=\"yelp\" class=\"modal-icon\" href=\"https://www.yelp.com/biz/versante-hearth-bar-park-city\" target=\"_blank\" rel=\"nofollow noreferrer\">\n                  <i class=\"fab  fa-2 fa-yelp\" aria-hidden=\"true\"></i> </a>\n              </div>\n            </div>\n            <div class=\"order-sm-1 w-60\">\n              <img class=\"img-fluid h-400\" src=\"{{dining.fields.yelpImage.fields.file.url}}\" alt=\"Dining\">\n            </div>\n        </div>\n\n\n          <div id=\"insta\" class=\" d-flex justify-content-around align-items-center versante-section-1 home-load\">\n          <div class=\"w-60\">\n            <img class=\"img-fluid h-400\" src=\"{{dining.fields.instagramImage.fields.file.url}}\" alt=\"Dining\">\n          </div>\n            <div class=\"versante-snippet d-flex justify-content-center w-50 text-center\">\n              <div class=\"insta d-flex flex-column justify-content-center\">\n                <a class=\"modal-icon\" aria-label=\"instagram\" href=\"https://www.instagram.com/versantehearthandbar\" target=\"_blank\" rel=\"nofollow noreferrer\"> <i class=\"fab fa-3 fa-instagram\" aria-hidden=\"true\"></i> </a>\n                <a class=\"modal-icon\" aria-label=\"instagram\"  href=\"https://www.instagram.com/versantehearthandbar\" target=\"_blank\" rel=\"nofollow noreferrer\">\n                  <h2>@versantehearthandbar</h2></a>\n              </div>\n            </div>\n        </div>\n        </section>\n        <!-- <div class=\"col-4\"></div> -->\n      </div>\n      <div class=\"carousel\">\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[0].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[0].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[0].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[1].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[1].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[1].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[2].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[2].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[2].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[3].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[3].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[3].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[4].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[4].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[4].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[5].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[5].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[5].fields.title}}\" />\n        </div>\n        <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[6].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[6].fields.description}}\" data-body=\"Share with your world\">\n          <img src=\"{{dining.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[6].fields.title}}\" />\n        </div>\n      </div>\n      <script>\n        jQuery.noConflict();\n        jQuery(document).ready(function($) {\n          $('.collapse')\n              .on('shown.bs.collapse', function() {\n                  $(this)\n                      .parent().parent()\n                      .find(\".fa-plus\")\n                      .removeClass(\"fa-plus\")\n                      .addClass(\"fa-minus\");\n              })\n              .on('hidden.bs.collapse', function() {\n                  $(this)\n                      .parent().parent()\n                      .find(\".fa-minus\")\n                      .removeClass(\"fa-minus\")\n                      .addClass(\"fa-plus\");\n              });\n\n          var $card = $('.img'),\n            $modal = $('#modal');\n\n          $card.click(this, function() {\n            var $this = $(this),\n              $thisImage = $this.find('img'),\n              $thisTitle = $this.data('title'),\n              $thisBody = $this.data('body'),\n              $thisDate = $this.data('date');\n\n            $modal.find('.header h2').html($thisTitle);\n            $modal.find('.meta').html($thisDate);\n            $modal.find('.body').html($thisBody);\n            $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n            $modal.modal();\n          })\n        });\n\n        function myhref(web) {\n          window.open(web, '_blank');\n        }\n      </script>\n\n    </div>\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\" role=\"document\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"close col-12\">\n                  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n              </button>\n                </div>\n                <div class=\"image col-md-12\">&nbsp;</div>\n                <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2></h2>\n                      <div class=\"col-12\">\n                        <a aria-label=\"facebook\" class=\"modal-icon\" data-ng-click=\"diningCtrl.socialShare('facebook')\"><i class=\"fa fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a aria-label=\"twitter\" class=\"modal-icon\" data-ng-click=\"diningCtrl.socialShare('twitter')\"> <i class=\"fa fa-2x fa-twitter\"></i> </a>\n                        <a aria-label=\"pinterest\"  class=\"modal-icon\" data-ng-click=\"diningCtrl.socialShare('pinterest')\"> <i class=\"fa fa-2x fa-pinterest\"></i> </a>\n                        <a aria-label=\"email\"  class=\"modal-icon\" data-ng-click=\"diningCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\"></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n"

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/versante/menu',
		template: __webpack_require__(65),
		controller: MenuController,
		controllerAs: 'menuCtrl'
	};
	
	function MenuController($scope, $state, store, $window, contentful, $http, Socialshare) {
		var vm = this;
		$window.scrollTo(0, 0);
		contentful.entries('content_type=diningPage&sys.id=2AN86PHCbkKqwexkOVUx4m').then(function (res) {
			// console.log('menu page contentful data',res);
			$scope.dining = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoTitle) {
				document.title = seoData.fields.seoTitle;
			}
			if (seoData.fields.seoDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoDescription;
					}
				}
			}
		});
	
		// $('.tri-up a').click(() => {
		// 		console.log(window.pageYOffset);
		// 	$('html, body').animate({
		// 		scrollTop: window.pageYOffset + $(window).height()
		// 	}, 300);
		// 	return false;
		// });
		// 	setTimeout(function(){
		//   var elem = document.querySelector('.carousel');
		//   var flkty = new Flickity(elem, {
		//     imagesLoaded: true,
		//     draggable: false,
		//     percentPostion: false,
		//     cellAlign: 'center',
		//     wrapAround: true,
		//     lazyLoad: true,
		//     pageDots: false,
		//     autoPlay: true
		//   });
		// }, 1000);
	
		// document.getElementById("stars").innerHTML = getStars(5);
	
	
		vm.trustUrl = "trustUrl";
	
		trustUrl.$inject = ['$sce'];
	
		function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}
	
		$window.sr = ScrollReveal({ reset: false });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#fitness', { distance: 0, duration: 1000, scale: 1.5 }, 500);
	}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"versante\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <!-- <div class=\"logo-versante\"><img src=\"/img/dining-assets/Versante_logo-wht-03.svg\" alt=\"Versante Logo, white\" /></div> -->\n      <div class=\"banner-item\">\n        <div class=\"logo-versante\"><img src=\"/img/dining-assets/Versante_logo-wht-03.svg\" alt=\"Versante Logo, white\" /></div>\n        <img class=\"mobile-hide\" src=\"{{dining.fields.bannerImage.fields.file.url}}\" alt=\"{{dining.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{dining.fields.mobileBannerImage.fields.file.url}}?h=768\" alt=\"{{dining.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1 style=\"color:#FFF\">{{dining.fields.bannerHeadline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#menu\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div id=\"menu\" class=\"main\">\n    <div class=\"wrap d-flex justify-content-center\">\n      <aside class=\"versante-section-2\">\n        <div class=\"text-center pad-2 versante-section-2 mobile-hide\">\n          <p>\n          <div data-marked='dining.fields.yelpIframe'></div>\n        </div>\n\n\n        <div class=\"this-week home-load versante-section-2 text-center\">\n          <div class=\"this-week-interior no-deco\">\n            <h1 class=\"text-center\" style=\"margin-bottom:.4em;\">Hours:</h1>\n            <div id=\"thisWeek\" class=\"text-center\" data-marked='dining.fields.hours'></div>\n            <h2 class=\"text-center\" style=\"margin-bottom: .4em;\"><a href=\"tel:{{dining.fields.phoneNumber}}\">{{dining.fields.phoneNumber}}</a></h2>\n            <div ng-if=\"dining.fields.orderingLinks\" class=\"d-flex flex-wrap justify-content-start mt-3\">\n              <div data-ng-repeat=\"orderLink in dining.fields.orderingLinks\" class=\"desktop-hide mt-neg-3 pb-2\">\n                <a href=\"orderLink.fields.link\" target=\"_blank\" class=\"btn btn-secondary\" aria-label=\"reserve a table online\">{{orderLink.fields.label}}</a>\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n        <div ng-if=\"dining.fields.specials.fields.showSpecials === true\" class=\"this-week mobile-hide home-load versante-section-2 text-center\">\n          <div class=\"this-week-interior\">\n            <h1 class=\"text-center\" style=\"margin-top: 1em\">{{dining.fields.specials.fields.title}}</h1>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special1DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special1Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special1Body'></div>\n\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special2DayTime}}</h2>\n            <h3>{{dining.fields.specials.fields.special2Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special2Body'></div>\n            <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special3Daytime}}</h2>\n            <h3>{{dining.fields.specials.fields.special3Title}}</h3>\n            <div data-marked='dining.fields.specials.fields.special3Body'></div>\n          </div>\n\n        </div>\n\n\n        <div ng-if=\"dining.fields.specials.fields.showSpecials === true\" class=\"this-week desktop-hide home-load versante-section-2\">\n          <a data-toggle=\"collapse\" data-target=\"#collapseExample\" aria-expanded=\"false\" aria-controls=\"collapseExample\">\n            <div class=\"this-week-interior\">\n              <div class=\"icon-versante\">\n                <h1 class=\"text-center\">{{dining.fields.specials.fields.title}}</h1><i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n              </div>\n              <div class=\"collapse\" id=\"collapseExample\">\n\n                <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special1DayTime}}</h2>\n                <h3>{{dining.fields.specials.fields.special1Title}}</h3>\n                <div data-marked='dining.fields.specials.fields.special1Body'></div>\n\n                <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special2DayTime}}</h2>\n                <h3>{{dining.fields.specials.fields.special2Title}}</h3>\n                <div data-marked='dining.fields.specials.fields.special2Body'></div>\n\n                <h2 style=\"margin-bottom: .5em;\">{{dining.fields.specials.fields.special3Daytime}}</h2>\n                <h3>{{dining.fields.specials.fields.special3Title}}</h3>\n                <div data-marked='dining.fields.specials.fields.special3Body'></div>\n              </div>\n            </div>\n          </a>\n        </div>\n\n        <div class=\"this-week home-load versante-section-2 blue-outline text-center m-top-2 mobile-hide\">\n          <div class=\"this-week-interior no-deco\">\n            <div id=\"sidebar-message\" class=\"text-center\" data-marked='dining.fields.sidebarMessage' style=\"padding: .5em .2em;\"></div>\n          </div>\n        </div>\n\n        <div class=\"this-week home-load versante-section-2 text-center m-top-4 large-party mobile-hide\">\n          <div class=\"this-week-interior no-deco\">\n            <div id=\"chef\" class=\"text-center\" data-marked='dining.fields.chefInfo'></div>\n          </div>\n        </div>\n\n      </aside>\n      <section>\n        <div class=\"d-flex justify-content-around align-items-center versante-section-1\">\n          <div id=\"menu\" class=\"versante-snippet\">\n            <div class=\"w-80 mobile-hide\">\n              <h1 style=\"color: #dc0000; letter-spacing: .15em; margin-bottom: .5em;\">{{dining.fields.section1Title}}</h1>\n              <div id=\"section1Body\" style=\"color: #000;\" data-marked='dining.fields.section1Body'>\n              </div>\n              <div ng-if=\"dining.fields.orderingLinks\" class=\"d-flex flex-wrap justify-content-start\">\n                <div data-ng-repeat=\"orderLink in dining.fields.orderingLinks\" class=\"mt-neg-3 pr-3\">\n                  <a href=\"{{orderLink.fields.link}}\" target=\"_blank\" class=\"btn btn-secondary\" aria-label=\"reserve a table online\">{{orderLink.fields.label}}</a>\n                </div>\n              </div>\n            </div>\n            <div>\n              <div data-marked=\"dining.fields.menuScript\"></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"desktop-hide versante-section-2 \">\n          <div class=\"this-week home-load versante-section-2 blue-outline text-center m-top-2\">\n            <div class=\"this-week-interior no-deco\">\n              <div id=\"sidebar-message\" class=\"text-center\" data-marked='dining.fields.sidebarMessage' style=\"padding: .5em .2em;\"></div>\n            </div>\n          </div>\n\n          <div class=\"this-week home-load versante-section-2 text-center m-top-4 large-party\">\n            <div class=\"this-week-interior no-deco\">\n              <div id=\"chef\" class=\"text-center\" data-marked='dining.fields.chefInfo'></div>\n            </div>\n          </div>\n        </div>\n      </section>\n    </div>\n  </div>\n  <!-- <div class=\"carousel\">\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[0].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[0].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[0].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[0].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[1].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[1].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[1].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[1].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[2].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[2].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[2].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[2].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[3].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[3].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[3].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[3].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[4].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[4].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[4].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[4].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[5].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[5].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[5].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[5].fields.title}}\" />\n    </div>\n    <div style=\"cursor:pointer;\" class=\"img\" data-id=\"{{dining.fields.slider.fields.images[6].sys.id}}\" data-title=\"{{dining.fields.slider.fields.images[6].fields.description}}\">\n      <img src=\"{{dining.fields.slider.fields.images[6].fields.file.url}}?h=375&fm=jpg&fl=progressive\" alt=\"{{dining.fields.slider.fields.images[6].fields.title}}\" />\n    </div>\n  </div> -->\n  <!-- <script>\n    jQuery.noConflict();\n    jQuery(document).ready(function($) {\n      $('.collapse')\n        .on('shown.bs.collapse', function() {\n          $(this)\n            .parent().parent()\n            .find(\".fa-plus\")\n            .removeClass(\"fa-plus\")\n            .addClass(\"fa-minus\");\n        })\n        .on('hidden.bs.collapse', function() {\n          $(this)\n            .parent().parent()\n            .find(\".fa-minus\")\n            .removeClass(\"fa-minus\")\n            .addClass(\"fa-plus\");\n        });\n\n      var $card = $('.img'),\n        $modal = $('#modal');\n\n      $card.click(this, function() {\n        var $this = $(this),\n          $thisImage = $this.find('img'),\n          $thisTitle = $this.data('title'),\n          $thisBody = $this.data('body'),\n          $thisDate = $this.data('date');\n\n        $modal.find('.header h2').html($thisTitle);\n        $modal.find('.meta').html($thisDate);\n        $modal.find('.body').html($thisBody);\n        $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n        $modal.modal();\n      })\n    });\n\n    function myhref(web) {\n      window.open(web, '_blank');\n    }\n  </script> -->\n\n\n  <!-- <div class=\"container-fluid\">\n    <div class=\"modal fade\" id=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n      <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"close col-12\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                  <span aria-hidden=\"true\">\n                    <p><i class=\"fa fa-close\"></i></p>\n                  </span>\n                </button>\n              </div>\n              <div class=\"image col-md-12\">&nbsp;</div>\n              <div class=\"info col-md-12\">\n                <div class=\"row\">\n                  <div class=\"header col-12\">\n                    <h2></h2>\n                    <div class=\"col-12\">\n                      <div class=\"body col-12\"></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div> -->\n</div>\n"

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/galleries',
		template: __webpack_require__(67),
		controller: GalleriesController,
		controllerAs: 'galleriesCtrl'
	};
	
	function GalleriesController($scope, $state, store, $window, contentful, $http, Socialshare) {
		var vm = this;
		$window.scrollTo(0, 0);
		contentful.entries('content_type=longPage&sys.id=4jqa7QAUcMGgK0ka2YUcYw&include6').then(function (res) {
			// console.log('gallery page contentful data',res);
			$scope.galleries = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoPageTitle) {
				document.title = seoData.fields.seoPageTitle;
			}
			if (seoData.fields.seoPageDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoPageDescription;
					}
				}
			}
		});
		contentful.entries('content_type=gallery&sys.id=73Fk6SaCGWEgKg4EgA4UOg').then(function (res) {
			console.log('room gallery data', res);
			$scope.roomGallery = res.data.items[0];
		});
		contentful.entries('content_type=gallery&sys.id=593jsONLB6w46omCMWsQAE').then(function (res) {
			console.log('amen gallery data', res);
			$scope.amenGallery = res.data.items[0];
		});
		contentful.entries('content_type=gallery&sys.id=3Xh8zGmrc4mG0WKGKKkE6M').then(function (res) {
			console.log('dining gallery data', res);
			$scope.eatGallery = res.data.items[0];
		});
		contentful.entries('content_type=gallery&sys.id=adMjMPfbHOOKaA8WcEssw').then(function (res) {
			console.log('meet gallery data', res);
			$scope.meetGallery = res.data.items[0];
		});
	
		vm.trustUrl = "trustUrl";
	
		trustUrl.$inject = ['$sce'];
	
		function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}
		$window.sr = ScrollReveal({ reset: true });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#king-suite', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#meetings-events', { distance: 0, duration: 1000, scale: 1.5 }, 500);
	
		vm.socialShare = function (share) {
			if (share === 'facebook') {
				Socialshare.share({
					'provider': 'facebook',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
						'socialshareQuote': 'Peaks Hotel | Gallery',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'twitter') {
				Socialshare.share({
					'provider': 'twitter',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
						'socialshareText': 'Peaks Hotel | Gallery',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'pinterest') {
				Socialshare.share({
					'provider': 'pinterest',
					'attrs': {
						'socialshareUrl': 'http://peaks-hotel.herokuapp.com/galleries',
						'socialshareText': 'Peaks Hotel | Gallery',
						'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
						'socialsharePopupHeight': '400',
						'socialsharePopupWidth': '400'
					}
				});
			} else if (share === 'email') {
				Socialshare.share({
					'provider': 'email',
					'attrs': {
						'socialshare-subject': 'Peaks Hotel | Gallery',
						'socialshare-body': 'Take a look at the Peaks Hotel!'
					}
				});
			}
		};
	}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  // smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n<div id=\"galleries\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{galleries.fields.bannerImage.fields.file.url}}\" alt=\"{{galleries.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{galleries.fields.mobileBannerImage.fields.file.url}}?h=768\" alt=\"{{galleries.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{galleries.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n           <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n         </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n  <div class=\"main\">\n    <div ng-repeat-start=\"section in galleries.fields.sections\">\n      <div class=\"row no-gutters\">\n        <div ng-if='section.fields.title == \"Rooms\"' id=\"hover-button\" class=\"col-lg-12 text-center\" style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button id=\"pool\" type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#modal1\">{{section.fields.title}}</button>\n        </div>\n        <div ng-if='section.fields.title == \"Amenities\"' id=\"hover-button\" class=\"col-lg-12 text-center\" style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button id=\"pool\" type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#modal2\">{{section.fields.title}}</button>\n        </div>\n        <div ng-if='section.fields.title == \"Dining\"' id=\"hover-button\" class=\"col-lg-12 text-center\" style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button id=\"pool\" type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#modal3\">{{section.fields.title}}</button>\n        </div>\n        <div ng-if='section.fields.title == \"Meetings + Events\"' id=\"hover-button\" class=\"col-lg-12 text-center\" style=\"background: url({{section.fields.image.fields.file.url}}) center no-repeat; background-size:cover;\">\n          <button id=\"pool\" type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#modal4\">{{section.fields.title}}</button>\n        </div>\n      </div>\n    </div>\n    <div ng-repeat-end></div>\n    <div class=\"container-fluid\">\n      <div class=\"modal fade\" id=\"modal1\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <button type=\"button\" class=\"title\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p>{{roomGallery.fields.description}}</p></span>\n              </button>\n              <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n          </button>\n                </div>\n                <div class=\"image col-md-12\">\n                  <div class=\"gallery-one\" data-flickity-options='{ \"imagesLoaded\": true,\"percentPosition\": false,\"cellAlign\": \"center\", \"wrapAround\": true, \"lazyLoad\": true, \"pageDots\": false, \"autoPlay\": false }'>\n                    <img src=\"{{roomGallery.fields.images[0].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[0].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[1].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[1].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[2].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[2].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[3].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[3].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[4].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[4].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[5].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[5].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[6].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[6].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[7].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[7].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[8].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[8].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[9].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[9].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[10].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[10].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[11].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[11].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[12].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[12].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[13].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[13].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[14].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[14].fields.title}}\" />\n                    <img src=\"{{roomGallery.fields.images[15].fields.file.url}}?h=375\" alt=\"{{roomGallery.fields.images[15].fields.title}}\" />\n                  </div>\n                </div>\n                <!-- <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2 class=\"caption\"></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('facebook')\"><i class=\"fab fa-2x fa-facebook-square\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('twitter')\"> <i class=\"fab fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('pinterest')\"> <i class=\"fab fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\">Share with your world</div>\n                      </div>\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal fade\" id=\"modal2\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <button type=\"button\" class=\"title\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p>{{modal.fields.description}}</p></span>\n              </button>\n              <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n          </button>\n                </div>\n                <div class=\"image col-md-12\">\n                  <div class=\"gallery-two\" data-flickity-options='{ \"imagesLoaded\": true,\"percentPosition\": false,\"cellAlign\": \"center\", \"wrapAround\": true, \"lazyLoad\": true, \"pageDots\": false, \"autoPlay\": false }'>\n                    <img src=\"{{amenGallery.fields.images[0].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[0].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[1].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[1].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[2].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[2].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[3].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[3].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[4].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[4].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[5].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[5].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[6].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[6].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[7].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[7].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[8].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[8].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[9].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[9].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[10].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[10].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[11].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[11].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[12].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[12].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[13].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[13].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[14].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[14].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[15].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[15].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[16].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[16].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[17].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[17].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[18].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[18].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[19].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[19].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[20].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[20].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[21].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[21].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[22].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[22].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[23].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[23].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[24].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[24].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[25].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[25].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[26].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[26].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[27].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[27].fields.title}}\" />\n                    <img src=\"{{amenGallery.fields.images[28].fields.file.url}}?h=375\" alt=\"{{amenGallery.fields.images[28].fields.title}}\" />\n                  </div>\n                </div>\n                <!-- <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2 class=\"caption\"></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('facebook')\"><i class=\"fab fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('twitter')\"> <i class=\"fab fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('pinterest')\"> <i class=\"fab fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\">Share with your world</div>\n                      </div>\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal fade\" id=\"modal3\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <button type=\"button\" class=\"title\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p>{{modal.fields.description}}</p></span>\n              </button>\n              <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n          </button>\n                </div>\n                <div class=\"image col-md-12\">\n                  <div class=\"gallery-three\" data-flickity-options='{ \"imagesLoaded\": true,\"percentPosition\": false,\"cellAlign\": \"center\", \"wrapAround\": true, \"lazyLoad\": true, \"pageDots\": false, \"autoPlay\": false }'>\n                    <img src=\"{{eatGallery.fields.images[0].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[0].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[1].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[1].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[2].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[2].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[3].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[3].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[4].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[4].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[5].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[5].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[6].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[6].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[7].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[7].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[8].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[8].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[9].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[9].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[10].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[10].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[11].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[11].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[12].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[12].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[13].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[13].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[14].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[14].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[15].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[15].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[16].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[16].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[17].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[17].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[18].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[18].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[19].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[19].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[20].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[20].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[21].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[21].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[22].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[22].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[23].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[23].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[24].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[24].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[25].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[25].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[26].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[26].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[27].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[27].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[28].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[28].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[29].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[29].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[30].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[30].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[31].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[31].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[32].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[32].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[33].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[33].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[34].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[34].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[35].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[35].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[36].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[36].fields.title}}\" />\n                    <img src=\"{{eatGallery.fields.images[37].fields.file.url}}?h=375\" alt=\"{{eatGallery.fields.images[37].fields.title}}\" />\n                  </div>\n                </div>\n                <!-- <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2 class=\"caption\"></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('facebook')\"><i class=\"fab fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('twitter')\"> <i class=\"fab fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('pinterest')\"> <i class=\"fab fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\">Share with your world</div>\n                      </div>\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal fade\" id=\"modal4\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog\">\n          <div class=\"modal-content\">\n            <div class=\"modal-body\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <button type=\"button\" class=\"title\" data-dismiss=\"modal\" aria-label=\"Close\">\n                <span aria-hidden=\"true\"><p>{{modal.fields.description}}</p></span>\n              </button>\n              <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <span aria-hidden=\"true\"><p><i class=\"fa fa-close\"></i></p></span>\n          </button>\n                </div>\n                <div class=\"image col-md-12\">\n                  <div class=\"gallery-four\">\n                    <img src=\"{{meetGallery.fields.images[0].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[0].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[1].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[1].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[2].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[2].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[3].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[3].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[4].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[4].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[5].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[5].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[6].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[6].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[7].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[7].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[8].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[8].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[9].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[9].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[10].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[10].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[11].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[11].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[12].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[12].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[13].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[13].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[14].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[14].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[15].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[15].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[16].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[16].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[17].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[17].fields.title}}\" />\n                    <img src=\"{{meetGallery.fields.images[18].fields.file.url}}?h=375\" alt=\"{{meetGallery.fields.images[18].fields.title}}\" />\n                  </div>\n                </div>\n                <!-- <div class=\"info col-md-12\">\n                  <div class=\"row\">\n                    <div class=\"header col-12\">\n                      <h2 class=\"caption\"></h2>\n                      <div class=\"col-12\">\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('facebook')\"><i class=\"fab fa-2x fa-facebook-square\" aria-hidden=\"true\"></i></a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('twitter')\"> <i class=\"fab fa-2x fa-twitter\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('pinterest')\"> <i class=\"fab fa-2x fa-pinterest\"></i> </a>\n                        <a class=\"modal-icon\" data-ng-click=\"galleriesCtrl.socialShare('email')\"> <i class=\"fa fa-2x fa-envelope\"></i> </a>\n                        <div class=\"body col-12\">Share with your world</div>\n                      </div>\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <script>\n    jQuery.noConflict();\n    jQuery(document).ready(function($) {\n      $('#modal1').on('shown.bs.modal', function(event) {\n        $('.gallery-one').flickity({\n          'imagesLoaded': true,\n          'draggable': true,\n          'percentPostion': false,\n          'cellAlign': 'left',\n          'wrapAround': true,\n          'lazyLoad': true,\n          'pageDots': false,\n          'autoPlay': true\n        });\n      });\n\n\n      $('#modal2').on('shown.bs.modal', function(event) {\n        $('.gallery-two').flickity({\n          'imagesLoaded': true,\n          'draggable': true,\n          'percentPostion': false,\n          'cellAlign': 'left',\n          'wrapAround': true,\n          'lazyLoad': true,\n          'pageDots': false,\n          'autoPlay': true\n        });\n      });\n\n\n      $('#modal3').on('shown.bs.modal', function(event) {\n        $('.gallery-three').flickity({\n          'imagesLoaded': true,\n          'draggable': true,\n          'percentPostion': false,\n          'cellAlign': 'left',\n          'wrapAround': true,\n          'lazyLoad': true,\n          'pageDots': false,\n          'autoPlay': true\n        });\n      });\n      $('#modal4').on('shown.bs.modal', function(event) {\n        $('.gallery-four').flickity({\n          'imagesLoaded': true,\n          'draggable': true,\n          'percentPostion': false,\n          'cellAlign': 'left',\n          'wrapAround': true,\n          'lazyLoad': true,\n          'pageDots': false,\n          'autoPlay': true\n        });\n      });\n      var $card = $('.img'),\n        $modal = $('#modal');\n\n      $card.click(this, function() {\n        var $this = $(this),\n          $thisImage = $this.find('img'),\n          // $thisTitle = $this.data('title'),\n          $thisBody = $this.data('body'),\n          $thisDate = $this.data('date');\n\n        // $modal.find('.header h2').html($thisTitle);\n        $modal.find('.meta').html($thisDate);\n        $modal.find('.body').html($thisBody);\n        $modal.find('.image').css('background-image', 'url(' + $thisImage[0].src + ')');\n        $modal.modal();\n      })\n    });\n  </script>\n</div>\n"

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/employment',
		template: __webpack_require__(69),
		controller: employmentController,
		controllerAs: 'employmentCtrl'
	};
	
	function employmentController(contentful, $window, $state, $http, $timeout, $scope) {
		var vm = this;
		$window.scrollTo(0, 0);
		vm.showForm = true;
		vm.showConfirmationLayer = false;
		vm.showErrorLayer = false;
	
		vm.submitForm = function (formValid) {
			if (formValid) {
				var postUrl = "/api/contact";
				var reason = "test";
				var obj = {
					fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
					fromEmail: vm.contactForm.email,
					toName: 'Guest Services',
					toEmail: 'guestservices@parkcitypeaks.com',
					subject: 'Employment Inquiry',
					emailBody: vm.contactForm.comments,
					emailAttachments: vm.contactForm.cv + ' ' + vm.contactForm.resume
				};
				$http.post(postUrl, obj).then(function success(res) {
					console.log('success: ', res);
					vm.showForm = false;
					vm.showConfirmationLayer = true;
					// $timeout(function() {
					// 	vm.contactForm = '';
					// 	vm.showConfirmationLayer = false;
					// }, 10000);
				}, function error(err) {
					console.log('error: ', err);
					window.glob = err;
					vm.showErrorLayer = true;
					$timeout(function () {
						vm.contactForm = '';
						vm.showErrorLayer = false;
					}, 5000);
				});
			} else {
				console.log("form invalid");
			}
		};
	}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "\n<div id=\"contactPage\">\n  <script type='text/javascript'>\n    //smooth scroll on homepage; move to project JS file\n    $('.tri-up a').click(() => {\n      $('html, body').animate({\n        scrollTop: window.pageYOffset + $(window).height()\n      }, 300);\n      return false;\n    });\n\n    function myFunction(x) {\n      x.classList.toggle(\"change\");\n    }\n  </script>\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"img/employment-assets/HeroImage.jpg\" alt=\"Contact\">\n        <img class=\"desktop-hide\" src=\"img/employment-assets/HeroImage.jpg\" alt=\"Contact\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>Employment</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n             <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n           </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a aria-label=\"homepage\" href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n  <div class=\"container-fluid\">\n    <div class=\"emailConfirmationLayer\" data-ng-show=\"employmentCtrl.showForm\">\n      <div class=\"employment-greeting col-12 pad-top-10\">\n        <h2>HI THERE!</h2>\n        <p>We are always looking for incredible talent. Please submit the form below and someone from our team will be in touch.</p>\n      </div>\n        <form id=\"contactform\" class=\"well form-horizontal\" name=\"userForm\" data-ng-submit=\"employmentCtrl.submitForm(userForm.$valid)\">\n\n          <!-- Form group for name -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <input aria-label=\"inputfirstname\" name=\"inputfirstname\" data-ng-model=\"employmentCtrl.contactForm.firstName\" placeholder=\"FIRST NAME\" class=\"form-control\" type=\"text\" maxlength=\"80\" required>\n                <input aria-label=\"inputlastname\" name=\"inputlastname\" data-ng-model=\"employmentCtrl.contactForm.lastName\" placeholder=\"LAST NAME\" class=\"form-control\" type=\"text\" maxlength=\"80\" required>\n              </div>\n            </div>\n          </div>\n\n          <!-- Form group for email + phone -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <input aria-label=\"inputemail\" name=\"inputemail\" data-ng-model=\"employmentCtrl.contactForm.email\" placeholder=\"EMAIL\" class=\"form-control\" type=\"email\" maxlength=\"80\" required>\n              </div>\n            </div>\n          </div>\n\n          <!-- Form group for comment -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <textarea aria-label=\"inputcomment\" name=\"inputcomment\" data-ng-model=\"employmentCtrl.contactForm.comments\" placeholder=\"COMMENTS\" class=\"form-control\" maxlength=\"1000\" required></textarea>\n              </div>\n            </div>\n          </div>\n\n<!--\n          <div class=\"form-group upload\">\n            <div class=\"col-md-4 inputGroupContainer\">\n              <label class=\"control-label input-group\">Upload Cover Letter</label>\n              <div class=\"input-group\">\n                <input aria-label=\"inputcoverletter\" name=\"inputcoverletter\" data-ng-model=\"employmentCtrl.contactForm.cv\" placeholder=\"Upload Cover Letter\" class=\"form-control\" type=\"file\" style=\"background: transparent;\" >\n              </div>\n            </div>\n          </div> -->\n<!--\n          <div class=\"form-group upload\">\n            <div class=\"col-md-4 inputGroupContainer\">\n              <label class=\"control-label input-group\">Upload Resume</label>\n              <div class=\"input-group\">\n                <input aria-label=\"inputresume\" name=\"inputresume\" data-ng-model=\"employmentCtrl.employmentForm.resume\"  placeholder=\"Upload Resume\" class=\"form-control\" type=\"file\" style=\"background: transparent;\" >\n              </div>\n            </div>\n          </div> -->\n\n\n          <!-- Form group for button  -->\n          <div class=\"spacer\"></div>\n          <div class=\"form-group\">\n            <div class=\"col-md-4 inputGroupContainer\">\n              <div class=\"input-group justify-center\">\n                <button aria-label=\"submit\" type=\"submit\" class=\"btn btn-primary\" style=\"font-size:12px;\">SUBMIT</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n      <div class=\"container contactContent\">\n        <div class=\"row\">\n          <div class=\"emailConfirmationLayer\" data-ng-show=\"employmentCtrl.showConfirmationLayer\">\n            <h2 class=\"tk-clarendon-wide\">SUCCESS!</h2>\n            <p class=\"futuraHeavy text-uppercase\">Thanks for your interest in Peaks Hotel. We'll get back to you just as soon as we can.</p>\n            <p>Return to our\n              <a href=\"/\" aria-label=\"homepage\">homepage.</a>\n            </p>\n          </div>\n          <div class=\"emailConfirmationLayer\" data-ng-show=\"employmentCtrl.showErrorLayer\">\n            <h2 class=\"tk-clarendon-wide\">WE'RE SORRY!</h2>\n            <p class=\"futuraHeavy text-uppercase\">An error occurred while trying to deliver your message through the website. You can reach us at <a href=\"mailto:guestservices@parkcitypeaks.com\">guestservices@parkcitypeaks.com</a>.</p>\n            <p>Return to our\n              <a href=\"/\" aria-label=\"homepage\">homepage.</a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n      <div class=\"spacer\"></div>\n</div>\n"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/peaks-picks',
		template: __webpack_require__(71),
		controller: peaksPicksController,
		controllerAs: 'peaksPicksCtrl'
	};
	
	function peaksPicksController($scope, $state, store, $window, contentful, $http) {
		var vm = this;
		$window.scrollTo(0, 0);
	
		$scope.tab = 1;
	
		$scope.setTab = function (newTab) {
			$scope.tab = newTab;
		};
	
		$scope.isSet = function (tabNum) {
			return $scope.tab === tabNum;
		};
		contentful.entries('content_type=longPage&sys.id=6GD94B8cdqWiwM2O0GCa48').then(function (res) {
			//  console.log('picks page contentful data',res);
			$scope.picks = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoPageTitle) {
				document.title = seoData.fields.seoPageTitle;
			}
			if (seoData.fields.seoPageDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoPageDescription;
					}
				}
			}
		});
	}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/javascript\">\n  //smooth scroll on homepage; move to project JS file\n  $(\".tri-up a\").click(() => {\n    $(\"html, body\").animate(\n      {\n        scrollTop: window.pageYOffset + $(window).height(),\n      },\n      300\n    );\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n\n  if (\n    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(\n      navigator.userAgent\n    )\n  ) {\n    $(\".peaks-pickers a\").click(() => {\n      $(\"html, body\").animate(\n        {\n          scrollTop: $(window).height(),\n        },\n        500\n      );\n      return false;\n    });\n\n    function myFunction(x) {\n      x.classList.toggle(\"change\");\n    }\n  }\n</script>\n<div id=\"peaks-picks\">\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img\n          class=\"mobile-hide\"\n          src=\"{{picks.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{picks.fields.bannerImage.fields.title}}\" />\n        <img\n          class=\"desktop-hide\"\n          src=\"{{picks.fields.mobileBannerImage.fields.file.url}}?h=768\"\n          style=\"min-height: 100%\"\n          alt=\"{{picks.fields.mobileBannerImage.fields.title}}\" />\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{picks.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\">\n    <a href=\"/\"\n      ><img\n        src=\"/img/Peaks-Hotel-Logo_wht.svg\"\n        alt=\"Peaks Hotel Park City Logo\"\n    /></a>\n  </div>\n  <div class=\"wrap\">\n    <section class=\"main\">\n      <div class=\"local-spots justify-content-center\">\n        <h3 class=\"bottom-center\">Our favorite local spots</h3>\n      </div>\n      <div class=\"local-spots-button justify-content-center mobile-hide\">\n        <button\n          class=\"navbar-toggler\"\n          type=\"button\"\n          data-toggle=\"collapse\"\n          data-target=\"#collapseExample\"\n          aria-controls=\"collapseExample\"\n          aria-expanded=\"false\"\n          aria-label=\"Toggle Peaks Picks\">\n          <span class=\"icon-bar\"></span>\n          <span class=\"icon-bar\"></span>\n          <span class=\"icon-bar\"></span>\n        </button>\n      </div>\n      <div>\n        <div class=\"d-flex align-items-stretch peaks-pickers\">\n          <ul class=\"nav-pills nav-stacked\">\n            <li\n              ng-repeat=\"section in picks.fields.sections track by $index\"\n              ng-class=\"{ active: isSet($index + 1) }\">\n              <a href ng-click=\"setTab($index + 1)\">\n                <img\n                  class=\"peaks-picks-icon\"\n                  src=\"img/peaks-picks-assets/mountain-icon.png\"\n                  alt=\"icon\" />\n                <span>\n                  <h3 style=\"letter-spacing: 0.4em\">\n                    {{ section.fields.heading }}\n                  </h3>\n                </span>\n                <i\n                  ng-class=\"isSet($index + 1) ? 'fa fa-caret-up' : 'fa fa-caret-down'\"></i>\n              </a>\n            </li>\n            <div\n              ng-repeat=\"section in picks.fields.sections track by $index\"\n              ng-show=\"isSet($index + 1)\"\n              class=\"desktop-hide\">\n              <div class=\"row home-load\">\n                <div\n                  class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n                  <h4 class=\"text-right\">\n                    {{ section.fields.name }}, {{ section.fields.title }}\n                  </h4>\n                  <img\n                    class=\"mx-auto d-block picks\"\n                    src=\"img/Peaks-Badge-icon.svg\"\n                    alt=\"Peaks Picks\" />\n                  <h3>{{ section.fields.heading }}</h3>\n                  <div data-marked=\"section.fields.body\"></div>\n                  <a\n                    ng-if=\"section.fields.ctaButtonLabel\"\n                    class=\"btn btn-secondary\"\n                    href=\"{{ section.fields.ctaButtonLink }}\"\n                    role=\"button\"\n                    >{{ section.fields.ctaButtonLabel }}</a\n                  >\n                </div>\n                <div class=\"col-md-6 order-md-2 mobile-order-1 text-center\">\n                  <img\n                    ng-if=\"section.fields.image.fields.file.url\"\n                    class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n                    src=\"{{ section.fields.image.fields.file.url }}\"\n                    alt=\"{{ section.fields.image.fields.title }}\" />\n                  <img\n                    ng-if=\"!section.fields.image.fields.file.url\"\n                    class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n                    src=\"http://thesweetpeople.com/wp/wp-content/uploads/2015/08/person_placeholder.png\" />\n                </div>\n\n                <div\n                  class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n                  style=\"background: url({{section.fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n              </div>\n            </div>\n          </ul>\n        </div>\n      </div>\n    </section>\n    <aside class=\"mobile-hide\">\n      <div ng-repeat=\"section in picks.fields.sections track by $index\" ng-show=\"isSet($index + 1)\">\n        <div class=\"row home-load\">\n          <!-- Section Content -->\n          <div class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n            <h4 class=\"text-right\">\n              {{ section.fields.name }}, {{ section.fields.title }}\n            </h4>\n            <img\n              class=\"mx-auto d-block picks\"\n              src=\"img/Peaks-Badge-icon.svg\"\n              alt=\"Peaks Picks\" />\n            <h3>{{ section.fields.heading }}</h3>\n            <div data-marked=\"section.fields.body\"></div>\n            <a\n              ng-if=\"section.fields.ctaButtonLabel\"\n              class=\"btn btn-secondary\"\n              href=\"{{ section.fields.ctaButtonLink }}\"\n              role=\"button\"\n              >{{ section.fields.ctaButtonLabel }}</a>\n          </div>\n    \n          <!-- Section Image -->\n          <div class=\"col-md-6 order-md-2 mobile-order-1 bg-type-picks text-center\">\n            <img\n              ng-if=\"section.fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"{{ section.fields.image.fields.file.url }}\"\n              alt=\"{{ section.fields.image.fields.title }}\" />\n            <img\n              ng-if=\"!section.fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"http://thesweetpeople.com/wp/wp-content/uploads/2015/08/person_placeholder.png\" />\n          </div>\n    \n          <!-- Section Background -->\n          <div\n          class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n          style=\"background: url({{section.fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n      </div>\n        </div>\n      </div>\n    </aside>\n    \n    <aside class=\"mobile-hide\">\n      <div ng-show=\"isSet(1)\">\n        <div class=\"row home-load\">\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n            <h4 class=\"text-right\">\n              {{picks.fields.sections[0].fields.name}},\n              {{picks.fields.sections[0].fields.title}}\n            </h4>\n            <img\n              class=\"mx-auto d-block picks\"\n              src=\"img/Peaks-Badge-icon.svg\"\n              alt=\"Peaks Picks\" />\n            <h3>{{picks.fields.sections[0].fields.heading}}</h3>\n            <div data-marked=\"picks.fields.sections[0].fields.body\"></div>\n            <a\n              ng-if=\"picks.fields.sections[0].fields.ctaButtonLabel\"\n              class=\"btn btn-secondary\"\n              href=\"{{picks.fields.sections[0].fields.ctaButtonLink}}\"\n              role=\"button\"\n              >{{picks.fields.sections[0].fields.ctaButtonLabel}}</a\n            >\n          </div>\n          <div\n            class=\"col-md-6 order-md-2 mobile-order-1 bg-type-picks text-center\">\n            <img\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"{{picks.fields.sections[0].fields.image.fields.file.url}}\"\n              alt=\"{{picks.fields.sections[0].fields.image.fields.title}}\" />\n          </div>\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n            style=\"background: url({{picks.fields.sections[0].fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n        </div>\n      </div>\n      <div ng-show=\"isSet(2)\">\n        <div class=\"row home-load\">\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n            <h4 class=\"text-right\">\n              {{picks.fields.sections[1].fields.name}},\n              {{picks.fields.sections[1].fields.title}}\n            </h4>\n            <img\n              class=\"mx-auto d-block picks\"\n              src=\"img/Peaks-Badge-icon.svg\"\n              alt=\"Peaks Picks\" />\n            <h3>{{picks.fields.sections[1].fields.heading}}</h3>\n            <div data-marked=\"picks.fields.sections[1].fields.body\"></div>\n            <a\n              ng-if=\"picks.fields.sections[1].fields.ctaButtonLabel\"\n              class=\"btn btn-secondary\"\n              href=\"{{picks.fields.sections[1].fields.ctaButtonLink}}\"\n              role=\"button\"\n              >{{picks.fields.sections[1].fields.ctaButtonLabel}}</a\n            >\n          </div>\n          <div\n            class=\"col-md-6 order-md-2 mobile-order-1 bg-type-picks text-center\">\n            <img\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"{{picks.fields.sections[1].fields.image.fields.file.url}}\"\n              alt=\"{{picks.fields.sections[1].fields.image.fields.title}}\" />\n          </div>\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n            style=\"background: url({{picks.fields.sections[1].fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n        </div>\n      </div>\n      <div ng-show=\"isSet(3)\">\n        <div class=\"row home-load\">\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n            <h4 class=\"text-right\">\n              {{picks.fields.sections[2].fields.name}},\n              {{picks.fields.sections[2].fields.title}}\n            </h4>\n            <img\n              class=\"mx-auto d-block picks\"\n              src=\"img/Peaks-Badge-icon.svg\"\n              alt=\"Peaks Picks\" />\n            <h3>{{picks.fields.sections[2].fields.heading}}</h3>\n            <div data-marked=\"picks.fields.sections[2].fields.body\"></div>\n            <a\n              ng-if=\"picks.fields.sections[2].fields.ctaButtonLabel\"\n              class=\"btn btn-secondary\"\n              href=\"{{picks.fields.sections[2].fields.ctaButtonLink}}\"\n              role=\"button\"\n              >{{picks.fields.sections[2].fields.ctaButtonLabel}}</a\n            >\n          </div>\n          <div\n            class=\"col-md-6 order-md-2 mobile-order-1 bg-type-picks text-center\">\n            <img\n              ng-if=\"picks.fields.sections[2].fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"{{picks.fields.sections[2].fields.image.fields.file.url}}\"\n              alt=\"{{picks.fields.sections[2].fields.image.fields.title}}\" />\n            <img\n              ng-if=\"!picks.fields.sections[2].fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"http://thesweetpeople.com/wp/wp-content/uploads/2015/08/person_placeholder.png\" />\n          </div>\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n            style=\"background: url({{picks.fields.sections[2].fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n        </div>\n      </div>\n\n      <div ng-show=\"isSet(4)\">\n        <div class=\"row home-load\">\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-type-home text-center\">\n            <h4 class=\"text-right\">\n              {{picks.fields.sections[3].fields.name}},\n              {{picks.fields.sections[3].fields.title}}\n            </h4>\n            <img\n              class=\"mx-auto d-block picks\"\n              src=\"img/Peaks-Badge-icon.svg\"\n              alt=\"Peaks Picks\" />\n            <h3>{{picks.fields.sections[3].fields.heading}}</h3>\n            <div data-marked=\"picks.fields.sections[3].fields.body\"></div>\n            <a\n              ng-if=\"picks.fields.sections[3].fields.ctaButtonLabel\"\n              class=\"btn btn-secondary\"\n              href=\"{{picks.fields.sections[3].fields.ctaButtonLink}}\"\n              role=\"button\"\n              >{{picks.fields.sections[3].fields.ctaButtonLabel}}</a\n            >\n          </div>\n          <div\n            class=\"col-md-6 order-md-2 mobile-order-1 bg-type-picks text-center\">\n            <img\n              ng-if=\"picks.fields.sections[3].fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"{{picks.fields.sections[3].fields.image.fields.file.url}}\"\n              alt=\"{{picks.fields.sections[3].fields.image.fields.title}}\" />\n            <img\n              ng-if=\"!picks.fields.sections[3].fields.image.fields.file.url\"\n              class=\"author-avatar rounded-circle mx-auto d-block border-white\"\n              src=\"http://thesweetpeople.com/wp/wp-content/uploads/2015/08/person_placeholder.png\" />\n          </div>\n          <div\n            class=\"col-md-12 order-md-2 mobile-order-1 bg-picks-home home-load lazyload\"\n            style=\"background: url({{picks.fields.sections[3].fields.pickImage.fields.file.url}}) center no-repeat; background-size:cover;\"></div>\n        </div>\n      </div>\n    </aside>\n  </div>\n</div>\n"

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		url: '/contact',
		template: __webpack_require__(73),
		controller: ContactController,
		controllerAs: 'contactCtrl'
	};
	
	function ContactController(contentful, $window, $state, $http, $timeout, $scope) {
		var vm = this;
		$window.scrollTo(0, 0);
		vm.showForm = true;
		vm.showConfirmationLayer = false;
		vm.showErrorLayer = false;
	
		vm.submitForm = function (formValid) {
			if (formValid) {
				var postUrl = "/api/contact";
				var reason = "test";
				var obj = {
					fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
					fromEmail: vm.contactForm.email,
					toName: 'Guest Services',
					toEmail: 'guestservices@parkcitypeaks.com',
					subject: 'Peaks Park City | Contact Form',
					emailBody: vm.contactForm.comments
				};
	
				// FAKE FORM POST FOR DEVELOPMENT
				// console.log('valid, emailing ' + obj.toEmail)
				// vm.showConfirmationLayer = true;
				// $timeout(function(){
				//   vm.contactForm = '';
				//   vm.showConfirmationLayer = false;
				// }, 5000);
	
				$http.post(postUrl, obj).then(function success(res) {
					// console.log('success: ', res);
					vm.showForm = false;
					vm.showConfirmationLayer = true;
					// $timeout(function() {
					// 	vm.contactForm = '';
					// 	vm.showConfirmationLayer = false;
					// }, 10000);
				}, function error(err) {
					// console.log('error: ', err)
					window.glob = err;
					vm.showErrorLayer = true;
					$timeout(function () {
						vm.contactForm = '';
						vm.showErrorLayer = false;
					}, 5000);
				});
			} else {
				// console.log("form invalid");
			}
		};
	
		contentful.entries('content_type=longPage&sys.id=6M2b4SINagSMEiwga0mi4').then(function (res) {
			// console.log('meetings page contentful data',res);
			$scope.contact = res.data.items[0];
			var seoData = res.data.items[0];
			if (seoData.fields.seoPageTitle) {
				document.title = seoData.fields.seoPageTitle;
			}
			if (seoData.fields.seoPageDescription) {
				var meta = document.getElementsByTagName("meta");
				for (var i = 0; i < meta.length; i++) {
					if (meta[i].name.toLowerCase() === "description") {
						meta[i].content = seoData.fields.seoPageDescription;
					}
				}
			}
		});
	}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"contactPage\">\n  <script type='text/javascript'>\n    //smooth scroll on homepage; move to project JS file\n    $('.tri-up a').click(() => {\n      $('html, body').animate({\n        scrollTop: window.pageYOffset + $(window).height()\n      }, 300);\n      return false;\n    });\n\n    function myFunction(x) {\n      x.classList.toggle(\"change\");\n    }\n  </script>\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{contact.fields.bannerImage.fields.file.url}}\" alt=\"{{contact.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{contact.fields.mobileBannerImage.fields.file.url}}?h=768\" alt=\"{{contact.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{contact.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n             <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n           </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\"/></a></div>\n  <div class=\"container-fluid\">\n    <div class=\"emailConfirmationLayer\" data-ng-show=\"contactCtrl.showForm\">\n      <div class=\"employment-greeting col-12 pad-top-10\">\n        <h2>How can we help?</h2>\n        <p>Please submit the form below and someone from our team will be in touch.</p>\n      </div>\n      <div class=\"emailConfirmationLayer\" data-ng-show=\"contactCtrl.showForm\">\n        <form id=contactform class=\"well form-horizontal\" name=\"userForm\" data-ng-submit=\"contactCtrl.submitForm(userForm.$valid)\">\n\n          <!-- Form group for name -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <input aria-label=\"inputfirstname\" name=\"inputfirstname\" data-ng-model=\"contactCtrl.contactForm.firstName\" placeholder=\"FIRST NAME\" class=\"form-control\" type=\"text\" maxlength=\"80\" required>\n                <input aria-label=\"inputlastname\" name=\"inputlastname\" data-ng-model=\"contactCtrl.contactForm.lastName\" placeholder=\"LAST NAME\" class=\"form-control\" type=\"text\" maxlength=\"80\" required>\n              </div>\n            </div>\n          </div>\n\n          <!-- Form group for email + phone -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <input aria-label=\"inputemail\" name=\"inputemail\" data-ng-model=\"contactCtrl.contactForm.email\" placeholder=\"EMAIL\" class=\"form-control\" type=\"email\" maxlength=\"80\" required>\n              </div>\n            </div>\n          </div>\n\n          <!-- Form group for comment -->\n\n          <div class=\"form-group\">\n            <div class=\"col-md-6 inputGroupContainer\">\n              <div class=\"input-group\">\n                <textarea aria-label=\"inputcomment\" name=\"inputcomment\" data-ng-model=\"contactCtrl.contactForm.comments\" placeholder=\"COMMENTS\" class=\"form-control\" maxlength=\"1000\" required></textarea>\n              </div>\n            </div>\n          </div>\n\n\n          <!-- Form group for button  -->\n          <div class=\"spacer\"></div>\n          <div class=\"form-group\">\n            <div class=\"col-md-4 inputGroupContainer\">\n              <div class=\"input-group justify-center\">\n                <button aria-label=\"submit\" type=\"submit\" class=\"btn btn-primary\" style=\"font-size:12px;\">SUBMIT</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"container contactContent\">\n      <div class=\"row\">\n        <div class=\"emailConfirmationLayer\" data-ng-show=\"contactCtrl.showConfirmationLayer\">\n          <h2 class=\"tk-clarendon-wide\">SUCCESS!</h2>\n          <p class=\"futuraHeavy text-uppercase\">Thanks for your interest in Peaks Hotel. We'll get back to you just as soon as we can.</p>\n          <p>Return to our\n            <a aria-label=\"homepage\" href=\"/\">homepage.</a>\n          </p>\n        </div>\n        <div class=\"emailConfirmationLayer\" data-ng-show=\"contactCtrl.showErrorLayer\">\n          <h2 class=\"tk-clarendon-wide\">WE'RE SORRY!</h2>\n          <p class=\"futuraHeavy text-uppercase\">An error occurred while trying to deliver your message through the website. You can reach us at <a href=\"mailto:guestservices@parkcitypeaks.com\">guestservices@parkcitypeaks.com</a>.</p>\n          <p>Return to our\n            <a aria-label=\"homepage\" href=\"/\">homepage.</a>\n          </p>\n        </div>\n      </div>\n    </div>\n      <div class=\"spacer\"></div>\n  </div>\n</div>\n"

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  url: '/offers',
	  template: __webpack_require__(75),
	  controller: OffersController,
	  controllerAs: 'offersCtrl'
	};
	
	function OffersController($scope, $state, store, $window, contentful, $http, Socialshare, $document) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  contentful.entries('content_type=offersPage&sys.id=4mcTySV7wbKBnYIP95OH48').then(function (res) {
	    // console.log('meetings page contentful data',res);
	    $scope.offers = res.data.items[0];
	    console.log('offers page', $scope.offers);
	    var seoData = res.data.items[0];
	    if (seoData.fields.seoPageTitle) {
	      document.title = seoData.fields.seoPageTitle;
	    }
	    if (seoData.fields.seoPageDescription) {
	      var meta = document.getElementsByTagName("meta");
	      for (var i = 0; i < meta.length; i++) {
	        if (meta[i].name.toLowerCase() === "description") {
	          meta[i].content = seoData.fields.seoPageDescription;
	        }
	      }
	    }
	  });
	  setTimeout(function () {
	    var elem = document.querySelector('.carousel');
	    var flkty = new Flickity(elem, {
	      imagesLoaded: true,
	      draggable: false,
	      percentPostion: false,
	      cellAlign: 'center',
	      wrapAround: true,
	      lazyLoad: true,
	      pageDots: false,
	      autoPlay: true
	    });
	  }, 1000);
	
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ['$sce'];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  $window.sr = ScrollReveal({
	    reset: false
	  });
	  sr.reveal('.home-load', {
	    duration: 1000
	  });
	  sr.reveal('#cafe', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#pool', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	  sr.reveal('#king-suite', {
	    distance: 0,
	    duration: 1000,
	    scale: 1.5
	  }, 500);
	
	  $('.show-blue').on('click', function () {
	    var contentID = $(this).data('target');
	    $('#' + contentID).toggleClass('reveal');
	    $(this).fadeOut(800, 'linear');
	  });
	
	  $('.show-white').on('click', function () {
	    var contentID = $(this).data('target');
	    $('#' + contentID).toggleClass('reveal');
	    $(this).fadeOut(800, 'linear');
	  });
	
	  // Close overlay when the outside of menu is clicked
	  $('.hide-blue').on('click', function () {
	    $('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
	      $('.overlay.bg-blue').removeClass('conceal');
	      $('.overlay.bg-blue').removeClass('reveal');
	      $(this).dequeue();
	      $(".show-blue").fadeIn(800, 'linear');
	    });
	  });
	  $('.hide-white').on('click', function () {
	    $('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
	      $('.overlay.bg-white').removeClass('conceal');
	      $('.overlay.bg-white').removeClass('reveal');
	      $(this).dequeue();
	      $(".show-white").fadeIn(800, 'linear');
	    });
	  });
	  vm.socialShare = function (share) {
	    if (share === 'facebook') {
	      Socialshare.share({
	        'provider': 'facebook',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareQuote': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'twitter') {
	      Socialshare.share({
	        'provider': 'twitter',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareText': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'pinterest') {
	      Socialshare.share({
	        'provider': 'pinterest',
	        'attrs': {
	          'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	          'socialshareText': 'Peaks Hotel | Rooms',
	          'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	          'socialsharePopupHeight': '400',
	          'socialsharePopupWidth': '400'
	        }
	      });
	    } else if (share === 'email') {
	      Socialshare.share({
	        'provider': 'email',
	        'attrs': {
	          'socialshare-subject': 'Peaks Hotel | Rooms',
	          'socialshare-body': 'Take a look at the Peaks Hotel!'
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  // smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div>\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img class=\"mobile-hide\" src=\"{{offers.fields.bannerImage.fields.file.url}}\"\n          alt=\"{{offers.fields.bannerImage.fields.title}}\">\n        <img class=\"desktop-hide\" src=\"{{offers.fields.mobileBannerImage.fields.file.url}}?h=768\"\n          alt=\"{{offers.fields.mobileBannerImage.fields.title}}\">\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{offers.fields.headline}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div id=\"jump1\" class=\"main\">\n    <div id=\"offersHeadline\" class=\"d-flex justify-content-center align-items-center pt-5\">\n      <h1 class=\"mb-0\">{{offers.fields.headline}}</h1>\n    </div>\n    <div id=\"offers\" class=\"container pb-5\">\n      <div ng-repeat=\"offer in offers.fields.offers\" class=\"row mt-5\">\n        <div class=\"col-12 col-md-5 mt-0 mb-4 mb-md-0\">\n          <img src=\"{{offer.fields.image.fields.file.url}}?w=500\" alt=\"\" {{offers.fields.image.fields.title}}\n            class=\"img-fluid img-cover\">\n        </div>\n        <div id=\"flex\" class=\"col-12 col-md-7 mt-0 text-center\">\n          <h2>{{offer.fields.title}}</h2>\n          <div data-marked='offer.fields.shortDescription'></div>\n          <a class=\"btn btn-secondary\" href=\"/offer/{{offer.fields.slug}}\">Learn More</a>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n</div>"

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  url: '/offer/:slug',
	  template: __webpack_require__(77),
	  controller: OffersDetailController,
	  controllerAs: 'offersDetailCtrl',
	  params: {
	    slug: null
	  }
	};
	
	function OffersDetailController($scope, $state, store, $window, contentful, $http, Socialshare, $document, $timeout) {
	  var vm = this;
	  $window.scrollTo(0, 0);
	  $scope.page = 'offer';
	
	  console.log('slug', $state.params.slug);
	  if ($state.params.slug) {
	    var queryString = "content_type=offer&fields.slug=" + $state.params.slug;
	    contentful.entries(queryString).then(function (res) {
	      $scope.offer = res.data.items[0];
	      console.log('offer', $scope.offer);
	      var seoData = res.data.items[0];
	      if (seoData.fields.seoPageTitle) {
	        document.title = seoData.fields.seoPageTitle;
	      }
	      if (seoData.fields.seoPageDescription) {
	        var meta = document.getElementsByTagName("meta");
	        for (var i = 0; i < meta.length; i++) {
	          if (meta[i].name.toLowerCase() === "description") {
	            meta[i].content = seoData.fields.seoPageDescription;
	          }
	        }
	      }
	    });
	  }
	  $timeout(function () {}, 500);
	
	  vm.trustUrl = "trustUrl";
	
	  trustUrl.$inject = ['$sce'];
	
	  function trustUrl($sce) {
	    return function (mediaUrl) {
	      return $sce.trustAsResourceUrl(mediaUrl);
	    };
	  }
	
	  // vm.socialShare = function (share) {
	  //   if (share === 'facebook') {
	  //     Socialshare.share({
	  //       'provider': 'facebook',
	  //       'attrs': {
	  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	  //         'socialshareQuote': 'Peaks Hotel | Rooms',
	  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	  //         'socialsharePopupHeight': '400',
	  //         'socialsharePopupWidth': '400'
	  //       }
	  //     });
	  //   } else if (share === 'twitter') {
	  //     Socialshare.share({
	  //       'provider': 'twitter',
	  //       'attrs': {
	  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	  //         'socialshareText': 'Peaks Hotel | Rooms',
	  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	  //         'socialsharePopupHeight': '400',
	  //         'socialsharePopupWidth': '400'
	  //       }
	  //     });
	  //   } else if (share === 'pinterest') {
	  //     Socialshare.share({
	  //       'provider': 'pinterest',
	  //       'attrs': {
	  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
	  //         'socialshareText': 'Peaks Hotel | Rooms',
	  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
	  //         'socialsharePopupHeight': '400',
	  //         'socialsharePopupWidth': '400'
	  //       }
	  //     });
	  //   } else if (share === 'email') {
	  //     Socialshare.share({
	  //       'provider': 'email',
	  //       'attrs': {
	  //         'socialshare-subject': 'Peaks Hotel | Rooms',
	  //         'socialshare-body': 'Take a look at the Peaks Hotel!'
	  //       }
	  //     });
	  //   }
	  // }
	}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = "<script type='text/javascript'>\n  // smooth scroll on homepage; move to project JS file\n  $('.tri-up a').click(() => {\n    $('html, body').animate({\n      scrollTop: window.pageYOffset + $(window).height()\n    }, 300);\n    return false;\n  });\n\n  function myFunction(x) {\n    x.classList.toggle(\"change\");\n  }\n</script>\n\n<div>\n  <div class=\"banner\">\n    <div class=\"banner-inner\">\n      <div class=\"banner-item\">\n        <img src=\"{{offer.fields.image.fields.file.url}}\" alt=\"{{offer.fields.image.fields.title}}\">\n\n        <div class=\"container\">\n          <div class=\"banner-caption d-md-block text-center\">\n            <h1>{{offer.fields.title}}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"ribbon\">\n    <div class=\"tri-up\">\n      <a aria-label=\"scroll down on click\" href=\"#jump1\">\n        <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"logo\"><a href=\"/\"><img src=\"/img/Peaks-Hotel-Logo_wht.svg\" alt=\"Peaks Hotel Park City Logo\" /></a></div>\n\n  <div id=\"jump1\" class=\"main\">\n    <div id=\"offersHeadline\" class=\"d-flex justify-content-center align-items-center pt-5\">\n      <h1 class=\"mb-0\">{{offer.fields.title}}</h1>\n    </div>\n    <div id=\"offers\" class=\"container\">\n      <div class=\"row mt-5\">\n        <div class=\"col-12 col-md-8 mt-0 mb-5\">\n\n          <div data-marked='offer.fields.details'></div>\n          <div class=\"text-center\">\n            <a class=\"btn btn-secondary\" href=\"{{offer.fields.buttonLink}}\">{{offer.fields.buttonLabel}}</a>\n\n          </div>\n        </div>\n        <div class=\"col-12 col-md-8 text-left\">\n\n          <div data-marked='offer.fields.terms'></div>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n</div>"

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    template: __webpack_require__(79),
	    controller: controller
	  };
	};
	
	function controller($scope, $state, store, $window, contentful, $timeout) {
	  var vm = this;
	  if (window.location.hash && $(window.location.hash).length) {
	    $(window.location.hash).modal('show');
	  }
	
	  contentful.entries('content_type=footer').then(function (res) {
	    $scope.footer = res.data.items[0];
	  });
	}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"footer\">\n  <!-- Modal -->\n  <div\n    class=\"modal fade\"\n    id=\"formModal\"\n    tabindex=\"-1\"\n    aria-labelledby=\"formModalLabel\"\n    aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <!-- <h5 class=\"modal-title\" id=\"formModalLabel\">Subscribe to our newsletter</h5> -->\n          <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\">\n            <span aria-hidden=\"true\">&times;</span>\n          </button>\n        </div>\n        <div class=\"modal-body\">\n          <div data-marked=\"footer.fields.revinateForm\"></div>\n          <!-- <form id=\"revinate_contact_api_form\" token=\"8fff7145-9326-47a3-b541-8498d6ce436d\"\n            onsubmit=\"revFormOnSubmit(); event.preventDefault();\">\n            <fieldset>\n              <legend> Revinate Contact Sign Up Form Sample.</legend>\n              <div>\n                <label>First/Last Name</label>\n                <input type=\"text\" name=\"firstName\" />\n                <input type=\"text\" name=\"lastName\" />\n              </div>\n              <div>\n                <label>Email</label>\n                <input class=\"long\" type=\"email\" name=\"email\" required />\n              </div>\n              <button type=\"submit\">Submit!</button>\n          </form> -->\n        </div>\n        <div class=\"modal-footer\">\n          <!-- <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button> -->\n        </div>\n      </div>\n    </div>\n  </div>\n  <footer>\n    <div class=\"ribbon text-center\">\n      <div class=\"container row\">\n        <div class=\"col-3\">\n          <a\n            aria-label=\"{{footer.fields.link1Label}}\"\n            href=\"{{footer.fields.link1Url}}\"\n            >{{footer.fields.link1Label}}</a\n          >\n        </div>\n        <div class=\"col-3\">\n          <p class=\"social\">\n            <a\n              aria-label=\"Go to our Facebook Page\"\n              href=\"https://www.facebook.com/ParkCityPeaks\"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\">\n              <i class=\"fab fa-2x fa-facebook\" aria-hidden=\"true\"></i\n            ></a>\n            <a\n              aria-label=\"Go to our Instagram Page\"\n              href=\"https://www.instagram.com/parkcitypeaks\"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\">\n              <i class=\"fab fa-2x fa-instagram\" aria-hidden=\"true\"></i\n            ></a>\n          </p>\n        </div>\n\n        <div class=\"col-6\">\n          <div id=\"newForm\">\n            <div\n              data-marked=\"footer.fields.newsletterText\"\n              class=\"pr-3 mb-3 mb-lg-0\"></div>\n            <button\n              type=\"button\"\n              class=\"btn btn-primary\"\n              data-toggle=\"modal\"\n              data-target=\"#formModal\">\n              {{footer.fields.newsletterButtonLabel}}\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row no-gutters\">\n      <div\n        class=\"col-md-6 order-md-1 mobile-order-2 bg-footer-left text-white text-center\">\n        <div class=\"d-flex flex-wrap\">\n          <div class=\"col-12 col-md-6\">\n            <img\n              ng-if=\"footer.fields.awardImage\"\n              id=\"awardImage\"\n              src=\"{{footer.fields.awardImage.fields.file.url}}\"\n              alt=\"{{footer.fields.awardImage.fields.title}}\"\n              class=\"img-fluid\" />\n          </div>\n          <div class=\"col-12 col-md-6\">\n            <h4 class=\"text-right\">\n              <a\n                aria-label=\"see our location in google maps\"\n                href=\"https://maps.google.com?saddr=Current+Location&daddr=Park+City+Peaks+Hotel,+2346+Park+Avenue,+Park+City,+Utah\"\n                target=\"_blank\"\n                >Quick Directions</a\n              >\n            </h4>\n            <p class=\"text-right\">\n              Park City Peaks Hotel<br />\n              {{footer.fields.streetAddress}}, {{footer.fields.cityStateZip}}<br />\n              <a\n                aria-label=\"phone number one\"\n                href=\"tel:{{footer.fields.phoneNumber1}}\"\n                >{{footer.fields.phoneNumber1}}</a\n              >\n              /\n              <a\n                aria-label=\"phone number two\"\n                href=\"tel:{{footer.fields.phoneNumber2}}\"\n                >{{footer.fields.phoneNumber2}}</a\n              >\n            </p>\n            <h4 class=\"text-right\">\n              <a\n                aria-label=\"Go to contact page\"\n                href=\"{{footer.fields.link2Url}}\"\n                >{{footer.fields.link2Label}}</a\n              >\n              |\n              <a\n                aria-label=\"Go to our booking site to reserve a room\"\n                href=\"{{footer.fields.link3Url}}\"\n                >{{footer.fields.link3Label}}</a\n              >\n            </h4>\n          </div>\n        </div>\n        <div>\n          <p class=\"small\">\n            &copy;{{footer.fields.copyrightInfo}} |\n            <a\n              title=\"Go to our employment page\"\n              href=\"{{footer.fields.link4Url}}\"\n              >{{footer.fields.link4Label}}</a\n            >\n            |\n            <a\n              aria-label=\"Things to do in Park City website\"\n              href=\"{{footer.fields.link5Url}}\"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n              >{{footer.fields.link5Label}}</a\n            >\n          </p>\n          <p class=\"small\">\n            Site By\n            <a\n              aria-label=\"visit Obviouslee Marketing's website\"\n              href=\"https://www.obviouslee.com\"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n              >Obviouslee Marketing</a\n            >\n          </p>\n        </div>\n      </div>\n      <div class=\"col-md-6 order-md-2 mobile-order-1 bg-footer-right\">\n        <div class=\"map-canvas\"></div>\n      </div>\n    </div>\n  </footer>\n</div>\n"

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function () {
	  return {
	    restrict: "EA",
	    replace: true,
	    template: __webpack_require__(81),
	    controller: controller
	  };
	};
	
	function controller($scope, $state, store, $window, contentful) {
	  contentful.entries("content_type=specialsPage").then(function (res) {
	    // console.log('specials', res);
	    $scope.specials = res.data.items[0];
	  });
	  contentful.entries("content_type=popUp").then(function (res) {
	    $scope.pop = res.data.items[0];
	    console.log("Pop", $scope.pop);
	  });
	}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"header\">\n  <nav class=\"navbar fixed-top\" id=\"nav\">\n    <div class=\"collapse navbar-collapse bg-primary\" id=\"navbarToggleNav\">\n      <div class=\"p-4 d-flex align-items-center vh close-this\" onclick=\"toggleOverlay()\">\n        <ul class=\"navbar-nav mx-auto text-center\">\n          <li class=\"nav-item active\">\n            <h1><a class=\"nav-link\" href=\"/\">Home<span class=\"sr-only\">(current)</span></a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/rooms\">Rooms</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/amenities\">Amenities</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/galleries\">Galleries</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/activities\">Activities</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/meetings-and-events\">Meetings + Events</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/versante\">Dining</a></h1>\n          </li>\n          <!-- <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/versante/menu\">Menu</a></h1>\n          </li> -->\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/weddings\">Weddings</a></h1>\n          </li>\n          <li class=\"nav-item\">\n            <h1><a class=\"nav-link\" href=\"/offers\">Offers</a></h1>\n          </li>\n          <li class=\"nav-item desktop-hide\">\n            <hr>\n          </li>\n          <li class=\"nav-item small desktop-hide\">\n            <a class=\"nav-link\" href=\"/peaks-picks\">Peaks Picks</a>\n          </li>\n          <li class=\"nav-item small desktop-hide\">\n            <a class=\"nav-link\" href=\"/contact\">Contact</a>\n          </li>\n          <li class=\"nav-item small desktop-hide\">\n            <a class=\"nav-link\" href=\"/employment\">Employment</a>\n          </li>\n          <li class=\"nav-item small desktop-hide\">\n            <a class=\"nav-link\" href=\"https://www.visitparkcity.com/things-to-do/\" target=\"_blank\"\n              rel=\"noopener noreferrer\">Visit Park City</a>\n          </li>\n          <li class=\"mobile-hide\">\n            <button class=\"nav-toggler collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarToggleNav\"\n              aria-controls=\"navbarToggleNav\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">&times;</button>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <button onclick=\"toggleOverlay()\" id=\"nav-button\" class=\"nav-main navbar-toggler collapsed\" type=\"button\"\n      data-toggle=\"collapse\" data-target=\"#navbarToggleNav\" aria-controls=\"navbarToggleNav\" aria-expanded=\"false\"\n      aria-label=\"Toggle navigation\" onClick>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n    </button>\n    <div class=\"bookingbar mobile-hide\">\n      <div class=\"form-group row\">\n        <div class=\"date-picker\">\n          <input class=\"form-control\" aria-label=\"check-in\" id=\"check-in\" size=\"15\" placeholder=\"Check-In\"\n            title=\"check-in\">\n        </div>\n        <div class=\"date-picker\">\n          <input class=\"form-control\" aria-label=\"check-out\" id=\"check-out\" size=\"15\" placeholder=\"Check-Out\"\n            title=\"check-out\">\n        </div>\n        <div class=\"rooms-select\">\n          <select id=\"rooms\" aria-label=\"number of rooms\" class=\"form-control\" title=\"number of rooms\">\n            <option selected value=\"\"># of Rooms</option>\n            <option value=\"1\">1</option>\n            <option value=\"2\">2</option>\n            <option value=\"3\">3</option>\n          </select>\n        </div>\n        <div class=\"go\">\n          <button id=\"go\" type=\"submit\" class=\"btn btn-primary\">Find Rooms</button>\n        </div>\n        <div class=\"text-center\">\n          <a aria-label=\"telephone number\" href=\"tel:800.649.5012\">\n            <p>800.649.5012</p>\n          </a>\n        </div>\n      </div>\n    </div>\n    <a href=\"/offers\" class=\"specials navbar-toggler mobile-hide\" aria-label=\"ToggleSpecials\">View\n      Specials</a>\n\n  </nav>\n\n  <nav class=\"navbar\" id=\"nav\">\n    <div class=\"collapse navbar-collapse specials-list bg-primary close-this\" id=\"ToggleSpecials\"\n      onclick=\"toggleOverlay()\">\n      <div id=\"ToggleSpecials\" class=\"overlay-pop-s\">\n        <div class=\"overlay-pop-bg-s\"></div>\n        <div class=\"popup\">\n          <div class=\"d-flex align-items-center justify-content-center pt-4 p-md-4\">\n            <ul class=\"text-center\">\n              <li ng-repeat=\"deal in specials.fields.specials\" class=\"text-white large\">\n                <h2 ng-if=\"deal.fields.specialTitle\">{{deal.fields.specialTitle}}</h2>\n                <!-- <h4>{{deal.fields.specialBody}}</h4> -->\n                <div ng-if=\"deal.fields.specialBody\" data-marked='deal.fields.specialBody' id=\"specialsBody\"></div>\n                <h4 ng-if=\"deal.fields.specialLink\"><a class=\"btn btn-primary\"\n                    aria-label=\"{{deal.fields.specialCtaLabel}}\" href=\"{{deal.fields.specialLink}}\"\n                    target=\"_blank\">{{deal.fields.specialCtaLabel}}</a></h4>\n              </li>\n              <li>\n                <button class=\"specials toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#ToggleSpecials\"\n                  aria-controls=\"ToggleSpecials\" aria-expanded=\"false\" aria-label=\"Toggle specials\">&times;</button>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </nav>\n\n\n  <div ng-if=\"pop.fields.popUpActive === true\" id=\"popup1\" class=\"overlay-pop\">\n    <div class=\"overlay-pop-bg\"></div>\n    <div class=\"popup\">\n      <a class=\"close close-pop\" href=\"#\">&times;</a>\n      <div class=\"d-flex align-items-center justify-content-center pt-4 p-md-4\">\n        <ul class=\"text-center\">\n          <li class=\"large pb-1\">\n            <h2>{{pop.fields.title}}</h2>\n            <div data-marked='pop.fields.body'></div>\n            <div ng-if=\"pop.fields.ctaButtonLabel\" class=\"accordion\" id=\"accordionExample\">\n              <h4>\n                <button class=\"btn btn-primary collapsed\" type=\"button\" data-toggle=\"collapse\"\n                  data-target=\"#collapseTwo\" aria-expanded=\"false\" aria-controls=\"collapseTwo\">\n                  {{pop.fields.ctaButtonLabel}}\n                </button>\n              </h4>\n\n              <div class=\"card\">\n                <div id=\"collapseTwo\" class=\"collapse\" aria-labelledby=\"headingTwo\" data-parent=\"#accordionExample\">\n                  <div class=\"card-body\">\n                    <div data-marked='pop.fields.policy'></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </li>\n          <hr ng-if=\"pop.fields.special\">\n          <li ng-if=\"pop.fields.special\" class=\"large\">\n            <h2>{{pop.fields.special.fields.specialTitle}}</h2>\n            <div data-marked='pop.fields.special.fields.specialBody'></div>\n            <h4><a class=\"btn btn-primary\" aria-label=\"{{pop.fields.special.fields.specialCtaLabel}}\"\n                href=\"{{pop.fields.special.fields.specialLink}}\"\n                target=\"_blank\">{{pop.fields.special.fields.specialCtaLabel}}</a></h4>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n\n\n\n  <nav class=\"container navbar desktop-hide\" id=\"mobile\">\n    <button class=\"navbar-toggler mobile-specials \">Specials</button>\n    <button onclick=\"toggleOverlay()\" class=\"navbar-toggler mobile-booking collapsed\" type=\"button\"\n      data-toggle=\"collapse\" data-target=\"#bookingform\" aria-controls=\"bookingform\" aria-expanded=\"false\"\n      aria-label=\"Toggle navigation\">Reservations</button>\n    <a href=\"tel:8006495012\" class=\"btn btn-link mobile-call\" type=\"button\" aria-label=\"mobile call\"><i\n        class=\"fa fa-2x fa-phone\" aria-hidden=\"true\"></i></a>\n    <div class=\"collapse desktop-hide\" id=\"bookingform\" style=\"transition: 500ms ease-out;\">\n      <div class=\"bookingbar desktop-hide\">\n        <div class=\"form-group row desktop-hide\">\n          <div class=\"desktop-hide\">\n            <img src=\"/img/Peaks-Hotel-Logo_blu.svg\" alt=\"Peaks Hotel Park City Logo\" />\n            <h3 class=\"text-center\">Make a Reservation</h3>\n          </div>\n          <div class=\"date-picker\">\n            <input class=\"form-control\" aria-label=\"check-in-mobile\" id=\"check-in-mobile\" size=\"15\"\n              placeholder=\"Check-In\" readonly>\n          </div>\n          <div class=\"date-picker\">\n            <input class=\"form-control\" aria-label=\"check-out-mobile\" id=\"check-out-mobile\" size=\"15\"\n              placeholder=\"Check-Out\" readonly>\n          </div>\n          <div class=\"rooms-select\">\n            <select id=\"rooms-mobile\" class=\"form-control\">\n              <option aria-label=\"number of rooms\" selected value=\"\"># of Rooms</option>\n              <option value=\"1\">1</option>\n              <option value=\"2\">2</option>\n              <option value=\"3\">3</option>\n            </select>\n          </div>\n          <div class=\"go\">\n            <button id=\"go-mobile\" type=\"submit\" class=\"btn btn-primary\" aria-label=\"find rooms\">Find Rooms</button>\n          </div>\n          <div class=\"text-center desktop-hide\">\n            <a aria-label=\"call us\" href=\"tel:800.649.5012\">\n              <p style=\"margin-top: 1em;\">800.649.5012</p>\n            </a>\n          </div>\n          <button onclick=\"toggleOverlay()\" class=\"specials toggler\" type=\"button\" data-toggle=\"collapse\"\n            data-target=\"#bookingform\" aria-controls=\"ToggleBooking\" aria-expanded=\"true\"\n            aria-label=\"Toggle booking\">&times;</button>\n        </div>\n      </div>\n    </div>\n  </nav>\n</header>\n"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js